export const serviceCentersData = [
  {
    "id": 1,
    "name": "Hi Tech Communication (VISASP3830)",
    "sc_name": "Hi Tech Communication",
    "sc_code": "VISASP3830",
    "address": "Shop No. 4/6/71, 1St Floor Khawaspura, Ayodhya Road, Near Panjab National Bank(Infront Of Uco Bank), Faizabad- 224001",
    "city": "Faizabad",
    "state": "Uttar Pradesh",
    "pincode": "224001",
    "phone": "9918222444",
    "email": "rahullko222@live.com"
  },
  {
    "id": 2,
    "name": "Shiva Tele Care (VISASP3755)",
    "sc_name": "Shiva Tele Care",
    "sc_code": "VISASP3755",
    "address": "522/1/A1/ G.T Road, Serampore,Hooghly,-712201",
    "city": "Shrerampore",
    "state": "West Bengal",
    "pincode": "712201",
    "phone": "7003299304",
    "email": "shivatelecarerealme01@gmail.com"
  },
  {
    "id": 3,
    "name": "Micro World (VISASP4187)",
    "sc_name": "Micro World",
    "sc_code": "VISASP4187",
    "address": "Bandh Para,S.P. College Road,Dumka 814101",
    "city": "Dumka",
    "state": "Jharkhand",
    "pincode": "814101",
    "phone": "7004020112",
    "email": "microworlddumka@gmail.com"
  },
  {
    "id": 4,
    "name": "Sri Balaji Technologies (VISASP3849)",
    "sc_name": "Sri Balaji Technologies",
    "sc_code": "VISASP3849",
    "address": "23B-5-96, EEDARA VARI, STREET, R R PET, ELURU, West Godavari, Andhra Pradesh-534002",
    "city": "Eluru",
    "state": "Andhra Pradesh",
    "pincode": "534002",
    "phone": "7093266678",
    "email": "sribalaji.eluru@gmail.com"
  },
  {
    "id": 5,
    "name": "Z Plus Mobile Gallery (VISASP3850)",
    "sc_name": "Z Plus Mobile Gallery",
    "sc_code": "VISASP3850",
    "address": "Shop No 8 Patel Shopping Center Nr.Shital Circle Near Railway Station, Bharuch-392001",
    "city": "Bharuch",
    "state": "Gujarat",
    "pincode": "392001",
    "phone": "7621995555",
    "email": "yatishmobile@gmail.com"
  },
  {
    "id": 6,
    "name": "VIMAL ELECTRONIC (VISASP4167)",
    "sc_name": "VIMAL ELECTRONIC",
    "sc_code": "VISASP4167",
    "address": "Bluechip Building Near Gangaur Sweets Palace Road, Raigarh, Chhattisgarh -496001",
    "city": "Raigarh",
    "state": "Chhattisgarh",
    "pincode": "496001",
    "phone": "9294690377",
    "email": "mrvimalelectronic@gmail.com"
  },
  {
    "id": 7,
    "name": "Subham Telecom (VISASP4163)",
    "sc_name": "Subham Telecom",
    "sc_code": "VISASP4163",
    "address": "Gateway Plaza, Basant Takees Lane, Shahid Chowk,Katihar-854105",
    "city": "Katihar",
    "state": "Bihar",
    "pincode": "854105",
    "phone": "6452243300",
    "email": "subham.telecomktr@gmaail.com"
  },
  {
    "id": 8,
    "name": "M/S Mobile World (VISASP3872)",
    "sc_name": "M/S Mobile World",
    "sc_code": "VISASP3872",
    "address": "341, 342, Bartand, City Center, Bartand, Dhanbad, Pincode - 826001 Jharkhand,",
    "city": "Dhanbad",
    "state": "Jharkhand",
    "pincode": "826001",
    "phone": "9334098999",
    "email": "servdhanbad@gmail.com"
  },
  {
    "id": 9,
    "name": "LAVANYA ENTERPRISES (VISASP4164)",
    "sc_name": "LAVANYA ENTERPRISES",
    "sc_code": "VISASP4164",
    "address": "LAL Darwaza Near Mega Shop Kadrigate Road Farrukhabad - 209625, City:Farrukhabad, Pincode:209625",
    "city": "Farrukhabad",
    "state": "Uttar Pradesh",
    "pincode": "209625",
    "phone": "9506368207",
    "email": "mithungupta301@gmail.com"
  },
  {
    "id": 10,
    "name": "Laxmi Enterprises (VISASP4171)",
    "sc_name": "Laxmi Enterprises",
    "sc_code": "VISASP4171",
    "address": "Jp Complex, PP Compound, Near Lic Building, Sujata Chowk, Ranchi, Jharkhand 834001",
    "city": "Ranchi",
    "state": "Jharkhand",
    "pincode": "834001",
    "phone": "8789477704",
    "email": "laxmien2025@gmail.com"
  },
  {
    "id": 11,
    "name": "Bright Support (VISASP4169)",
    "sc_name": "Bright Support",
    "sc_code": "VISASP4169",
    "address": "D-24, First Floor, Siddhivinayak Complex, Opp. Sarda Capital, DP Road, Beed,Maharashtra, 431122",
    "city": "Beed",
    "state": "Maharashtra",
    "pincode": "431122",
    "phone": "9225312123",
    "email": "brightsupport11@gmail.com"
  },
  {
    "id": 12,
    "name": "H P TELECOM (VISASP4199)",
    "sc_name": "H P TELECOM",
    "sc_code": "VISASP4199",
    "address": "Shop No.5 , Nr. Akshat Telecom,Ranchodray Complex,opp.Bandhan Bank,Lal Tekri,Bhuj-370001 370001",
    "city": "Bhuj",
    "state": "Gujarat",
    "pincode": "370001",
    "phone": "9725293106",
    "email": "hptelecombhuj@gmail.com"
  },
  {
    "id": 13,
    "name": "GANDHI SALES & SERVICES (VISASP4184)",
    "sc_name": "GANDHI SALES & SERVICES",
    "sc_code": "VISASP4184",
    "address": "F-23, FIRST FLOOR, CHAROTAR COMPLEX, NEAR GANDHI STATUE, OPP. RAILWAY GODI 388001",
    "city": "Anand",
    "state": "Gujarat",
    "pincode": "388001",
    "phone": "9898394055",
    "email": "gandhi_s74@yahoo.com"
  },
  {
    "id": 14,
    "name": "NEW SERVICE (VISASP4181)",
    "sc_name": "NEW SERVICE",
    "sc_code": "VISASP4181",
    "address": "Devi Ganj Road, Nagar Nigam, Complex 1St Floor, ShopNo.09,Ambikapur ,Surguja ,Chhattisgarh -497001,",
    "city": "Ambikapur",
    "state": "Chhattisgarh",
    "pincode": "497001",
    "phone": "9907935855",
    "email": "newserviceambikapur@gmail.com"
  },
  {
    "id": 15,
    "name": "SRI ADITYA COMMUNICATION (VISASP3902)",
    "sc_name": "SRI ADITYA COMMUNICATION",
    "sc_code": "VISASP3902",
    "address": "Near Siddivanayaka Temple Compounder Line, Next To H.P Gas , 1 Flour Hospet-583201",
    "city": "Hospet",
    "state": "Karnataka",
    "pincode": "583201",
    "phone": "9342145089",
    "email": "santhosh.hospet2@gmail.com"
  },
  {
    "id": 16,
    "name": "Raj Communication (VISASP3831)",
    "sc_name": "Raj Communication",
    "sc_code": "VISASP3831",
    "address": "No.6,Ave Maria Complex, Voc Nagar,Thanjavur-613007",
    "city": "Thanjavur",
    "state": "Tamil Nadu",
    "pincode": "613007",
    "phone": "9789407052",
    "email": "rajcommunication192@gmail.com"
  },
  {
    "id": 17,
    "name": "Gospel Telecom (VISASP3846)",
    "sc_name": "Gospel Telecom",
    "sc_code": "VISASP3846",
    "address": "No 98/21,Shop No 5,1st Floor, Ashok Nagar Main Road, Landmark : (Opposite To Chozan Mess) Ashok Nagar, Chennai -600024",
    "city": "Chennai",
    "state": "Tamil Nadu",
    "pincode": "600024",
    "phone": "9360412427",
    "email": "gospel.telecom@gmail.com"
  },
  {
    "id": 18,
    "name": "A K Technologies (VISASP3815)",
    "sc_name": "A K Technologies",
    "sc_code": "VISASP3815",
    "address": "20/295,BESIDE ANNAMACHARYA CIRCLE,B.K.M.STREET.KADAPA-516001",
    "city": "Kadapa",
    "state": "Andhra Pradesh",
    "pincode": "516001",
    "phone": "9515004015",
    "email": "kareem4341@gmail.com"
  },
  {
    "id": 19,
    "name": "Taranam (VISASP3781)",
    "sc_name": "Taranam",
    "sc_code": "VISASP3781",
    "address": "Nokia Care, Near Hdfc Bank, Khari Phatak Road, Vidisha-464001",
    "city": "Vidisha",
    "state": "Madhya Pradesh",
    "pincode": "464001",
    "phone": "9826530022",
    "email": "abhinesh.taran@gmail.com"
  },
  {
    "id": 20,
    "name": "ABINASH TELECOM (VIS02231)",
    "sc_name": "ABINASH TELECOM",
    "sc_code": "VIS02231",
    "address": "PLOT NO 27 DISTRICT CENTER CHANDRASEKHARPUR BHUBANESWAR 751016",
    "city": "Bhubaneshwar",
    "state": "Odisha",
    "pincode": "751016",
    "phone": "8338886731",
    "email": "abinashtelecom@gmail.com"
  },
  {
    "id": 21,
    "name": "M/s Aditya Telecom (VISASP3878)",
    "sc_name": "M/s Aditya Telecom",
    "sc_code": "VISASP3878",
    "address": "Singh Plaza, Ground Floor, In Front Of Sree Leather Show Room, Dolamundai, Cuttack \u00e2\u20ac\u201c 753001",
    "city": "Cuttack",
    "state": "Odisha",
    "pincode": "753001",
    "phone": "9556398999",
    "email": "adityatelecomcuttack@gmail.com"
  },
  {
    "id": 22,
    "name": "MICRO CARE (VISASP3761)",
    "sc_name": "MICRO CARE",
    "sc_code": "VISASP3761",
    "address": "G.D.COMPLEX.N.T.ROAD.NEAR TRIVINI COMPLEX -784001",
    "city": "Tezpur",
    "state": "Assam",
    "pincode": "784001",
    "phone": "6003732525",
    "email": "microcare77@gmail.com"
  },
  {
    "id": 23,
    "name": "Singh Communication (VISASP3742)",
    "sc_name": "Singh Communication",
    "sc_code": "VISASP3742",
    "address": "GROUND FLOOR, L.F 10, MANSAROVER COMPLEX, HOSHANGABAD ROAD MPRTC, HUZUR, Bhopal, Madhya Pradesh, 462016, PIN: 462011",
    "city": "Bhopal",
    "state": "Madhya Pradesh",
    "pincode": "462011",
    "phone": "9926322660",
    "email": "akhileshbaghel@gmail.com"
  },
  {
    "id": 24,
    "name": "ANMOL INTERNATIONAL (VISASP3875)",
    "sc_name": "ANMOL INTERNATIONAL",
    "sc_code": "VISASP3875",
    "address": "Shop No. 10-A, Metro Plaza, Sabji Mandi, Paithan Gate, Aurangabad \u00e2\u20ac\u201c 431001 (Landmark : Opposite Bagban Masjid)",
    "city": "Aurangabad",
    "state": "Maharashtra",
    "pincode": "431001",
    "phone": "9762926121",
    "email": "infoai2121@gmail.com"
  },
  {
    "id": 25,
    "name": "IT Care (VISASP2734)",
    "sc_name": "IT Care",
    "sc_code": "VISASP2734",
    "address": "Infront Of Railway Station, Near IDBI Bank. Untta Station Jehanabad, Bihar - 804417",
    "city": "Jehanabad",
    "state": "Bihar",
    "pincode": "804417",
    "phone": "9504110922",
    "email": "itcarejehanabad@gmail.com"
  },
  {
    "id": 26,
    "name": "Zee Cool Service Center (VISASP3879)",
    "sc_name": "Zee Cool Service Center",
    "sc_code": "VISASP3879",
    "address": "First Floor, Pugmil Road, Kallu Chowk, Near V Mart Maill, Okni No.2, Hazaribagh Bihar-825301",
    "city": "Hazaribag",
    "state": "Jharkhand",
    "pincode": "825301",
    "phone": "6203555319",
    "email": "zeecoolmi@gmail.com"
  },
  {
    "id": 27,
    "name": "PUBLIC POINT CENTER (VIS02159)",
    "sc_name": "PUBLIC POINT CENTER",
    "sc_code": "VIS02159",
    "address": "LAVA CARE NEW AAMGHAT COLONY GANDHI PARK GHAZIPUR-233001",
    "city": "Ghazipur",
    "state": "Uttar Pradesh",
    "pincode": "233001",
    "phone": "8960652145",
    "email": "shahidgzp91@gmail.com"
  },
  {
    "id": 28,
    "name": "Himnish Communication (VISASP2576)",
    "sc_name": "Himnish Communication",
    "sc_code": "VISASP2576",
    "address": "Laxmi Market Near City Chowky Rampur Bushar 172001",
    "city": "Rampur Bushahr",
    "state": "Himachal Pradesh",
    "pincode": "172001",
    "phone": "8219409151",
    "email": "joshi.rmp@gmail.com"
  },
  {
    "id": 29,
    "name": "AIR VOICE (VIS02054)",
    "sc_name": "AIR VOICE",
    "sc_code": "VIS02054",
    "address": "235/4/1 Panchanantala Road,Near Panchanantala Mandir- 711101",
    "city": "Howrah",
    "state": "West Bengal",
    "pincode": "711101",
    "phone": "9123699211",
    "email": "9230010990av@gmail.com"
  },
  {
    "id": 30,
    "name": "Akhil Traders (VISASP3764)",
    "sc_name": "Akhil Traders",
    "sc_code": "VISASP3764",
    "address": "G107,108 Yashwant Plaza , Opp Railway Station-452001",
    "city": "Indore",
    "state": "Madhya Pradesh",
    "pincode": "452001",
    "phone": "8878617400",
    "email": "service@akhiltraders.com"
  },
  {
    "id": 31,
    "name": "RIDHHI INTERPRISES (VIS01807)",
    "sc_name": "RIDHHI INTERPRISES",
    "sc_code": "VIS01807",
    "address": "Address - Mhadev Nagar Khindwr Road Near Biswa Road Gurudwara Mahmudabad Sitapur 261203",
    "city": "Mahmudabad",
    "state": "Uttar Pradesh",
    "pincode": "261203",
    "phone": "8429139944",
    "email": "amriteshsamsung@gmail.com"
  },
  {
    "id": 32,
    "name": "Tatva Infotech (VISASP3899)",
    "sc_name": "Tatva Infotech",
    "sc_code": "VISASP3899",
    "address": "Mayur CHS, 2nd Floor, Office No - 203, Ram Maruti Road, Opposite - Lagoon Showroom, Above - Louis Philippe & U.S Polo Showroom, Thane West, Naupada, Maharashtra, Pin - 400602",
    "city": "Thane",
    "state": "Maharashtra",
    "pincode": "400602",
    "phone": "9619562333",
    "email": "anil_krishna05@yahoo.co.in"
  },
  {
    "id": 33,
    "name": "AARJAY ASSOCIATES (VISASP3814)",
    "sc_name": "AARJAY ASSOCIATES",
    "sc_code": "VISASP3814",
    "address": "2nd Floor,55/265,Manorama Jn, Near South Over Bridge, Adacent To South Square Overbuilding, Sahodaran Ayyapan Road, Ernakulam, Kochi 682036",
    "city": "Cochin",
    "state": "Kerala",
    "pincode": "682036",
    "phone": "7510254699",
    "email": "aarjay.in@gmail.com"
  },
  {
    "id": 34,
    "name": "Ramdev Telecom (VISASP3900)",
    "sc_name": "Ramdev Telecom",
    "sc_code": "VISASP3900",
    "address": "404/C,N.S.C. BOSE ROAD ,LAXMI NARAYAN COLONY ,GARIA KOLKATA, WESTBENGAL 700047",
    "city": "Garia",
    "state": "West Bengal",
    "pincode": "700047",
    "phone": "9831294298",
    "email": "gunjantank1976@gmail.com"
  },
  {
    "id": 35,
    "name": "Mahendra Telecom (VISASP4208)",
    "sc_name": "Mahendra Telecom",
    "sc_code": "VISASP4208",
    "address": "Radha Krishna More S.C.Sen Road Purulia PIN-723101",
    "city": "Purulia",
    "state": "West Bengal",
    "pincode": "723101",
    "phone": "9851343539",
    "email": "mahendratelecompurulia@gmail.com"
  },
  {
    "id": 36,
    "name": "MAHADEV INFOTECH (VISASP2760)",
    "sc_name": "MAHADEV INFOTECH",
    "sc_code": "VISASP2760",
    "address": "1st Floor Naveen Market MG Road Near Aditya Vision Aurangabad 824101",
    "city": "Aurangabad",
    "state": "Bihar",
    "pincode": "824101",
    "phone": "9386370028",
    "email": "infotechvaishnavi51@gmail.com"
  },
  {
    "id": 37,
    "name": "J.D. ENTERPRISE (VISASP3817)",
    "sc_name": "J.D. ENTERPRISE",
    "sc_code": "VISASP3817",
    "address": "PLOT NO 2207, Office No.216G, Hans Complex, Talaja Road, Sanskar Mandal, Bhavnagar-364002",
    "city": "Bhavnagar",
    "state": "Gujarat",
    "pincode": "364002",
    "phone": "9227560664",
    "email": "jdenterprise25.bvn@gmail.com"
  },
  {
    "id": 38,
    "name": "New Tirupati Cellulars (VISASP3797)",
    "sc_name": "New Tirupati Cellulars",
    "sc_code": "VISASP3797",
    "address": "Shop No 02 & 03, Esteem Towar, Near Surya Hotel, Mumbai Highway, Kharalwadi Pimpri,Pune, Maharashtra-411018",
    "city": "Pune",
    "state": "Maharashtra",
    "pincode": "411018",
    "phone": "8087072808",
    "email": "newtirupati@gmail.com"
  },
  {
    "id": 39,
    "name": "AZAD MOBILS (VIS01550)",
    "sc_name": "AZAD MOBILS",
    "sc_code": "VIS01550",
    "address": "Mishrikh Road Narottam Nagar, Sidhauli, Sitapur Pin code-261303",
    "city": "Sidhauli",
    "state": "Uttar Pradesh",
    "pincode": "261303",
    "phone": "9044789209",
    "email": "sharif078627.ms@gmail.com"
  },
  {
    "id": 40,
    "name": "Maa Comunication (VISASP3813)",
    "sc_name": "Maa Comunication",
    "sc_code": "VISASP3813",
    "address": "756/0, Maitry Park App, Vijalpore, Navsari - 396445",
    "city": "Navsari",
    "state": "Gujarat",
    "pincode": "396445",
    "phone": "9408650308",
    "email": "honornavsari@gmail.com"
  },
  {
    "id": 41,
    "name": "Mehta Watch Company (VISASP3779)",
    "sc_name": "Mehta Watch Company",
    "sc_code": "VISASP3779",
    "address": "R 17 First Floor Food And Entertainment City Mdda Complex Clock Tower-248001",
    "city": "Dehradun",
    "state": "Uttarakhand",
    "pincode": "248001",
    "phone": "9997770077",
    "email": "mehtawatchcompany@gmail.com"
  },
  {
    "id": 42,
    "name": "The Key Pad (VISASP3748)",
    "sc_name": "The Key Pad",
    "sc_code": "VISASP3748",
    "address": "Ramananda Tower,2Nd Floor,Opp.Hotel Nandan,Above Federal Bank,Paltan Bazar-781008",
    "city": "Guwahati",
    "state": "Assam",
    "pincode": "781008",
    "phone": "9864425149",
    "email": "vvvipintiwari@gmail.com"
  },
  {
    "id": 43,
    "name": "Universal Service (VIS00071)",
    "sc_name": "Universal Service",
    "sc_code": "VIS00071",
    "address": "Sugandhya,Delhi Road,Hooghly:- 712102",
    "city": "Hooghly",
    "state": "West Bengal",
    "pincode": "712102",
    "phone": "9874348348",
    "email": "universalservice720@gmail.com"
  },
  {
    "id": 44,
    "name": "Sact Communication (VISASP3776)",
    "sc_name": "Sact Communication",
    "sc_code": "VISASP3776",
    "address": "274 Good Shed Street, MADURAI-625001",
    "city": "Madurai",
    "state": "Tamil Nadu",
    "pincode": "625001",
    "phone": "9095150007",
    "email": "sactcommunication2016@gmail.com"
  },
  {
    "id": 45,
    "name": "Bright Infocom (VIS01510)",
    "sc_name": "Bright Infocom",
    "sc_code": "VIS01510",
    "address": "10-1-8, Shop No- 8, Ground Floor,The Landmark Complex,Sampath Vinayaka Temple Road,Visapatnam-530017",
    "city": "Vishakapatnam",
    "state": "Andhra Pradesh",
    "pincode": "530017",
    "phone": "9866256776",
    "email": "bright.vizag15@gmail.com"
  },
  {
    "id": 46,
    "name": "Neha Enterprise (VISASP3766)",
    "sc_name": "Neha Enterprise",
    "sc_code": "VISASP3766",
    "address": "BOC GATE NATUN BAZAR OPPO SOMA SWEET CHAPAGURI ROAD BONGAIGAON-783380",
    "city": "Bongaigaon",
    "state": "Assam",
    "pincode": "783380",
    "phone": "9365969451",
    "email": "newtechno.mobileservice@gmail.com"
  },
  {
    "id": 47,
    "name": "SHRI BALAJI SERVICES (VISASP4209)",
    "sc_name": "SHRI BALAJI SERVICES",
    "sc_code": "VISASP4209",
    "address": "KISHNAY COMPLEX CINEMA ROAD ANWARPUR HAJIPUR VAISHALI 844101",
    "city": "Hajipur",
    "state": "Bihar",
    "pincode": "844101",
    "phone": "9279983816",
    "email": "shribalajiserviceshjp@gmail.com"
  },
  {
    "id": 48,
    "name": "Gaurav Communication (VIS02026)",
    "sc_name": "Gaurav Communication",
    "sc_code": "VIS02026",
    "address": "1091, BISHAN SWROOP COLONY NEAR PREM HOSPITAL OPP ICS COACHING CENTER PANIPAT 132103",
    "city": "Panipat",
    "state": "Haryana",
    "pincode": "132103",
    "phone": "7015240360",
    "email": "gauravcomm3@gmail.com"
  },
  {
    "id": 49,
    "name": "Manav Telecom (VISASP3799)",
    "sc_name": "Manav Telecom",
    "sc_code": "VISASP3799",
    "address": "15, Managalam Place, Nn Mall 301A,1st Floor , Rohini Sec-3 Near By M2K,Cinema, Delhi-110085",
    "city": "New Delhi",
    "state": "Delhi",
    "pincode": "110085",
    "phone": "9582592391",
    "email": "dexters.cp@gmail.com"
  },
  {
    "id": 50,
    "name": "ICON TECHNOLOGIES (VISASP4194)",
    "sc_name": "ICON TECHNOLOGIES",
    "sc_code": "VISASP4194",
    "address": "PRIYA COMPLEX 26/183 NADUVILANGADI TIRUR 676101",
    "city": "Tirur",
    "state": "Kerala",
    "pincode": "676101",
    "phone": "9037177720",
    "email": "icontirur@gmail.com"
  },
  {
    "id": 51,
    "name": "MOBILE WORLD (VISASP2900)",
    "sc_name": "MOBILE WORLD",
    "sc_code": "VISASP2900",
    "address": "OPP- INFRONT OF INDIAN OIL PETROL PUMP, MIRZAPUR CHOWK , DARBHANGA 846004",
    "city": "Darbhanga",
    "state": "Bihar",
    "pincode": "846004",
    "phone": "7004521518",
    "email": "canand92@gmail.com"
  },
  {
    "id": 52,
    "name": "SHREE AASTHA ENTERPRISE (VIS01549)",
    "sc_name": "SHREE AASTHA ENTERPRISE",
    "sc_code": "VIS01549",
    "address": "201 C.S MARG ALIRAJPUR, PIN: 457887",
    "city": "Alirajpur",
    "state": "Madhya Pradesh",
    "pincode": "457887",
    "phone": "9893114555",
    "email": "aasthamobile555@gmail.com"
  },
  {
    "id": 53,
    "name": "Laxmi Telecom (VISASP3837)",
    "sc_name": "Laxmi Telecom",
    "sc_code": "VISASP3837",
    "address": "BATTALA, H.G.B.ROAD, GARTALA, AGARTALA, West Tripura, 799001",
    "city": "Agartala",
    "state": "Tripura",
    "pincode": "799001",
    "phone": "9862773621",
    "email": "telecomlaxmi1103@gmail.com"
  },
  {
    "id": 54,
    "name": "GD Mobile Care (VISASP3796)",
    "sc_name": "GD Mobile Care",
    "sc_code": "VISASP3796",
    "address": "GD MOBILE CARE,NO:1/20, 200 Feet Road, EACHANGADU, KOVILAMBAKKAM, Chennai-600129",
    "city": "Chennai",
    "state": "Tamil Nadu",
    "pincode": "600129",
    "phone": "9043524659",
    "email": "gdmobilecarekeelkatalai@gmail.com"
  },
  {
    "id": 55,
    "name": "SHREE GANESH ENTERPRISES (VIS02133)",
    "sc_name": "SHREE GANESH ENTERPRISES",
    "sc_code": "VIS02133",
    "address": "BHAGAT BULDING 1ST FLOOR ADB CHOWK ARARIA BIHAR-854311, Bihar, Araria",
    "city": "Araria",
    "state": "Bihar",
    "pincode": "854311",
    "phone": "9934053895",
    "email": "shreeganeshenterprisesararia@gmail.com"
  },
  {
    "id": 56,
    "name": "Mahi SVC (VISASP3798)",
    "sc_name": "Mahi SVC",
    "sc_code": "VISASP3798",
    "address": "\"SHAHI COMPLEX, GROUND FLOOR, NEW DAKBUNGLOW ROAD, PATNA , BIHAR Pin Code - 800001\"",
    "city": "Patna",
    "state": "Bihar",
    "pincode": "800001",
    "phone": "9304344655",
    "email": "mahisvc.nokia@gmail.com"
  },
  {
    "id": 57,
    "name": "Everest Mobicare (VISASP3787)",
    "sc_name": "Everest Mobicare",
    "sc_code": "VISASP3787",
    "address": "184,Lenin Sarani,Next To Tipu Sultan Masjid,Esplanade, 1st Flore, PIN: 700013",
    "city": "Kolkata",
    "state": "West Bengal",
    "pincode": "700013",
    "phone": "9903554880",
    "email": "admin@everestmobicare.com"
  },
  {
    "id": 58,
    "name": "YA SERVICE (VISASP3897)",
    "sc_name": "YA SERVICE",
    "sc_code": "VISASP3897",
    "address": "Floor-1, N/A, Jwain Complex, Motphran, Wahthapbroo, East Khasi Hills, Meghalaya, 793002",
    "city": "Shillong",
    "state": "Meghalaya",
    "pincode": "793002",
    "phone": "8014488051",
    "email": "yaservicederek@gmail.com"
  },
  {
    "id": 59,
    "name": "Sri Siddi Vinayaka Communications (VISASP3862)",
    "sc_name": "Sri Siddi Vinayaka Communications",
    "sc_code": "VISASP3862",
    "address": "Shop No : F29,30,31 Kr&Ms Reddy Complex , Vijaya Talkies Raod , Chowrasta, Hanmakonda , Warangal-506001",
    "city": "Warangal",
    "state": "Telangana",
    "pincode": "506001",
    "phone": "8686267677",
    "email": "srisiddivinayakacommunications@gmail.com"
  },
  {
    "id": 60,
    "name": "Dev Services (VIS02151)",
    "sc_name": "Dev Services",
    "sc_code": "VIS02151",
    "address": "Thana Road, Bounsi,Banka-813104",
    "city": "Banka",
    "state": "Bihar",
    "pincode": "813104",
    "phone": "8051090740",
    "email": "devservicesbnk@gmail.com"
  },
  {
    "id": 61,
    "name": "New Mass Communication (VISASP3736)",
    "sc_name": "New Mass Communication",
    "sc_code": "VISASP3736",
    "address": "Sco 152 Ist Floor Mugal Canal Market Karnal-132001",
    "city": "Karnal",
    "state": "Haryana",
    "pincode": "132001",
    "phone": "8950500920",
    "email": "servkarnal@gmail.com"
  },
  {
    "id": 62,
    "name": "Ashish Electronics (VISASP3827)",
    "sc_name": "Ashish Electronics",
    "sc_code": "VISASP3827",
    "address": "Ashish Electronics, B-Xix 565/5 1St Floor Near Icici Bank Cemetery Road Ludhiana-141001",
    "city": "Ludhiana",
    "state": "Punjab",
    "pincode": "141001",
    "phone": "9814578175",
    "email": "quickservice_lg@rediffmail.com"
  },
  {
    "id": 63,
    "name": "M/S Dharms Mobile (VISASP3863)",
    "sc_name": "M/S Dharms Mobile",
    "sc_code": "VISASP3863",
    "address": "G. N. B Road, Shanti Nagar Backsides Of Mitra Agency Book Store, New Market Area, Assam 78612, PIN: 786125",
    "city": "Tinsukia",
    "state": "Assam",
    "pincode": "786125",
    "phone": "7002212404",
    "email": "dharmsmobile@gmail.com"
  },
  {
    "id": 64,
    "name": "Cell Care Point (VISASP3807)",
    "sc_name": "Cell Care Point",
    "sc_code": "VISASP3807",
    "address": "Shop No, 122, 1St Floor, Pearl Plaza, Building Beside Mcdonald Opp Andheri Station Andheri West Mumbai, Maharashtra-400058",
    "city": "Mumbai",
    "state": "Maharashtra",
    "pincode": "400058",
    "phone": "9699418605",
    "email": "cellcarepoint98@gmail.com"
  },
  {
    "id": 65,
    "name": "Vijeex System (VISASP3858)",
    "sc_name": "Vijeex System",
    "sc_code": "VISASP3858",
    "address": "26, Sarathy Nagar, Near Uzhavar Chandai,Kagithapattarai,Vellore. 632012",
    "city": "Vellore",
    "state": "Tamil Nadu",
    "pincode": "632012",
    "phone": "9894577339",
    "email": "vijeexsystems@gmail.com"
  },
  {
    "id": 66,
    "name": "Supreme Services (VISASP3867)",
    "sc_name": "Supreme Services",
    "sc_code": "VISASP3867",
    "address": "ABOVE MULTIPLES GARMENT SHOP, FIRST FLOOR NO.30/A, 30/A, D Devaraj Urs Road, Devraj Mohalla, Mysuru, Mysuru, Karnataka, 570001",
    "city": "Mysore",
    "state": "Karnataka",
    "pincode": "570001",
    "phone": "9880910706",
    "email": "supremeservicesmys@gmail.com"
  },
  {
    "id": 67,
    "name": "L M Services (VISASP3809)",
    "sc_name": "L M Services",
    "sc_code": "VISASP3809",
    "address": "Jubilly Buildings, T B Road, Kottayam-686001",
    "city": "Kottayam",
    "state": "Kerala",
    "pincode": "686001",
    "phone": "8129948833",
    "email": "mail@lmservices.co.in"
  },
  {
    "id": 68,
    "name": "TRIPATHI ENTERPRISESS (VIS01643)",
    "sc_name": "TRIPATHI ENTERPRISESS",
    "sc_code": "VIS01643",
    "address": "Shop No.2,karuwa Baba Churaha Purani Basti,Basti,uttar Pradesh,272002",
    "city": "Basti",
    "state": "Uttar Pradesh",
    "pincode": "272002",
    "phone": "9839300013",
    "email": "tripathi.enterprises3013@yahoo.com"
  },
  {
    "id": 69,
    "name": "Shalimar Communication (VISASP3806)",
    "sc_name": "Shalimar Communication",
    "sc_code": "VISASP3806",
    "address": "120 Naya Bazar Near Pc Jwellers Bhilwara (Raj.)311001",
    "city": "Bhilwara",
    "state": "Rajasthan",
    "pincode": "311001",
    "phone": "9414262499",
    "email": "shalimarbhl11@gmail.com"
  },
  {
    "id": 70,
    "name": "Gsm Solutions (VISASP3841)",
    "sc_name": "Gsm Solutions",
    "sc_code": "VISASP3841",
    "address": "3528/3/4,Opp Fedral Bank,Near Tarun Bharat Press,Narvekar Galli,Belgaum590002",
    "city": "Belgaum",
    "state": "Karnataka",
    "pincode": "590002",
    "phone": "9980899780",
    "email": "gsmsolutions.belgaum@gmail.com"
  },
  {
    "id": 71,
    "name": "Husain Mobile Point (VIS01419)",
    "sc_name": "Husain Mobile Point",
    "sc_code": "VIS01419",
    "address": "Behind Anjuman Hospital , Talav Road , Dahod , Gujarat (389151)",
    "city": "Dahod",
    "state": "Gujarat",
    "pincode": "389151",
    "phone": "9662325949",
    "email": "husainmobile@yahoo.com"
  },
  {
    "id": 72,
    "name": "IVA Systems (VIS02378)",
    "sc_name": "IVA Systems",
    "sc_code": "VIS02378",
    "address": "1St Floor,City Centre Shoping Complex ,Near Akbar Travels ,Sulthan Bathery Wayanad Kerala ,673592",
    "city": "Wayanad",
    "state": "Kerala",
    "pincode": "673592",
    "phone": "9645610510",
    "email": "ivasystemssby@gmail.com"
  },
  {
    "id": 73,
    "name": "ARORA MOBILE SOLUTION (VIS01826)",
    "sc_name": "ARORA MOBILE SOLUTION",
    "sc_code": "VIS01826",
    "address": "ABOVE OBC BANK, BIKANER ROAD, SURATGARH-331507, PIN: 335804",
    "city": "Suratgarh",
    "state": "Rajasthan",
    "pincode": "335804",
    "phone": "9079882123",
    "email": "aroramobiles17@gmail.com"
  },
  {
    "id": 74,
    "name": "EXCLUSIVE CARE (VIS02157)",
    "sc_name": "EXCLUSIVE CARE",
    "sc_code": "VIS02157",
    "address": "39/4967B, USNAZ TOWERS, OPP. MEDICAL TRUST HOSPITAL, PALLIMUKKU, M G ROAD, COCHIN, PIN-682016",
    "city": "Cochin",
    "state": "Kerala",
    "pincode": "682016",
    "phone": "9947114499",
    "email": "exclusivetechteam@gmail.com"
  },
  {
    "id": 75,
    "name": "M/S RISHU TELECOM (VISASP2789)",
    "sc_name": "M/S RISHU TELECOM",
    "sc_code": "VISASP2789",
    "address": "WARD NO 21 TF-54 IN FRONT OF GANESH PANDAL BUDHWARI BAZAR KORBA PIN -495677",
    "city": "Korba",
    "state": "Chhattisgarh",
    "pincode": "495677",
    "phone": "7000356029",
    "email": "rishutelecom35@gmail.com"
  },
  {
    "id": 76,
    "name": "Sri Lakshmi Ganapathi Technology (VISASP4193)",
    "sc_name": "Sri Lakshmi Ganapathi Technology",
    "sc_code": "VISASP4193",
    "address": "Door No. 1-9-21/A, 1st Floor, Idea Showroom, Upstair, Himagiri Road, Vizinagaram, Andhra Pradesh 535003",
    "city": "Vizianagaram",
    "state": "Andhra Pradesh",
    "pincode": "535003",
    "phone": "9392202777",
    "email": "ramanalg777@gmail.com"
  },
  {
    "id": 77,
    "name": "INSTANT MOBILE AND COMPUTERS (VISASP3903)",
    "sc_name": "INSTANT MOBILE AND COMPUTERS",
    "sc_code": "VISASP3903",
    "address": "Arni Rd, Opp RAJSAGAR BOYS ZONE, New Singhania Nagar, Bharti Nagar, Yavatmal, Wadgaon Road, Maharashtra 445002",
    "city": "Yavatmal",
    "state": "Maharashtra",
    "pincode": "445002",
    "phone": "7875300010",
    "email": "instantmobileytl@gmail.com"
  },
  {
    "id": 78,
    "name": "MOBICARE SOLUTIONS (VISASP3847)",
    "sc_name": "MOBICARE SOLUTIONS",
    "sc_code": "VISASP3847",
    "address": "2-7-381 , First Floor , Prashanth Complex , A2Z Pharmacy , Opp: Prathima Multiplex , Collectorate Chowrastha , Karimnagar - 505 001, PIN: 505001",
    "city": "Karimnagar",
    "state": "Telangana",
    "pincode": "505001",
    "phone": "8466866864",
    "email": "mobicaresolutions2020@gmail.com"
  },
  {
    "id": 79,
    "name": "Aparna Electronics And Services (VISASP3880)",
    "sc_name": "Aparna Electronics And Services",
    "sc_code": "VISASP3880",
    "address": "Behind Bhagyashree Ghee Bhandar , Gol Bazar Bazar Ward , Chandrapur , Maharashtra - 442402",
    "city": "Chandrapur",
    "state": "Maharashtra",
    "pincode": "442402",
    "phone": "7744954321",
    "email": "kapurkarkoustubh@gmail.com"
  },
  {
    "id": 80,
    "name": "OM SAI TELECOM (VISASP3825)",
    "sc_name": "OM SAI TELECOM",
    "sc_code": "VISASP3825",
    "address": "Shop No F-197,Haware Fantasia Business Park,1st Floor Corparate Wing Behind Inorbit Mall Vashi Navimumbai 400705",
    "city": "Vashi",
    "state": "Maharashtra",
    "pincode": "400705",
    "phone": "9137427274",
    "email": "omsai.fly@gmail.com"
  },
  {
    "id": 81,
    "name": "Sonu Mobile Shop (VISASP4078)",
    "sc_name": "Sonu Mobile Shop",
    "sc_code": "VISASP4078",
    "address": "1st Floor , Shop N 5e, Opp Old Bus Stand. Gohana Road , 126012( Haryana), PIN: 126102",
    "city": "Jind",
    "state": "Haryana",
    "pincode": "126102",
    "phone": "9812175147",
    "email": "smslucky555@gmail.com"
  },
  {
    "id": 82,
    "name": "Viajayaganapathi Cell Servicing (VIS01502)",
    "sc_name": "Viajayaganapathi Cell Servicing",
    "sc_code": "VIS01502",
    "address": "D.no.2-1-21,opp. Bhashyam School,Beside Ganesh Canteen, J.P.Road,Bhimavarm-534202",
    "city": "Bhimavaram",
    "state": "Andhra Pradesh",
    "pincode": "534202",
    "phone": "9912234549",
    "email": "vgcsbvrm@gmail.com"
  },
  {
    "id": 83,
    "name": "Master Cool (VISASP3836)",
    "sc_name": "Master Cool",
    "sc_code": "VISASP3836",
    "address": "41-42, First Floor, Sarang Marg, Near Surajpole, Udaipur-313001",
    "city": "Udaipur",
    "state": "Rajasthan",
    "pincode": "313001",
    "phone": "9414166278",
    "email": "mastercool0581@gmail.com"
  },
  {
    "id": 84,
    "name": "Smart Solutions (VISASP3843)",
    "sc_name": "Smart Solutions",
    "sc_code": "VISASP3843",
    "address": "No-55/30 Sn High Road, Near Aravinth Eye Hospital, Tirunelveli-627001",
    "city": "Tirunelveli",
    "state": "Tamil Nadu",
    "pincode": "627001",
    "phone": "9884544466",
    "email": "nccp.tirunelveli@gmail.com"
  },
  {
    "id": 85,
    "name": "Vasavi Associates (VISASP3820)",
    "sc_name": "Vasavi Associates",
    "sc_code": "VISASP3820",
    "address": "Central Park,204&205,1St Floor ,Near Municipal Office Tilak Road,Varada Raja Nagar-517501",
    "city": "Tirupati",
    "state": "Andhra Pradesh",
    "pincode": "517501",
    "phone": "7093444999",
    "email": "vasavinokia@gmail.com"
  },
  {
    "id": 86,
    "name": "Delight Techno Services (VISASP3851)",
    "sc_name": "Delight Techno Services",
    "sc_code": "VISASP3851",
    "address": "Shop No 13 , 14 , Diamond Towers , Beside Taj Tristar Hotel, Opp Manju Theater , Secunderabad, Hyderabad, Telangana -500003",
    "city": "Hyderabad",
    "state": "Telangana",
    "pincode": "500003",
    "phone": "7093444999",
    "email": "delight.hyderabad555@gmail.com"
  },
  {
    "id": 87,
    "name": "S V Communications (VISASP3852)",
    "sc_name": "S V Communications",
    "sc_code": "VISASP3852",
    "address": "Shop No 13 , 14 , Diamond Towers , Beside Taj Tristar Hotel, Opp Manju Theater , Secunderabad, Hyderabad, Telangana -500003",
    "city": "Nalgonda",
    "state": "Telangana",
    "pincode": "500003",
    "phone": "7093444999",
    "email": "delight.hyderabad555@gmail.com"
  },
  {
    "id": 88,
    "name": "Suncity Mobile (VISASP3744)",
    "sc_name": "Suncity Mobile",
    "sc_code": "VISASP3744",
    "address": "\"SHOP NO.1159, NEAR BANK OF INDIA, OPPOSITE FORT PARKING, DHIBBA PARA, JAISALMER, Jaisalmer, Rajasthan, 345001 \"",
    "city": "Jaisalmer",
    "state": "Rajasthan",
    "pincode": "345001",
    "phone": "9667116434",
    "email": "suncitymobilejaisalmer1988@gmail.com"
  },
  {
    "id": 89,
    "name": "Mobile Connect (VISASP3778)",
    "sc_name": "Mobile Connect",
    "sc_code": "VISASP3778",
    "address": "SECOND FLOOR, S.C.O.2461-2462 SECTOR 22-C, Chandigarh, 160022",
    "city": "Chandigarh",
    "state": "Punjab",
    "pincode": "160022",
    "phone": "9915572530",
    "email": "manjit_saini@live.in"
  },
  {
    "id": 90,
    "name": "Techno Service Zone (VISASP3842)",
    "sc_name": "Techno Service Zone",
    "sc_code": "VISASP3842",
    "address": "#15, 1St Temple Street, Near 10Th Cross, Opp New Asha Sweets Malleshwaram ,Bangalore, Karnataka-560003",
    "city": "Bangalore",
    "state": "Karnataka",
    "pincode": "560003",
    "phone": "9972032657",
    "email": "technoservicezone@gmail.com"
  },
  {
    "id": 91,
    "name": "City Care (VISASP3876)",
    "sc_name": "City Care",
    "sc_code": "VISASP3876",
    "address": "Hotel City Vinayak Campus, 1st Floor, Beside Aditya Vision, Front Of Bsnl Office And Post, Station Road , Motihari, 845401",
    "city": "Motihari",
    "state": "Bihar",
    "pincode": "845401",
    "phone": "9097577786",
    "email": "azaad.mth@hotmail.com"
  },
  {
    "id": 92,
    "name": "S.K. COMPUTER (VISASP2684)",
    "sc_name": "S.K. COMPUTER",
    "sc_code": "VISASP2684",
    "address": "COLLEGE ROAD -GYANDA GALI- SAHIBGANJ -816109, Jharkhand, Sahibganj",
    "city": "Sahibganj",
    "state": "Jharkhand",
    "pincode": "816109",
    "phone": "9955558008",
    "email": "skcomputer.k@gmail.com"
  },
  {
    "id": 93,
    "name": "Intech Solutions (VIS00014)",
    "sc_name": "Intech Solutions",
    "sc_code": "VIS00014",
    "address": "28/35 Rabindra Avenue, Beside Electric Supply Office, Malda - 732101",
    "city": "Malda",
    "state": "West Bengal",
    "pincode": "732101",
    "phone": "9339202796",
    "email": "intechsolutionsmalda@gmail.com"
  },
  {
    "id": 94,
    "name": "M S Communication (VIS02069)",
    "sc_name": "M S Communication",
    "sc_code": "VIS02069",
    "address": "Jabbarchak Chowk , Tatarpur Road, Near Gandhi Shanti Partishthan, Bhagalpur - 812001",
    "city": "Bhagalpur",
    "state": "Bihar",
    "pincode": "812001",
    "phone": "9122841843",
    "email": "mscommunication81@gmail.com"
  },
  {
    "id": 95,
    "name": "Bharat It Solutions (VISASP2549)",
    "sc_name": "Bharat It Solutions",
    "sc_code": "VISASP2549",
    "address": "Mateshwari Complex Salempur Shilpi Phokra Chapra Saran Pin. 841301 Ph.7004392722 , Bihar, Chapra",
    "city": "Chapra",
    "state": "Bihar",
    "pincode": "841301",
    "phone": "7004392722",
    "email": "bharat.itsolutions2019@gmail.com"
  },
  {
    "id": 96,
    "name": "MS Communication (VISASP3790)",
    "sc_name": "MS Communication",
    "sc_code": "VISASP3790",
    "address": "First Floor, AMCW-45/1317D, Bismi Complex, Vazhichery Road, Alappuzha, Kerala, 688001",
    "city": "Alappuzha",
    "state": "Kerala",
    "pincode": "688001",
    "phone": "9400593777",
    "email": "mscommunications377@gmail.com"
  },
  {
    "id": 97,
    "name": "Balaji Consumer Product (VISASP2888)",
    "sc_name": "Balaji Consumer Product",
    "sc_code": "VISASP2888",
    "address": "Baranilpur Banerjee Super Market, Ground 48, Baranilpur Uttarpara North Pally, Ward No. 12, Purba Bardhaman , West Bengal - 713101",
    "city": "East Barddhaman",
    "state": "West Bengal",
    "pincode": "713101",
    "phone": "9775749626",
    "email": "balajiconsumerproduct@gmail.com"
  },
  {
    "id": 98,
    "name": "SHRISTI ENTERPRISES (VISASP3300)",
    "sc_name": "SHRISTI ENTERPRISES",
    "sc_code": "VISASP3300",
    "address": "NEAR BUS STAND GIRIHINDA STATION ROAD SHEIKHPURA Pin 811105 Ph-9473072361, Bihar, SHEIKHPURA",
    "city": "Sheikhpura",
    "state": "Bihar",
    "pincode": "811105",
    "phone": "6203281054",
    "email": "shristienterprises39@gmail.com"
  },
  {
    "id": 99,
    "name": "Slanz Communication (VISASP3737)",
    "sc_name": "Slanz Communication",
    "sc_code": "VISASP3737",
    "address": "#4&5 Sri Siddaganga Complex B H Road Tumkur-572102",
    "city": "Tumkur",
    "state": "Karnataka",
    "pincode": "572102",
    "phone": "9449325125",
    "email": "slanzcommunication@gmail.com"
  },
  {
    "id": 100,
    "name": "Hitech Mobiles (VISASP2852)",
    "sc_name": "Hitech Mobiles",
    "sc_code": "VISASP2852",
    "address": "Opp. Navrang Opticle, Near by Post Office, Nai Sadak, Shajapur, Madhya Pradesh-465001",
    "city": "Shajapur",
    "state": "Madhya Pradesh",
    "pincode": "465001",
    "phone": "7000220486",
    "email": "hitechmobiles269@gmail.com"
  },
  {
    "id": 101,
    "name": "Shoolini Communication (VIS00922)",
    "sc_name": "Shoolini Communication",
    "sc_code": "VIS00922",
    "address": "Shop No. 14 First Sheel Complex Old Court Road Solan H.P 173212",
    "city": "Solan",
    "state": "Himachal Pradesh",
    "pincode": "173212",
    "phone": "9805544442",
    "email": "rajesh.kumar.solan@gmail.com"
  },
  {
    "id": 102,
    "name": "Neo Tech (VISASP2610)",
    "sc_name": "Neo Tech",
    "sc_code": "VISASP2610",
    "address": "2Nd Floor, Ms Tower, Bakery Junction, Thampanoor Po, Trivandrum - 695001",
    "city": "Trivandrum",
    "state": "Kerala",
    "pincode": "695001",
    "phone": "9746359224",
    "email": "neotechtvm2022@gmail.com"
  },
  {
    "id": 103,
    "name": "Ayush Services (VIS02139)",
    "sc_name": "Ayush Services",
    "sc_code": "VIS02139",
    "address": "703, Shop No B3, Yasudev Apartment, E Ward Near Khemraj Bakery , 4th Lene Shahupuri -416001",
    "city": "Kolhapur",
    "state": "Maharashtra",
    "pincode": "416001",
    "phone": "9146775781",
    "email": "ayushservices2020@gmail.com"
  },
  {
    "id": 104,
    "name": "X Cell Solutions (VIS00757)",
    "sc_name": "X Cell Solutions",
    "sc_code": "VIS00757",
    "address": "S-19,20,21,Second Floor,Forza Mall,Gulf Bazr,Tirur Po,Malapuram Dt,, PIN: 676101",
    "city": "Tirur",
    "state": "Kerala",
    "pincode": "676101",
    "phone": "7012144755",
    "email": "ksptirur@gmail.com"
  },
  {
    "id": 105,
    "name": "Jain Mobile (VIS02058)",
    "sc_name": "Jain Mobile",
    "sc_code": "VIS02058",
    "address": "Near Katra Mandir, Pratap Ward, Bina-470113",
    "city": "Bina",
    "state": "Madhya Pradesh",
    "pincode": "470113",
    "phone": "8770330172",
    "email": "ggauravjain56@gmail.com"
  },
  {
    "id": 106,
    "name": "Service Hub (VISASP2834)",
    "sc_name": "Service Hub",
    "sc_code": "VISASP2834",
    "address": "Harisabha Chauk , Near Jawahar Cinema Amgola Muzaffarpur Pin-842001 Ph-8252866667 , Bihar, Muzaffarpur",
    "city": "Muzaffarpur",
    "state": "Bihar",
    "pincode": "842001",
    "phone": "7209110417",
    "email": "servicehub.muz@gmail.com"
  },
  {
    "id": 107,
    "name": "Ajay Electronics (VIS00544)",
    "sc_name": "Ajay Electronics",
    "sc_code": "VIS00544",
    "address": "G4/A Yashwant Plaza Near Railway Station Indore Mp 452001",
    "city": "Indore",
    "state": "Madhya Pradesh",
    "pincode": "452001",
    "phone": "9111111249",
    "email": "ajayelectronics3@gmail.com"
  },
  {
    "id": 108,
    "name": "Exclusive Cellular Services (VIS02070)",
    "sc_name": "Exclusive Cellular Services",
    "sc_code": "VIS02070",
    "address": "BL 08,09,10, Thakker Bazar, Below MNS Office, Trimbak Road, New CBS , Nashik-422002",
    "city": "Nashik",
    "state": "Maharashtra",
    "pincode": "422002",
    "phone": "7350009893",
    "email": "ecs.nashik@gmail.com"
  },
  {
    "id": 109,
    "name": "Akash Enterprises (VIS00162)",
    "sc_name": "Akash Enterprises",
    "sc_code": "VIS00162",
    "address": "Kadeer Market, Near Bob Atm, Indra Chowk,Budaun, Up West-243601",
    "city": "Budaun",
    "state": "Uttar Pradesh",
    "pincode": "243601",
    "phone": "9027274447",
    "email": "akashenterprises1993@gmail.com"
  },
  {
    "id": 110,
    "name": "Sawhney Communication (VIS01462)",
    "sc_name": "Sawhney Communication",
    "sc_code": "VIS01462",
    "address": "First Floor Tanshiq Jewellery Near Hotel Fortune Riviera Gulab Singh Marg Road Jammu. 180001",
    "city": "Jammu",
    "state": "Jammu And Kashmir",
    "pincode": "180001",
    "phone": "9086005398",
    "email": "akhilsawhney10101@gmail.com"
  },
  {
    "id": 111,
    "name": "Ahuja Mobile (VIS01380)",
    "sc_name": "Ahuja Mobile",
    "sc_code": "VIS01380",
    "address": "Ahuja Mobile Pvt Ltd Infront Of Danik Bhaskar Press, Bhaskarlane, Jayendraganj, Lashkar Gwalior MP 474001",
    "city": "Gwalior",
    "state": "Madhya Pradesh",
    "pincode": "474001",
    "phone": "9669006805",
    "email": "alok@ahujamobile.in"
  },
  {
    "id": 112,
    "name": "Alok Computers And Printers (VIS01446)",
    "sc_name": "Alok Computers And Printers",
    "sc_code": "VIS01446",
    "address": "214/E 2Nd Floor Super Bazar Station Road Moradabad-244001 , Uttar Pradesh, Moradabad",
    "city": "Moradabad",
    "state": "Uttar Pradesh",
    "pincode": "244001",
    "phone": "9456676979",
    "email": "alokk021@gmail.com"
  },
  {
    "id": 113,
    "name": "M R Solution (VISASP2775)",
    "sc_name": "M R Solution",
    "sc_code": "VISASP2775",
    "address": "P No.2267/3, Old Delhi Road Near American Tourister Store Sec 14 Gurugram 122001",
    "city": "Gurgaon",
    "state": "Haryana",
    "pincode": "122001",
    "phone": "9891774402",
    "email": "mrsolutionggn@gmail.com"
  },
  {
    "id": 114,
    "name": "Z A Mobiles (VIS00179)",
    "sc_name": "Z A Mobiles",
    "sc_code": "VIS00179",
    "address": "Gf-4 Leela Mention Nawal Kishor Road, Hazratganj, Lucknow, Uttar Pradesh, Lucknow, PIN: 226001",
    "city": "Lucknow",
    "state": "Uttar Pradesh",
    "pincode": "226001",
    "phone": "9889065311",
    "email": "amit.mobilecare@gmail.com"
  },
  {
    "id": 115,
    "name": "Shubham Telecom (VIS00161)",
    "sc_name": "Shubham Telecom",
    "sc_code": "VIS00161",
    "address": "Shop No G-15 Basoya Complex Naya Bans Sec-15 Noida-201301 Near Syndicate Bank",
    "city": "Noida",
    "state": "Uttar Pradesh",
    "pincode": "201301",
    "phone": "9717407203",
    "email": "shubhamtelecomnoida@gmail.com"
  },
  {
    "id": 116,
    "name": "A.K.Enterprises (VIS01130)",
    "sc_name": "A.K.Enterprises",
    "sc_code": "VIS01130",
    "address": "Near Shitla Mandir Chowk, Nimtalla Road,Munger Bihar , 811201, Bihar, Munger",
    "city": "Munger",
    "state": "Bihar",
    "pincode": "811201",
    "phone": "7677565959",
    "email": "akmsamit@gmail.com"
  },
  {
    "id": 117,
    "name": "Br Communication (VIS01355)",
    "sc_name": "Br Communication",
    "sc_code": "VIS01355",
    "address": "Near State Bank Of India Main Brance Old Lic Station Road Mainpuri, PIN: 205001",
    "city": "Mainpuri",
    "state": "Uttar Pradesh",
    "pincode": "205001",
    "phone": "9084138000",
    "email": "brcommunicationmainpuri@gmail.com"
  },
  {
    "id": 118,
    "name": "Amit Enterprises (VISASP2725)",
    "sc_name": "Amit Enterprises",
    "sc_code": "VISASP2725",
    "address": "Satteshwar, Near Stadium, Auraiya, Uttar Pradesh Pin-206122 , Uttar Pradesh, Auraiya",
    "city": "Auraiya",
    "state": "Uttar Pradesh",
    "pincode": "206122",
    "phone": "8077317798",
    "email": "amititelauraiya@gmail.com"
  },
  {
    "id": 119,
    "name": "Ray Computer (VIS00013)",
    "sc_name": "Ray Computer",
    "sc_code": "VIS00013",
    "address": "Biswas Para Road,Krishna Complex,Balurghat,Dakshin Dinajpur,West Bengal -733101",
    "city": "Balurghat",
    "state": "West Bengal",
    "pincode": "733101",
    "phone": "9474435402",
    "email": "raycomputer.blg@gmail.com"
  },
  {
    "id": 120,
    "name": "Bunty Electronics (VISASP2521)",
    "sc_name": "Bunty Electronics",
    "sc_code": "VISASP2521",
    "address": "B2 Stadium Complex, Mlb Road, Chhindwara, Mp-480001",
    "city": "Chhindwara",
    "state": "Madhya Pradesh",
    "pincode": "480001",
    "phone": "9981346658",
    "email": "buntyphotoelectronics@gmail.com"
  },
  {
    "id": 121,
    "name": "Maa Osiya Communication (VISASP3777)",
    "sc_name": "Maa Osiya Communication",
    "sc_code": "VISASP3777",
    "address": "Subhash Pally, Kameshwari Road , Coochbehar , West Bengal-736101",
    "city": "Coochbehar",
    "state": "West Bengal",
    "pincode": "736101",
    "phone": "9474428100",
    "email": "anandbanthia123@gmail.com"
  },
  {
    "id": 122,
    "name": "M/s Anand Gift & Mobile Center (VIS01665)",
    "sc_name": "M/s Anand Gift & Mobile Center",
    "sc_code": "VIS01665",
    "address": "Shop No.118,1st Floor KB Mall,Near Bus Stand,Talpura Road,Jhansi-284001, Uttar Pradesh, Jhansi",
    "city": "Jhansi",
    "state": "Uttar Pradesh",
    "pincode": "284001",
    "phone": "7408888884",
    "email": "anand.soni944@gmail.com"
  },
  {
    "id": 123,
    "name": "Sri Binayak Distributors (VIS00522)",
    "sc_name": "Sri Binayak Distributors",
    "sc_code": "VIS00522",
    "address": "N.K.T. Road , Beside Monalisha Bar. Jeypore.Dist-Koraput,Odisha.-764001",
    "city": "Jeypore",
    "state": "Odisha",
    "pincode": "764001",
    "phone": "9439090099",
    "email": "anilpadhy.n@gmail.com"
  },
  {
    "id": 124,
    "name": "The Care Point (VIS01081)",
    "sc_name": "The Care Point",
    "sc_code": "VIS01081",
    "address": "B-85 Main Loni Road Joyti Colony Sahadara Near Duraga Puri Chowk Delhi-110032",
    "city": "Delhi",
    "state": "Delhi",
    "pincode": "110032",
    "phone": "8700616767",
    "email": "ankitsngh191@gmail.com"
  },
  {
    "id": 125,
    "name": "Green Wep Technology (VISASP3769)",
    "sc_name": "Green Wep Technology",
    "sc_code": "VISASP3769",
    "address": "Plot Number -309, Kakrola Housing Complex First Floor Opposite - Metro Pillar Number - 789 Dwarka New Delhi - 110078 Landmark - Near Gahlot Electrical & Haryana Dairy & Opposite Oppo Service Center",
    "city": "Dwarka",
    "state": "Delhi",
    "pincode": "110078",
    "phone": "9911135585",
    "email": "greenweptechnology@gamil.com"
  },
  {
    "id": 126,
    "name": "Annu Mobile Center (VIS00598)",
    "sc_name": "Annu Mobile Center",
    "sc_code": "VIS00598",
    "address": "Ganpatiplaza Market Chhoti Bazariyapin Code:-476001",
    "city": "Morena",
    "state": "Madhya Pradesh",
    "pincode": "476001",
    "phone": "8823809099",
    "email": "annumobilecenter@yahoo.com"
  },
  {
    "id": 127,
    "name": "Anuraj Communication (VIS00424)",
    "sc_name": "Anuraj Communication",
    "sc_code": "VIS00424",
    "address": "F-3 1st Floor Salasar Plaza Opp. Raisar Plaza, Indira Bazar Jaipur Raj, PIN: 302004",
    "city": "Jaipur",
    "state": "Rajasthan",
    "pincode": "302004",
    "phone": "9314035628",
    "email": "anu.sarotiya@gmail.com"
  },
  {
    "id": 128,
    "name": "Mobizone (VIS00786)",
    "sc_name": "Mobizone",
    "sc_code": "VIS00786",
    "address": "Valanthara Building Pada North Pulliman Jn Karunagapally Kollam Keral 690518",
    "city": "Kollam",
    "state": "Kerala",
    "pincode": "690518",
    "phone": "9567766633",
    "email": "cellcarekarunagapally@gmail.com"
  },
  {
    "id": 129,
    "name": "COMPLETE COMPUTER SOLUTION (VISASP3440)",
    "sc_name": "COMPLETE COMPUTER SOLUTION",
    "sc_code": "VISASP3440",
    "address": "B-3, VISHNU PLAZA, RAILWAY ROAD, HAPUR 245101, Uttar Pradesh, Hapur",
    "city": "Hapur",
    "state": "Uttar Pradesh",
    "pincode": "245101",
    "phone": "9897003153",
    "email": "ccshapur@gmail.com"
  },
  {
    "id": 130,
    "name": "Arman Communication (VISASP2932)",
    "sc_name": "Arman Communication",
    "sc_code": "VISASP2932",
    "address": "Chandra Complex, 1St Floor, Jewel Rock Hotel Road, Durgigudi, Shimoga 577201",
    "city": "Shimoga",
    "state": "Karnataka",
    "pincode": "577201",
    "phone": "9590534310",
    "email": "armancommunication_shimoga@flexcare.in"
  },
  {
    "id": 131,
    "name": "INFINITY SYSTEM (VISASP3391)",
    "sc_name": "INFINITY SYSTEM",
    "sc_code": "VISASP3391",
    "address": "N N DUTTA ROAD, PREMTALA , SILCHAR, CACHAR, ASSAM, PIN: 788001",
    "city": "Cachar",
    "state": "Assam",
    "pincode": "788001",
    "phone": "8638462638",
    "email": "arijit.aditya@infinitysystem.co.in"
  },
  {
    "id": 132,
    "name": "Dey S Mobile (VIS00034)",
    "sc_name": "Dey S Mobile",
    "sc_code": "VIS00034",
    "address": "N.Sroad(Lohapatti) P.O::P.S: Islampur. Dist: Uttar Dinajpur West Bangol, PIN: 733202",
    "city": "Islampur",
    "state": "West Bengal",
    "pincode": "733202",
    "phone": "9064427833",
    "email": "darindam257@gmail.com"
  },
  {
    "id": 133,
    "name": "M/S Suvidh Electronics (VISASP2596)",
    "sc_name": "M/S Suvidh Electronics",
    "sc_code": "VISASP2596",
    "address": "Main Bus Stand, Udhampur 182101",
    "city": "Udhampur",
    "state": "Jammu And Kashmir",
    "pincode": "182101",
    "phone": "6005860558",
    "email": "arjunverma.alone@gmail.com"
  },
  {
    "id": 134,
    "name": "Mahendru Telecom (VIS00426)",
    "sc_name": "Mahendru Telecom",
    "sc_code": "VIS00426",
    "address": "Ofc No 2,2Nd Floor Monika Tower.Milapchownk,Near Company Bagh.Jalandhar, PIN: 144001",
    "city": "Jalandhar",
    "state": "Punjab",
    "pincode": "144001",
    "phone": "9803590001",
    "email": "mahendru.telecom@yahoo.com"
  },
  {
    "id": 135,
    "name": "Nishant Mobile Plaza (VISASP3927)",
    "sc_name": "Nishant Mobile Plaza",
    "sc_code": "VISASP3927",
    "address": "Hakim Dairy Wali Gali Mahadev Naka Near Railway Station Road Morena, PIN: 476001",
    "city": "Morena",
    "state": "Madhya Pradesh",
    "pincode": "476001",
    "phone": "9301365866",
    "email": "nishantmobileplaza@gmail.com"
  },
  {
    "id": 136,
    "name": "Atharv Mobile Bilaspur (VIS01443)",
    "sc_name": "Atharv Mobile Bilaspur",
    "sc_code": "VIS01443",
    "address": "Shop No 109 Jain Plaza C.M.D.Chowk Bilaspur Near Off Appolo City Center (C.G) Ph 9754212504 Pin No : 495001",
    "city": "Bilaspur",
    "state": "Chhattisgarh",
    "pincode": "495001",
    "phone": "9754212504",
    "email": "bittuisfree@gmail.com"
  },
  {
    "id": 137,
    "name": "ASHWANI COMMUNICATION (VISASP3136)",
    "sc_name": "ASHWANI COMMUNICATION",
    "sc_code": "VISASP3136",
    "address": "Office 23 , 10/54 BD Chambers Desh Bandhu Gupta Road Karol Bagh New Delhi 110005",
    "city": "Karol Bagh",
    "state": "Delhi",
    "pincode": "110005",
    "phone": "9999194403",
    "email": "care.ashwanicommunication@gmail.com"
  },
  {
    "id": 138,
    "name": "SHRI RAM ENTERPRISES (VISASP3253)",
    "sc_name": "SHRI RAM ENTERPRISES",
    "sc_code": "VISASP3253",
    "address": "Jarai Tiraha Near Tahir Gas Agency Budaun Raod 244412",
    "city": "Chandausi",
    "state": "Uttar Pradesh",
    "pincode": "244412",
    "phone": "9719563994",
    "email": "allmobipoint@gmail.com"
  },
  {
    "id": 139,
    "name": "Hiya Enterprises (VISASP3389)",
    "sc_name": "Hiya Enterprises",
    "sc_code": "VISASP3389",
    "address": "Shop No. 1&2 First Floor Jannat Market Station Road Ganja Gali Bata Chowk Katihar Bihar 854105, Bihar, Katihar",
    "city": "Katihar",
    "state": "Bihar",
    "pincode": "854105",
    "phone": "9431880010",
    "email": "aavionline@gmail.com"
  },
  {
    "id": 140,
    "name": "Shree Ram Mobile Players (VIS00438)",
    "sc_name": "Shree Ram Mobile Players",
    "sc_code": "VIS00438",
    "address": "Behind Bus Stand,Near Sholi Dharamshala Upside Dtdc Courier Abohar, PIN: 152116",
    "city": "Abohar",
    "state": "Punjab",
    "pincode": "152116",
    "phone": "9888701634",
    "email": "nightviewer@ymail.com"
  },
  {
    "id": 141,
    "name": "Sri Sai Surya Enterprises (VIS01191)",
    "sc_name": "Sri Sai Surya Enterprises",
    "sc_code": "VIS01191",
    "address": "F-9,10,11 Upstair Bangalore Bakery, Mantripragada Vari Complex,Cinema Road,Kakinada, PIN: 533001",
    "city": "Kakinada",
    "state": "Andhra Pradesh",
    "pincode": "533001",
    "phone": "9849440300",
    "email": "srisaisuryaenterpriseskkd@gmail.com"
  },
  {
    "id": 142,
    "name": "SRI JISHNU COMMUNICATIONS (VISASP2553)",
    "sc_name": "SRI JISHNU COMMUNICATIONS",
    "sc_code": "VISASP2553",
    "address": "#28-19-1/1, 1 St Floor,Opp Ratna Bag Showroom, Janda Street, Arundupet,Eluru Road, Vijayawada., Andhrapradesh-52002, PIN: 520002",
    "city": "Vijayawada",
    "state": "Andhra Pradesh",
    "pincode": "520002",
    "phone": "9246511555",
    "email": "sjcommunications.vij@gmail.com"
  },
  {
    "id": 143,
    "name": "Shiv Shakti Service (VIS01167)",
    "sc_name": "Shiv Shakti Service",
    "sc_code": "VIS01167",
    "address": "1 No Babupara, Barpeta Road, PIN: 781315",
    "city": "Barpeta Road",
    "state": "Assam",
    "pincode": "781315",
    "phone": "9706511968",
    "email": "yadavbablu756@gmail.com"
  },
  {
    "id": 144,
    "name": "Tech Solutions (VIS01531)",
    "sc_name": "Tech Solutions",
    "sc_code": "VIS01531",
    "address": "Plot No 7-A. 1st Floor, Opp. Metro Pillar No 120, N. S. Road, Sodala, Jaipur, Rajasthan \u00e2\u20ac\u201c 302019.",
    "city": "Jaipur",
    "state": "Rajasthan",
    "pincode": "302019",
    "phone": "9799338888",
    "email": "techsolutions.vis01531@gmail.com"
  },
  {
    "id": 145,
    "name": "BM Enterprises (VISASP3722)",
    "sc_name": "BM Enterprises",
    "sc_code": "VISASP3722",
    "address": "Shop No:G12, Shreeram Chember, Malbhat Pajifond, Margao, Goa - 403601",
    "city": "South Goa",
    "state": "Goa",
    "pincode": "403601",
    "phone": "9637105402",
    "email": "bmenterprises.margao@gmail.com"
  },
  {
    "id": 146,
    "name": "Shree Gayatri Mobile Sevices (VISASP2490)",
    "sc_name": "Shree Gayatri Mobile Sevices",
    "sc_code": "VISASP2490",
    "address": "1St Floor 1 Motimahal Building Ke Upar, Kille Ki Dhal,Nagaur Rajasthan 341001",
    "city": "Nagaur",
    "state": "Rajasthan",
    "pincode": "341001",
    "phone": "9649447774",
    "email": "blrmgaur@gmail.com"
  },
  {
    "id": 147,
    "name": "Shradha Communication (VISASP2839)",
    "sc_name": "Shradha Communication",
    "sc_code": "VISASP2839",
    "address": "Uttranchal Trade Center Shop No 2 & 3 Tikonia Nainital Road Haldwani - 263139",
    "city": "Haldwani",
    "state": "Uttarakhand",
    "pincode": "263139",
    "phone": "7983216798",
    "email": "philips.haldwani@gmail.com"
  },
  {
    "id": 148,
    "name": "Basharat Electronic (VISASP2715)",
    "sc_name": "Basharat Electronic",
    "sc_code": "VISASP2715",
    "address": "Dist Pulwama Ner Jama Masjid Gangoo Pulwama Pin Code 192301",
    "city": "Pulwama",
    "state": "Jammu And Kashmir",
    "pincode": "192301",
    "phone": "7889856605",
    "email": "abassyawer91@gmail.com"
  },
  {
    "id": 149,
    "name": "Bhagwat Electronics (VISASP2494)",
    "sc_name": "Bhagwat Electronics",
    "sc_code": "VISASP2494",
    "address": "Sai Baba School Ahale, Jawal Hanumagad, Nanded - 431602 (Maharashtra)",
    "city": "Nanded",
    "state": "Maharashtra",
    "pincode": "431602",
    "phone": "7620558192",
    "email": "bhagwatbhagwatelectronics@gmail.com"
  },
  {
    "id": 150,
    "name": "Shivam Enterprise (VIS01364)",
    "sc_name": "Shivam Enterprise",
    "sc_code": "VIS01364",
    "address": "Shop No 9/10 Valadin Plaza Imran Nagar,opp Shoper Stop Silvassa Road Vapi Gujarat ,396191",
    "city": "Vapi",
    "state": "Gujarat",
    "pincode": "396191",
    "phone": "8469999206",
    "email": "shivamenterpriseyuho@gmail.com"
  },
  {
    "id": 151,
    "name": "Hitech Multi Service (VIS01139)",
    "sc_name": "Hitech Multi Service",
    "sc_code": "VIS01139",
    "address": "1St Floor, Artesia, Malkini Mohalla, ,Gaurakashni, Sasaram, Bihar pin-821115, Bihar, Sasaram",
    "city": "Sasaram",
    "state": "Bihar",
    "pincode": "821115",
    "phone": "7004113437",
    "email": "hitechservicesasaram@gmail.com"
  },
  {
    "id": 152,
    "name": "Smart Care (VISASP3216)",
    "sc_name": "Smart Care",
    "sc_code": "VISASP3216",
    "address": "Super Complex Zilla School Motihari 845401 Ph 7250059305",
    "city": "Motihari",
    "state": "Bihar",
    "pincode": "845401",
    "phone": "7250059305",
    "email": "brajkishorsingh780@gmail.com"
  },
  {
    "id": 153,
    "name": "Chandigarh Service Center (VIS00976)",
    "sc_name": "Chandigarh Service Center",
    "sc_code": "VIS00976",
    "address": "121,King Palace ,Football Chowk, PIN: 133001",
    "city": "Ambala Cantt",
    "state": "Haryana",
    "pincode": "133001",
    "phone": "9996004995",
    "email": "chandigarhservicecenter@yahoo.com"
  },
  {
    "id": 154,
    "name": "Maruti Infotech (VIS01270)",
    "sc_name": "Maruti Infotech",
    "sc_code": "VIS01270",
    "address": "#14, 1St Floor, Eregowda Complex, Aralikatte Circle, Salagame Raod, Hassan - Pin 573201",
    "city": "Hassan",
    "state": "Karnataka",
    "pincode": "573201",
    "phone": "9686512353",
    "email": "santhoshballu12353@gmail.com"
  },
  {
    "id": 155,
    "name": "Weather Zone Service Centre (VISASP3071)",
    "sc_name": "Weather Zone Service Centre",
    "sc_code": "VISASP3071",
    "address": "Dm Kothi Road Near Cjm Campus Ara Bhojpur Pin-802301 Ph-9852868877",
    "city": "Ara",
    "state": "Bihar",
    "pincode": "802301",
    "phone": "9852868877",
    "email": "chandramanikumar8401@gmail.com"
  },
  {
    "id": 156,
    "name": "Multiple Mobile Care (VISASP3726)",
    "sc_name": "Multiple Mobile Care",
    "sc_code": "VISASP3726",
    "address": "Sree Gokulam Towers, Door No: 306, 100 Feet Road, Gandhipuram, Coimbatore, PIN: 641012",
    "city": "Coimbatore",
    "state": "Tamil Nadu",
    "pincode": "641012",
    "phone": "9894688345",
    "email": "multiplemobilecare.visasp3726@gmail.com"
  },
  {
    "id": 157,
    "name": "Ambika Telecom (VIS01118)",
    "sc_name": "Ambika Telecom",
    "sc_code": "VIS01118",
    "address": "1ft Floor, Near Post Office, Najo Mall, Opp - Kesariya Colthes, Kamruddinganj, Bihar Sharif, 803101,Bihar Sharif,803101, Bihar, Biharsharif",
    "city": "Biharsharif",
    "state": "Bihar",
    "pincode": "803101",
    "phone": "7780065449",
    "email": "ambika_patna@yahoo.com"
  },
  {
    "id": 158,
    "name": "OINDRILA SERVICES (VISASP3198)",
    "sc_name": "OINDRILA SERVICES",
    "sc_code": "VISASP3198",
    "address": "J.L. NO - 109, KHATIYAN NO - 6108, GANGAJALGHATI, DISTRICT - BANKURA, WEST BENGAL, PIN: 722133",
    "city": "Bankura",
    "state": "West Bengal",
    "pincode": "722133",
    "phone": "9434312703",
    "email": "sinhachiranjit@ymail.com"
  },
  {
    "id": 159,
    "name": "SACT COMMUNICTION (VISASP3291)",
    "sc_name": "SACT COMMUNICTION",
    "sc_code": "VISASP3291",
    "address": "274, 1ST FLOOR GOODSHED STREET, MADURAI 625001",
    "city": "Madurai",
    "state": "Tamil Nadu",
    "pincode": "625001",
    "phone": "9095150007",
    "email": "sactcommunication2016@gmail.com"
  },
  {
    "id": 160,
    "name": "Shree Electronics (VISASP2821)",
    "sc_name": "Shree Electronics",
    "sc_code": "VISASP2821",
    "address": "Behind Pradeep Canteen, Old Income Tax Office Road, Vidyanagar, Hubli-580021",
    "city": "Hubli",
    "state": "Karnataka",
    "pincode": "580021",
    "phone": "9844018837",
    "email": "shree.electronicshubli@gmail.com"
  },
  {
    "id": 161,
    "name": "Shiva Infosys (VIS00174)",
    "sc_name": "Shiva Infosys",
    "sc_code": "VIS00174",
    "address": "1St Flour , Delhi Tent House, Near Don and Dona School, Ghanta Ghr, Shahjapur, Uttar Pradesh, Shahjahanpur, PIN: 242001",
    "city": "Shahjahanpur",
    "state": "Uttar Pradesh",
    "pincode": "242001",
    "phone": "9235193270",
    "email": "shivainfosys1996@gmail.com"
  },
  {
    "id": 162,
    "name": "Raj Electronic (VIS01135)",
    "sc_name": "Raj Electronic",
    "sc_code": "VIS01135",
    "address": "Mahaveer Chowk Bangoan Road Saharsa Bihar , PIN-852201, Bihar, Saharsa",
    "city": "Saharsa",
    "state": "Bihar",
    "pincode": "852201",
    "phone": "9693310010",
    "email": "rajelectronices@gmail.com"
  },
  {
    "id": 163,
    "name": "Nav Durga Telecom (VISASP2723)",
    "sc_name": "Nav Durga Telecom",
    "sc_code": "VISASP2723",
    "address": "NEAR-ASIRWAD HOTEL DR .PREM PUSH LOHIYA KOAT BAZAR WAD NO-15 DIST -SITAMARHI (BIHAR) PIN COAD-843302",
    "city": "Sitamarhi",
    "state": "Bihar",
    "pincode": "843302",
    "phone": "9835040670",
    "email": "deepak.navdurga@gmail.com"
  },
  {
    "id": 164,
    "name": "Anand Mobile Repair (VISASP2704)",
    "sc_name": "Anand Mobile Repair",
    "sc_code": "VISASP2704",
    "address": "Anand Vihar Colony Opp Division No 2 Saili Road Pathankot-145001",
    "city": "Pathankot",
    "state": "Punjab",
    "pincode": "145001",
    "phone": "9855244486",
    "email": "danishmhjn1@gmail.com"
  },
  {
    "id": 165,
    "name": "B R Computer (VIS00407)",
    "sc_name": "B R Computer",
    "sc_code": "VIS00407",
    "address": "B R Computer Ajmeri Gate Sadar Bazar Kekri 305404",
    "city": "Kekri",
    "state": "Rajasthan",
    "pincode": "305404",
    "phone": "8104270266",
    "email": "brcomputerkekri@gmail.com"
  },
  {
    "id": 166,
    "name": "Tanwar Solution (VISASP3053)",
    "sc_name": "Tanwar Solution",
    "sc_code": "VISASP3053",
    "address": "Shop No.3,First Floor,Hariram Market,Bhiwadi Alwar{Rajasthan} 301019",
    "city": "Bhiwadi",
    "state": "Rajasthan",
    "pincode": "301019",
    "phone": "8058920112",
    "email": "tanwarsolution112@gmail.com"
  },
  {
    "id": 167,
    "name": "VASUDHA ENTERPRISES (VISASP2764)",
    "sc_name": "VASUDHA ENTERPRISES",
    "sc_code": "VISASP2764",
    "address": "MANDADE COMPLEX, OPP VISHWA SUPER MARKET , BARSHI ROAD , LATUR 413512",
    "city": "Latur",
    "state": "Maharashtra",
    "pincode": "413512",
    "phone": "8806533777",
    "email": "vasudhaenterprisespatanjali@gmail.com"
  },
  {
    "id": 168,
    "name": "Mishra Brothers (VIS00031)",
    "sc_name": "Mishra Brothers",
    "sc_code": "VIS00031",
    "address": "Beguntary Jalpaiguri, Near Beguntary Post Office West Bengal -735101",
    "city": "Jalpaiguri",
    "state": "West Bengal",
    "pincode": "735101",
    "phone": "9832597959",
    "email": "mishrabrothers8@gmail.com"
  },
  {
    "id": 169,
    "name": "Paradise Communication (VIS00425)",
    "sc_name": "Paradise Communication",
    "sc_code": "VIS00425",
    "address": "6, Raj Complex Near Sbi Atm Nehru Park, Bhawani Mandi Distt- Jhalawar Rajasthan-326502",
    "city": "Bhawani Mandi",
    "state": "Rajasthan",
    "pincode": "326502",
    "phone": "9694130007",
    "email": "bablumicromax@gmail.com"
  },
  {
    "id": 170,
    "name": "Sai Communication (VIS01273)",
    "sc_name": "Sai Communication",
    "sc_code": "VIS01273",
    "address": "Meenakshi Chowk Infront Of SBI Bank First Floor Hoshangabad Pin 461001(M.P.)",
    "city": "Hoshangabad",
    "state": "Madhya Pradesh",
    "pincode": "461001",
    "phone": "9300840810",
    "email": "dineshkumar.soni@yahoo.com"
  },
  {
    "id": 171,
    "name": "Durga Infotech (VISASP3459)",
    "sc_name": "Durga Infotech",
    "sc_code": "VISASP3459",
    "address": "June Pokhar,Kali Rekha B. Deoghar Jharkhand 814112 Ph 6206432766, Jharkhand, Deoghar",
    "city": "Deoghar",
    "state": "Jharkhand",
    "pincode": "814112",
    "phone": "8581076394",
    "email": "durgainfotech7755@gmail.com"
  },
  {
    "id": 172,
    "name": "Fauzia E Solution (VISASP2543)",
    "sc_name": "Fauzia E Solution",
    "sc_code": "VISASP2543",
    "address": "Rath Tiraha Degree Collage Road Maudaha, Uttar Pradesh ,210507",
    "city": "Maudaha",
    "state": "Uttar Pradesh",
    "pincode": "210507",
    "phone": "9125421742",
    "email": "firozkhan00757@gmail.com"
  },
  {
    "id": 173,
    "name": "B G Communications (VIS00839)",
    "sc_name": "B G Communications",
    "sc_code": "VIS00839",
    "address": "G-4, Meridian Guru Plaza,Near Ksrtc Bus Stand ,Bejai,Mangalore, PIN: 575004",
    "city": "Mangalore",
    "state": "Karnataka",
    "pincode": "575004",
    "phone": "8453770228",
    "email": "bgtech09@gmail.com"
  },
  {
    "id": 174,
    "name": "Shriganesh Mobile (VIS01404)",
    "sc_name": "Shriganesh Mobile",
    "sc_code": "VIS01404",
    "address": "panditdeen dayal complx shop n. f13 balaji ward chandani chouk jagdalpur chhattishgarh-494001",
    "city": "Jagadalpur",
    "state": "Chhattisgarh",
    "pincode": "494001",
    "phone": "8103703777",
    "email": "shriganeshmobilejdp@gmail.com"
  },
  {
    "id": 175,
    "name": "Maa Mobile World (VIS00135)",
    "sc_name": "Maa Mobile World",
    "sc_code": "VIS00135",
    "address": "2/158 Balaji Plaza,Upper Anant Bakers,Niranjan Puri,Ramghat Road, PIN: 202001",
    "city": "Aligarh",
    "state": "Uttar Pradesh",
    "pincode": "202001",
    "phone": "9319013000",
    "email": "maamobileworld@gmail.com"
  },
  {
    "id": 176,
    "name": "Balaji Communication (VIS01875)",
    "sc_name": "Balaji Communication",
    "sc_code": "VIS01875",
    "address": "Shop No.30, Purendra Mall (Geeta Talkies) Dabra, MP-475110",
    "city": "Dabra",
    "state": "Madhya Pradesh",
    "pincode": "475110",
    "phone": "9926298462",
    "email": "balajicommunicationdatia2014@gmail.com"
  },
  {
    "id": 177,
    "name": "Siva Micro System (VISASP3360)",
    "sc_name": "Siva Micro System",
    "sc_code": "VISASP3360",
    "address": "2/10, 1st Floor, Vellore City Centre, Anna Salai, Opp. Voohrees School, Vasanthapuram, Kosapet, Vellore, Tamil Nadu-632001",
    "city": "Vellore",
    "state": "Tamil Nadu",
    "pincode": "632001",
    "phone": "8148057705",
    "email": "sivamicrosystem.sms@gmail.com"
  },
  {
    "id": 178,
    "name": "Future Vision (VIS01378)",
    "sc_name": "Future Vision",
    "sc_code": "VIS01378",
    "address": "Rani Rashmoni Nagar , Sodepur-Kolkata-700110, Near- Railway Gate No -8",
    "city": "Kolkata",
    "state": "West Bengal",
    "pincode": "700110",
    "phone": "9331258966",
    "email": "futurevisionsodepur@gmail.com"
  },
  {
    "id": 179,
    "name": "Best IT Enterprise (VIS01328)",
    "sc_name": "Best IT Enterprise",
    "sc_code": "VIS01328",
    "address": "FF-29 Alankar Tower Opp Police Chowki Sayajigunj Vadodara Pin No 390005",
    "city": "Vadodara",
    "state": "Gujarat",
    "pincode": "390005",
    "phone": "9727903897",
    "email": "iball.gufran@gmail.com"
  },
  {
    "id": 180,
    "name": "K.G.N. Mobiles And Computers (VIS00398)",
    "sc_name": "K.G.N. Mobiles And Computers",
    "sc_code": "VIS00398",
    "address": "Shiv Shakti Katla ,Main Market, Lunkaransar, Bikaner, PIN: 334603",
    "city": "Lunkaransar",
    "state": "Rajasthan",
    "pincode": "334603",
    "phone": "9829771606",
    "email": "ukhamid@yahoo.com"
  },
  {
    "id": 181,
    "name": "Sri Global Electronics (VISASP2603)",
    "sc_name": "Sri Global Electronics",
    "sc_code": "VISASP2603",
    "address": "Global Electronics ,First Cross Road 12/1 Arundelpet,Guntur -2,Andhra Pradesh-522002",
    "city": "Guntur",
    "state": "Andhra Pradesh",
    "pincode": "522002",
    "phone": "7842041901",
    "email": "globalelectronicsguntur@gmail.com"
  },
  {
    "id": 182,
    "name": "Hasan Mobile (VIS00554)",
    "sc_name": "Hasan Mobile",
    "sc_code": "VIS00554",
    "address": "Shop No 9 Man Road Atal Complex Jhabua457661",
    "city": "Jhabua",
    "state": "Madhya Pradesh",
    "pincode": "457661",
    "phone": "8085559911",
    "email": "hasanqazi.hq@gmail.com"
  },
  {
    "id": 183,
    "name": "First Service Solution (VISASP2778)",
    "sc_name": "First Service Solution",
    "sc_code": "VISASP2778",
    "address": "South 24 P.G.S Bawali Traker Stand Pin-743384",
    "city": "South 24 Parganas",
    "state": "West Bengal",
    "pincode": "743384",
    "phone": "9874154186",
    "email": "hirok.halder@gmail.com"
  },
  {
    "id": 184,
    "name": "Hrishiyog Mobiles (VIS00645)",
    "sc_name": "Hrishiyog Mobiles",
    "sc_code": "VIS00645",
    "address": "Kulswamini Pl. No. 13(A) Donday Colony, Behind Aadarsha School, Dattamandir, Deopur, Dhule, PIN: 424002",
    "city": "Dhule",
    "state": "Maharashtra",
    "pincode": "424002",
    "phone": "9145362992",
    "email": "hrishikesh.yeole204@gmail.com"
  },
  {
    "id": 185,
    "name": "SKY COLLECTION (VISASP3709)",
    "sc_name": "SKY COLLECTION",
    "sc_code": "VISASP3709",
    "address": "GRU SAI APERTMENT BSIDE SHYAM TAKIES OPP SHIVAJI MAHARAJ PUTLA NANDED 431602",
    "city": "Nanded",
    "state": "Maharashtra",
    "pincode": "431602",
    "phone": "9960041441",
    "email": "skycollectionn@gmail.com"
  },
  {
    "id": 186,
    "name": "Burhani Solution (VISASP2600)",
    "sc_name": "Burhani Solution",
    "sc_code": "VISASP2600",
    "address": "1St Floor Vohra Market Main Bazar Road Deesa 385535",
    "city": "Deesa",
    "state": "Gujarat",
    "pincode": "385535",
    "phone": "9824071740",
    "email": "burhanisolution1@gmail.com"
  },
  {
    "id": 187,
    "name": "MOBI HUB (VIS01249)",
    "sc_name": "MOBI HUB",
    "sc_code": "VIS01249",
    "address": "Shop No 13, Uttam Complex, Ghoda Gadi Stand S T Road, Sanand 382110",
    "city": "Vishnagar",
    "state": "Gujarat",
    "pincode": "382110",
    "phone": "8780403157",
    "email": "smobihub@gmail.com"
  },
  {
    "id": 188,
    "name": "AKSA ENTERPRISES (VISASP3260)",
    "sc_name": "AKSA ENTERPRISES",
    "sc_code": "VISASP3260",
    "address": "1st Floor, Lari Complex, Gayatrinagar, Kasia Road, Infront Of Hotel Sky Lark, Padrauna, Disst- Kushinagar, Uttar Pradesh-274304, Uttar Pradesh, KushiNagar",
    "city": "Kushinagar",
    "state": "Uttar Pradesh",
    "pincode": "274304",
    "phone": "9721259775",
    "email": "altans368@gmail.com"
  },
  {
    "id": 189,
    "name": "Mobile Master (VIS00693)",
    "sc_name": "Mobile Master",
    "sc_code": "VIS00693",
    "address": "Shop No. 201, 2Nd Floor, Padmibai Tower, Opp. Railway Sub Way, Manvel Pada Road, Virar ? East, 401 305 Shop No. 201, 2Nd Floor, Padmibai Tower, Opp. R, PIN: 401305",
    "city": "Virar",
    "state": "Maharashtra",
    "pincode": "401305",
    "phone": "7620186699",
    "email": "mobilemaster266@gmail.com"
  },
  {
    "id": 190,
    "name": "M2 Infocom (VIS01825)",
    "sc_name": "M2 Infocom",
    "sc_code": "VIS01825",
    "address": "1st Floor , NO.D2/1358/1070/22, Punitha Hotel Complex , M C Road Near K S R T C Bustand , Mandya -571401",
    "city": "Mandya",
    "state": "Karnataka",
    "pincode": "571401",
    "phone": "9964844434",
    "email": "irfani56@gmail.com"
  },
  {
    "id": 191,
    "name": "Simran Service Point (VIS01077)",
    "sc_name": "Simran Service Point",
    "sc_code": "VIS01077",
    "address": "Pd 117A/5 Pitampura Delhi, PIN: 110088",
    "city": "Delhi",
    "state": "Delhi",
    "pincode": "110088",
    "phone": "8700080833",
    "email": "simranservicepoint@gmail.com"
  },
  {
    "id": 192,
    "name": "Mobile Care (VIS00672)",
    "sc_name": "Mobile Care",
    "sc_code": "VIS00672",
    "address": "Sunrise Apartment Gadkari Nagar Near Khadka Square Bhusawal-425201",
    "city": "Bhuswal",
    "state": "Maharashtra",
    "pincode": "425201",
    "phone": "9021376999",
    "email": "javed0223@gmail.com"
  },
  {
    "id": 193,
    "name": "Max Enterprises (VIS00732)",
    "sc_name": "Max Enterprises",
    "sc_code": "VIS00732",
    "address": "1/ Riddhi Siddhi Tower, Opp. Bodas Mangal Karyalay, Near Kotak Bank, Dombivli E Thane- 421201",
    "city": "Thane",
    "state": "Maharashtra",
    "pincode": "421201",
    "phone": "9819026625",
    "email": "maxbyond@gmail.com"
  },
  {
    "id": 194,
    "name": "Prompt Service (VIS00081)",
    "sc_name": "Prompt Service",
    "sc_code": "VIS00081",
    "address": "34/A Kalidas Bhattcahrya Lane, Shop N0 -3, Dostilane, Serampore West Bengal - 712201.",
    "city": "Shrerampore",
    "state": "West Bengal",
    "pincode": "712201",
    "phone": "9088809888",
    "email": "promptservice.india@gmail.com"
  },
  {
    "id": 195,
    "name": "Jignesh Computer (VISASP2510)",
    "sc_name": "Jignesh Computer",
    "sc_code": "VISASP2510",
    "address": "131, 1st Floor, Platinum Arcade, Jayshree Road, Junagadh Gujrat 362001",
    "city": "Junagadh",
    "state": "Gujarat",
    "pincode": "362001",
    "phone": "9925403445",
    "email": "jigneshcomputer2007@gmail.com"
  },
  {
    "id": 196,
    "name": "Sai Om Mobile Service (VIS00944)",
    "sc_name": "Sai Om Mobile Service",
    "sc_code": "VIS00944",
    "address": "Address Shop No.11,opp-Hariyana Roadways Workshop, Near-Raghunath Mandir, Main Bus Stand Road 122001",
    "city": "Gurgaon",
    "state": "Haryana",
    "pincode": "122001",
    "phone": "9711975393",
    "email": "saiom2190@gmail.com"
  },
  {
    "id": 197,
    "name": "Simi Communication (VIS00937)",
    "sc_name": "Simi Communication",
    "sc_code": "VIS00937",
    "address": "Shree Complex,Near Hindu Ashram Road, Hp, Nahan,Dist- Sirmour., PIN: 173001",
    "city": "Nahan",
    "state": "Himachal Pradesh",
    "pincode": "173001",
    "phone": "8091940500",
    "email": "mr ityunjoymandal210@gmail.com"
  },
  {
    "id": 198,
    "name": "M.S Tapas Trading (VISASP2579)",
    "sc_name": "M.S Tapas Trading",
    "sc_code": "VISASP2579",
    "address": "At/Po/Via/Ps-Kamarda,Dist-Balasore,Pin-756035",
    "city": "Balasore",
    "state": "Odisha",
    "pincode": "756035",
    "phone": "7735090467",
    "email": "jyotiprakashjena21@gmail.com"
  },
  {
    "id": 199,
    "name": "Sri Shiva Communications (VISASP2904)",
    "sc_name": "Sri Shiva Communications",
    "sc_code": "VISASP2904",
    "address": "Shop No 410, Panchashila Towers 4th Floor, Secunderabad - 500003",
    "city": "Secunderabad",
    "state": "Telangana",
    "pincode": "500003",
    "phone": "9000703030",
    "email": "srishivacommunications6@gmail.com"
  },
  {
    "id": 200,
    "name": "Best Mobiles (VIS01425)",
    "sc_name": "Best Mobiles",
    "sc_code": "VIS01425",
    "address": "Maikanta Tower Opp Town Hall Complex , RP Raod , Tanuku , West Godavari , Andhra Pradesh 534211",
    "city": "West Godavari",
    "state": "Andhra Pradesh",
    "pincode": "534211",
    "phone": "9705557878",
    "email": "bestmobilestnk@gmail.com"
  },
  {
    "id": 201,
    "name": "Mega Electronics (VIS00324)",
    "sc_name": "Mega Electronics",
    "sc_code": "VIS00324",
    "address": "No.2,Gopalapuram Road,Near Akshaya Hospital,Odai Pillayar Koil Stop,Gandhinagar Vellore, PIN: 632006",
    "city": "Vellore",
    "state": "Tamil Nadu",
    "pincode": "632006",
    "phone": "9994283939",
    "email": "meganath05@yahoo.com"
  },
  {
    "id": 202,
    "name": "Sreevani Traders (VIS00495)",
    "sc_name": "Sreevani Traders",
    "sc_code": "VIS00495",
    "address": "New Colony, Hotel Kapilas Lane, Near JMD Bakers, 1st Floor, Khata No 700 And Plot No 1566/2062 MOUZA-Rayagada Nagar, Rayagada. Pin - 765001",
    "city": "Rayagada",
    "state": "Odisha",
    "pincode": "765001",
    "phone": "9778662277",
    "email": "mitragupta@hotmail.com"
  },
  {
    "id": 203,
    "name": "SRI SAI TIRUMALA ELECTRONICS (VIS01420)",
    "sc_name": "SRI SAI TIRUMALA ELECTRONICS",
    "sc_code": "VIS01420",
    "address": "Door No, 4-3-216 To 265 , Jain Market,3rd Floor ,Opp. Gujarati School, Bank Street , Koti, HYDERABAD - 500095",
    "city": "Hyderabad",
    "state": "Telangana",
    "pincode": "500095",
    "phone": "9963377197",
    "email": "vinodsai_009@yahoo.com"
  },
  {
    "id": 204,
    "name": "STJMK Traders (VISASP2830)",
    "sc_name": "STJMK Traders",
    "sc_code": "VISASP2830",
    "address": "88 New Haridwar Colony, Ranipur More, Haridwar - 249401, Uttarakhand, Haridwar",
    "city": "Haridwar",
    "state": "Uttarakhand",
    "pincode": "249401",
    "phone": "7417092998",
    "email": "sl.haridwar@gmail.com"
  },
  {
    "id": 205,
    "name": "JANAK COMMUNICATION (VISASP3728)",
    "sc_name": "JANAK COMMUNICATION",
    "sc_code": "VISASP3728",
    "address": "5K/119 NIT 5 KC CINEMA ROAD OPP BABBAL SWEETS HOUSE FARIDABAD HARYANA, PIN: 121001",
    "city": "Faridabad",
    "state": "Haryana",
    "pincode": "121001",
    "phone": "8750344646",
    "email": "janakcommunication.nokia@gmail.com"
  },
  {
    "id": 206,
    "name": "Lakshmi Communications (VIS00330)",
    "sc_name": "Lakshmi Communications",
    "sc_code": "VIS00330",
    "address": "Aarumga Aacharya Street, Near New Bus Stand, DharmapuriPh-9047419900, PIN: 636701",
    "city": "Dharmapuri",
    "state": "Tamil Nadu",
    "pincode": "636701",
    "phone": "9047419900",
    "email": "karthikdharmapuri16@gmail.com"
  },
  {
    "id": 207,
    "name": "Sai Electronics And Mobile World (VISASP3727)",
    "sc_name": "Sai Electronics And Mobile World",
    "sc_code": "VISASP3727",
    "address": "D-12 Nehru Complex Tp Nagar, PIN: 495677",
    "city": "Korba",
    "state": "Chhattisgarh",
    "pincode": "495677",
    "phone": "9329698076",
    "email": "karuna98076@gmail.com"
  },
  {
    "id": 208,
    "name": "Cell Care Service Center (VISASP2873)",
    "sc_name": "Cell Care Service Center",
    "sc_code": "VISASP2873",
    "address": "Cell Care Service Center Burli Lay Out Near Old Bus Stand Bagalkot-587101",
    "city": "Bagalkot",
    "state": "Karnataka",
    "pincode": "587101",
    "phone": "9036544505",
    "email": "cellcarebgk@gmail.com"
  },
  {
    "id": 209,
    "name": "Sri Vinayaka Services (VISASP3548)",
    "sc_name": "Sri Vinayaka Services",
    "sc_code": "VISASP3548",
    "address": "#5-7-269, Beside Bharath Gas, Near A ToZ Bazar,Fire Station Lane, Nizamabad 503001",
    "city": "Nizamabad",
    "state": "Telangana",
    "pincode": "503001",
    "phone": "8096418321",
    "email": "srivinayaka.nzb@gmail.com"
  },
  {
    "id": 210,
    "name": "S.K.Telecom (VIS00005)",
    "sc_name": "S.K.Telecom",
    "sc_code": "VIS00005",
    "address": "1and2 Govt Colony Makhla Uttarpara Hooghly ,Nwarest - Kanthal Bagan, Bazer Railway Calvert, PIN: 712245",
    "city": "Hooghly",
    "state": "West Bengal",
    "pincode": "712245",
    "phone": "9062722182",
    "email": "sktelecomservice647@gmail.com"
  },
  {
    "id": 211,
    "name": "K.N.Enterprises (VIS01125)",
    "sc_name": "K.N.Enterprises",
    "sc_code": "VIS01125",
    "address": "Dominiya Pul Main Road Bihta Behind Icici Bank, Bihar, Bihta, PIN: 801103",
    "city": "Bihta",
    "state": "Bihar",
    "pincode": "801103",
    "phone": "9386370028",
    "email": "k.n.enterprises6@gmail.com"
  },
  {
    "id": 212,
    "name": "SK. ENTERPISES (VISASP2860)",
    "sc_name": "SK. ENTERPISES",
    "sc_code": "VISASP2860",
    "address": "Near Aysha Masjid,Puhana Road,Puhana Chowk,Post Saliyar,Roorkee-247667, Uttarakhand, Roorkee",
    "city": "Roorkee",
    "state": "Uttarakhand",
    "pincode": "247667",
    "phone": "8273503889",
    "email": "kurbanahmadpuhana8273@gmail.com"
  },
  {
    "id": 213,
    "name": "Aaradhya Telecom (VIS00648)",
    "sc_name": "Aaradhya Telecom",
    "sc_code": "VIS00648",
    "address": "Shop No 110, 1St Floor,New Khokhani Bhavan,Behind Dhuri Hotel,Near Railway Station,Vasai Mh-401202",
    "city": "Vasai",
    "state": "Maharashtra",
    "pincode": "401202",
    "phone": "7387164770",
    "email": "icptelvasai@gmail.com"
  },
  {
    "id": 214,
    "name": "Tragmatics Pvt. Limited (VIS01208)",
    "sc_name": "Tragmatics Pvt. Limited",
    "sc_code": "VIS01208",
    "address": "D.No: 21-1-63, 2Nd Floor, Icici Bank Atm Building, Pedapalli Street, Phoolbaugh Road, Vizianagaram, PIN: 535002",
    "city": "Vijayanagaram",
    "state": "Andhra Pradesh",
    "pincode": "535002",
    "phone": "8922221132",
    "email": "hello@tglhub.com"
  },
  {
    "id": 215,
    "name": "Moula Mobiles And Accessories (VIS01203)",
    "sc_name": "Moula Mobiles And Accessories",
    "sc_code": "VIS01203",
    "address": "Abdullah Khan Estates,Skanda Business Park,3rd Floor Shop No -26,Kurnool 518001 Andhra Pradesh",
    "city": "Kurnool",
    "state": "Andhra Pradesh",
    "pincode": "518001",
    "phone": "9133474713",
    "email": "moulamobiles@gmail.com"
  },
  {
    "id": 216,
    "name": "Shri Ram Balaji Mobile (VIS00372)",
    "sc_name": "Shri Ram Balaji Mobile",
    "sc_code": "VIS00372",
    "address": "Opposite Animal Hospital Baran Raj., PIN: 325205",
    "city": "Baran",
    "state": "Rajasthan",
    "pincode": "325205",
    "phone": "8764475333",
    "email": "tinkumehta.600@rediffmail.com"
  },
  {
    "id": 217,
    "name": "SAI MOBILE CARE (VIS01362)",
    "sc_name": "SAI MOBILE CARE",
    "sc_code": "VIS01362",
    "address": "NO: 6 NS COMPLEX,OMALUR MAIN ROAD, FOUR ROADS, SALEM - 636009",
    "city": "Salem",
    "state": "Tamil Nadu",
    "pincode": "636009",
    "phone": "9944003398",
    "email": "saimobilecare19@gmail.com"
  },
  {
    "id": 218,
    "name": "Arpa Enterprises (VISASP3320)",
    "sc_name": "Arpa Enterprises",
    "sc_code": "VISASP3320",
    "address": "Shop NO, 14,15, Parag Plaza, Near Lokmat Bhavan, Patrakar Chauk, Savedi, Ahmednagar.414003",
    "city": "Ahmednagar",
    "state": "Maharashtra",
    "pincode": "414003",
    "phone": "9145393924",
    "email": "mandarkulkarni@arpaglobal.com"
  },
  {
    "id": 219,
    "name": "A2Z Mobiles (VIS00333)",
    "sc_name": "A2Z Mobiles",
    "sc_code": "VIS00333",
    "address": "No.5A/14,Sundaravinayagar Koil Strret,Near Mahalakshmi Teater,Kallakurichi., PIN: 606202",
    "city": "Kallakurichi",
    "state": "Tamil Nadu",
    "pincode": "606202",
    "phone": "8148615820",
    "email": "kaviraj748@gmail.com"
  },
  {
    "id": 220,
    "name": "Mobile Garden (VISASP2449)",
    "sc_name": "Mobile Garden",
    "sc_code": "VISASP2449",
    "address": "Main Road Mukhiya Pandey Complex Garhwa Near Sbi Main Branch Pin 822114 Ph-9939517948",
    "city": "Garhwa",
    "state": "Jharkhand",
    "pincode": "822114",
    "phone": "9122108128",
    "email": "mobilegardengarhwa@gmail.com"
  },
  {
    "id": 221,
    "name": "Modi Mobile Point (VIS00350)",
    "sc_name": "Modi Mobile Point",
    "sc_code": "VIS00350",
    "address": "Infront Of Dilsukh Tal, Shyam Plaza, Block-11Hindaun City-322230 (Raj.)",
    "city": "Hindaun",
    "state": "Rajasthan",
    "pincode": "322230",
    "phone": "9875057363",
    "email": "rohit.modi01@gmail.com"
  },
  {
    "id": 222,
    "name": "Gorana Mobile (VISASP2503)",
    "sc_name": "Gorana Mobile",
    "sc_code": "VISASP2503",
    "address": "Near Somnath Temple, Rampura Naka, Manasa, Mp- 458110",
    "city": "Manasa",
    "state": "Madhya Pradesh",
    "pincode": "458110",
    "phone": "9926603442",
    "email": "manojgorana888@gmail.com"
  },
  {
    "id": 223,
    "name": "City Business Center (VIS00928)",
    "sc_name": "City Business Center",
    "sc_code": "VIS00928",
    "address": "Nr.Bus Stop Theogshimla-171201",
    "city": "Theog",
    "state": "Himachal Pradesh",
    "pincode": "171201",
    "phone": "9418051128",
    "email": "citybusinesscentertheog@gmail.com"
  },
  {
    "id": 224,
    "name": "Om Mobile Care (VIS00186)",
    "sc_name": "Om Mobile Care",
    "sc_code": "VIS00186",
    "address": "Munu Ganj Narayan Loha Wali Gali Gola Gokrannath Dist.Lakhimpur-Kheri, PIN: 262802",
    "city": "Gola Gokaran Nath",
    "state": "Uttar Pradesh",
    "pincode": "262802",
    "phone": "9889890201",
    "email": "ommobilecare_20@yahoo.in"
  },
  {
    "id": 225,
    "name": "Krishna Typewriter Co. (VIS00160)",
    "sc_name": "Krishna Typewriter Co.",
    "sc_code": "VIS00160",
    "address": "7A, Ist Floor, Palika Market, Gandhi Park, Rampur 244901 (U.P.)",
    "city": "Rampur",
    "state": "Uttar Pradesh",
    "pincode": "244901",
    "phone": "9808292928",
    "email": "krishna_rmp65@yahoo.co.in"
  },
  {
    "id": 226,
    "name": "Smart Service (VIS00025)",
    "sc_name": "Smart Service",
    "sc_code": "VIS00025",
    "address": "SANCHAYAN APARTMENT, GROUND FLOOR G1 2Y/1A HO CHI MINCH SARANI, SANJIB PALLY, BEHALA CHOWRASTA KOLKATA-700034, PIN: 700023",
    "city": "Kolkata",
    "state": "West Bengal",
    "pincode": "700023",
    "phone": "7059907288",
    "email": "smartservic.in@gmail.com"
  },
  {
    "id": 227,
    "name": "M/S Khushi Entrrprises (VISASP2512)",
    "sc_name": "M/S Khushi Entrrprises",
    "sc_code": "VISASP2512",
    "address": "Main Road Phusro Old B.D.O Office Opp. M A Jewellers Dist -Bokaro Pin-829144",
    "city": "Bokaro",
    "state": "Jharkhand",
    "pincode": "829144",
    "phone": "8271483068",
    "email": "salimmatrix1234@gmail.com"
  },
  {
    "id": 228,
    "name": "Lovely Communication (VIS01101)",
    "sc_name": "Lovely Communication",
    "sc_code": "VIS01101",
    "address": "Lal Bazar Potter Gali In Front Of Anchal Vastralaya Bettiah West Chapparan Bihar , Bihar, Bettiah, PIN: 845438",
    "city": "Bettiah",
    "state": "Bihar",
    "pincode": "845438",
    "phone": "9504340786",
    "email": "lovelycommunicationbth@gmail.com"
  },
  {
    "id": 229,
    "name": "Madina Electronics (VIS00284)",
    "sc_name": "Madina Electronics",
    "sc_code": "VIS00284",
    "address": "Paradise Chowmuni,City Center 1St Roon No-43, PIN: 799001",
    "city": "Agartala",
    "state": "Tripura",
    "pincode": "799001",
    "phone": "9774220562",
    "email": "md.mafij@gmail.com"
  },
  {
    "id": 230,
    "name": "Sree Sai Electronics (VISASP2612)",
    "sc_name": "Sree Sai Electronics",
    "sc_code": "VISASP2612",
    "address": "Shop No.08, Stand View Building, Behind S.T Stand , Plot No.394, T.P.S.I, Lokmannya Nagar, Old Panvel-410206.",
    "city": "Raigarh",
    "state": "Maharashtra",
    "pincode": "410206",
    "phone": "9702976393",
    "email": "midhunnair2707@gmail.com"
  },
  {
    "id": 231,
    "name": "Mobitel (VIS00046)",
    "sc_name": "Mobitel",
    "sc_code": "VIS00046",
    "address": "60, Bentinct Street (Opposite Paradise Cinema Hall), PIN: 700069",
    "city": "Kolkata",
    "state": "West Bengal",
    "pincode": "700069",
    "phone": "7044814567",
    "email": "mobitel_care@yahoo.com"
  },
  {
    "id": 232,
    "name": "Hindustan Service (VIS01152)",
    "sc_name": "Hindustan Service",
    "sc_code": "VIS01152",
    "address": "1St Floor, Adarsh Market Near Prem Talkies Shaheed Road Gaya Biharpind-823001",
    "city": "Gaya",
    "state": "Bihar",
    "pincode": "823001",
    "phone": "9504638670",
    "email": "hindustan.gaya@gmail.com"
  },
  {
    "id": 233,
    "name": "AYSHA ELECTRONICS (VISASP4057)",
    "sc_name": "AYSHA ELECTRONICS",
    "sc_code": "VISASP4057",
    "address": "1ST FLOOR RASHEED ENCLAVE NAGAR PALIKA ROAD MUGHAL DARBAR SHOP NO-5 BARABANKI-225001",
    "city": "Barabanki",
    "state": "Uttar Pradesh",
    "pincode": "225001",
    "phone": "9454321068",
    "email": "md.ahmedbbk@gmail.com"
  },
  {
    "id": 234,
    "name": "Kota Mobile (VIS00393)",
    "sc_name": "Kota Mobile",
    "sc_code": "VIS00393",
    "address": "Shop No C-20 , Shoping Center Choupati Road, OPP Bandan Bank Gumanpura, Kota, Rajasthan 324007",
    "city": "Kota",
    "state": "Rajasthan",
    "pincode": "324007",
    "phone": "7726843005",
    "email": "kotamobile1008@gmail.com"
  },
  {
    "id": 235,
    "name": "Pari Mobile Hub (VISASP2589)",
    "sc_name": "Pari Mobile Hub",
    "sc_code": "VISASP2589",
    "address": "Visavkrma Chowk Railway Road Near Sbi Bank Narwana Jind 126116",
    "city": "Narwana",
    "state": "Haryana",
    "pincode": "126116",
    "phone": "9658558000",
    "email": "parimobilehub@gmail.com"
  },
  {
    "id": 236,
    "name": "Vijaypal Telecom (VIS00101)",
    "sc_name": "Vijaypal Telecom",
    "sc_code": "VIS00101",
    "address": "Shop.No 8,Roorkee Talkis Complex,Civil Lines,Roorkee Uk 247667, Uttarakhand, Roorkee",
    "city": "Roorkee",
    "state": "Uttarakhand",
    "pincode": "247667",
    "phone": "9917081567",
    "email": "vijaypaltelecom@hotmail.com"
  },
  {
    "id": 237,
    "name": "Muskan Mobile (VIS01117)",
    "sc_name": "Muskan Mobile",
    "sc_code": "VIS01117",
    "address": "Muskan Mobile, Bhuwan Market, Near Central Bank Of India Donar Chauk Darbhanga Pin-846004 Ph-9570279840",
    "city": "Darbhanga",
    "state": "Bihar",
    "pincode": "846004",
    "phone": "9570279840",
    "email": "ramesh.raman78@gmail.com"
  },
  {
    "id": 238,
    "name": "Suresh Mobility (VIS00806)",
    "sc_name": "Suresh Mobility",
    "sc_code": "VIS00806",
    "address": "old sbm road ward no1,1st cross thathipalya mulbagal 563131",
    "city": "Kolar",
    "state": "Karnataka",
    "pincode": "563131",
    "phone": "9844566108",
    "email": "sureshmobility@gmail.com"
  },
  {
    "id": 239,
    "name": "Sagar Mobile Service (VIS00810)",
    "sc_name": "Sagar Mobile Service",
    "sc_code": "VIS00810",
    "address": "Opp- Jolly Boy, Amlibagh Banglore Road, Bellary, PIN: 583101",
    "city": "Bellary",
    "state": "Karnataka",
    "pincode": "583101",
    "phone": "8392276606",
    "email": "sagarradio_bly@yahoo.co.in"
  },
  {
    "id": 240,
    "name": "A.R.K Telecare India (VIS00804)",
    "sc_name": "A.R.K Telecare India",
    "sc_code": "VIS00804",
    "address": "Vasavi Mahall Cross Road Back Side Vanigotra Complex Chitradurga, PIN: 577501",
    "city": "Chitradurga",
    "state": "Karnataka",
    "pincode": "577501",
    "phone": "9964186283",
    "email": "afrozkhan652@gmail.com"
  },
  {
    "id": 241,
    "name": "Shree Vardhaman Communication (VIS00368)",
    "sc_name": "Shree Vardhaman Communication",
    "sc_code": "VIS00368",
    "address": "Near Bus Stand Chomu, PIN: 303702",
    "city": "Chomu",
    "state": "Rajasthan",
    "pincode": "303702",
    "phone": "9529999956",
    "email": "mukesh.jn23@gmail.com"
  },
  {
    "id": 242,
    "name": "MP Mobile Point (VIS01248)",
    "sc_name": "MP Mobile Point",
    "sc_code": "VIS01248",
    "address": "Jain Katla Kachahri Road Gangapur City Rajasthan-322201",
    "city": "Gangapur City",
    "state": "Rajasthan",
    "pincode": "322201",
    "phone": "9828790853",
    "email": "mukesh2013lemonmobiles@gmail.com"
  },
  {
    "id": 243,
    "name": "Vision Technology (VIS01723)",
    "sc_name": "Vision Technology",
    "sc_code": "VIS01723",
    "address": "1st Floor,Nazib Complex, Opp.Godrej Building,Ulubari,Guwahati-781007",
    "city": "Guwahati",
    "state": "Assam",
    "pincode": "781007",
    "phone": "9954422453",
    "email": "visiontechno2018@gmail.com"
  },
  {
    "id": 244,
    "name": "Royal Mobile Shop (VIS00687)",
    "sc_name": "Royal Mobile Shop",
    "sc_code": "VIS00687",
    "address": "Opp. Ram Rathod Hospital, Near Bus Stand, Vasant Nagar Road, Bk Complex Pusad-445204",
    "city": "Pusad",
    "state": "Maharashtra",
    "pincode": "445204",
    "phone": "9604526006",
    "email": "royalmobileservices1@gmail.com"
  },
  {
    "id": 245,
    "name": "Omega Communications (VIS00326)",
    "sc_name": "Omega Communications",
    "sc_code": "VIS00326",
    "address": "6/10, C.V. Naidu Salai , (Opp) Gnana Vidyalaya School, PIN: 602001",
    "city": "Thiruvallur",
    "state": "Tamil Nadu",
    "pincode": "602001",
    "phone": "9994827956",
    "email": "muraliomega@gmail.com"
  },
  {
    "id": 246,
    "name": "Narendra Mobile Care (VIS00584)",
    "sc_name": "Narendra Mobile Care",
    "sc_code": "VIS00584",
    "address": "Old Bus Stand Shop-4 Near Tiwari Book Stal,Sidhi, PIN: 486661",
    "city": "Sidhi",
    "state": "Madhya Pradesh",
    "pincode": "486661",
    "phone": "9907085555",
    "email": "narendra_smart28@rediffmail.com"
  },
  {
    "id": 247,
    "name": "MOBILINKS (VISASP3611)",
    "sc_name": "MOBILINKS",
    "sc_code": "VISASP3611",
    "address": "Mustaq Complex, Barbar Shah Near Pashan Wear 190001",
    "city": "Srinagar",
    "state": "Jammu And Kashmir",
    "pincode": "190001",
    "phone": "8715000666",
    "email": "contact@mobilinks.co.in"
  },
  {
    "id": 248,
    "name": "Puja Communication (VIS01131)",
    "sc_name": "Puja Communication",
    "sc_code": "VIS01131",
    "address": "Jyoti Complex,Ward No-8,, Room No-05, Khata No-40, Plot No-5/6, Forebesganj, Municipal Area Bihar , 854318, Bihar, Forbesganj",
    "city": "Forbesganj",
    "state": "Bihar",
    "pincode": "854318",
    "phone": "9852277677",
    "email": "kumarnaveen7677@rediffmail.com"
  },
  {
    "id": 249,
    "name": "Nikhil Service (VIS02205)",
    "sc_name": "Nikhil Service",
    "sc_code": "VIS02205",
    "address": "1St Floor,New Bus Stand Road,Ghumarwin Distt. Bilaspur , H.P Pin Code 174021",
    "city": "Bilaspur",
    "state": "Himachal Pradesh",
    "pincode": "174021",
    "phone": "9817284000",
    "email": "nikhilratwan@gmail.com"
  },
  {
    "id": 250,
    "name": "Swamy Mobiles (VIS00823)",
    "sc_name": "Swamy Mobiles",
    "sc_code": "VIS00823",
    "address": "Shop No -01 Pattanshetty Coplex Opp, Sasanur Petrol Bunk, PIN: 587101",
    "city": "Bagalkot",
    "state": "Karnataka",
    "pincode": "587101",
    "phone": "9141885888",
    "email": "swamymobilesbagalkot@gmail.com"
  },
  {
    "id": 251,
    "name": "Nisha Communication (VIS00234)",
    "sc_name": "Nisha Communication",
    "sc_code": "VIS00234",
    "address": "Kanji House Babulal Chauraha Banda -Kanji House Babulal Chauraha Banda -210001",
    "city": "Banda",
    "state": "Uttar Pradesh",
    "pincode": "210001",
    "phone": "8604882225",
    "email": "nishacommunicationbanda@gmail.com"
  },
  {
    "id": 252,
    "name": "Maya Communication (VIS00540)",
    "sc_name": "Maya Communication",
    "sc_code": "VIS00540",
    "address": "Maya Communication Front Of Degamber Jain Mandir Subhash Nager Balaghat Mp 481001",
    "city": "Balaghat",
    "state": "Madhya Pradesh",
    "pincode": "481001",
    "phone": "9826393912",
    "email": "mayacommunication108@gmail.com"
  },
  {
    "id": 253,
    "name": "Shree Saanvi Communications (VISASP2604)",
    "sc_name": "Shree Saanvi Communications",
    "sc_code": "VISASP2604",
    "address": "Shop No.307, 3rd Floor, Panchasheela Towers, Park Lane, Secundrabad - 500003",
    "city": "Secunderabad",
    "state": "Telangana",
    "pincode": "500003",
    "phone": "7702454188",
    "email": "shreesaanvicommunications@gmail.com"
  },
  {
    "id": 254,
    "name": "Applicare Service (VISASP3689)",
    "sc_name": "Applicare Service",
    "sc_code": "VISASP3689",
    "address": "howrah, PIN: 711102",
    "city": "Howrah",
    "state": "West Bengal",
    "pincode": "711102",
    "phone": "8617350990",
    "email": "applicareservice@gmail.com"
  },
  {
    "id": 255,
    "name": "Om Infotech (VIS00885)",
    "sc_name": "Om Infotech",
    "sc_code": "VIS00885",
    "address": "Main Road, Krishna Plaza Market, Near Gandhi Chowk, Pakur, Jharkhand, Pin - 816107",
    "city": "Pakur",
    "state": "Jharkhand",
    "pincode": "816107",
    "phone": "9431194300",
    "email": "balajiservice.pakur@gmail.com"
  },
  {
    "id": 256,
    "name": "Mobile House (VISASP2587)",
    "sc_name": "Mobile House",
    "sc_code": "VISASP2587",
    "address": "Main Road Line Muhalla Chatra Near Rilance Point Pin Code-825401 Ph-7004106291 , Jharkhand, Chatra",
    "city": "Chatra",
    "state": "Jharkhand",
    "pincode": "825401",
    "phone": "7004106292",
    "email": "kashyappankaj668@gmail.com"
  },
  {
    "id": 257,
    "name": "Divya Services (VIS00366)",
    "sc_name": "Divya Services",
    "sc_code": "VIS00366",
    "address": "First Floor, Sanjivani Doctors Complex, Opp Sri Ram Troma Hospital, Near Radhakishanpura Underpass Sikar (Raj), PIN: 332001",
    "city": "Sikar",
    "state": "Rajasthan",
    "pincode": "332001",
    "phone": "8104229180",
    "email": "dpassociats@gmail.com"
  },
  {
    "id": 258,
    "name": "Veer Mobiles (VIS01260)",
    "sc_name": "Veer Mobiles",
    "sc_code": "VIS01260",
    "address": "48/5 Police Station Road, Near: Pillayar Kovil Stop, Sivakasi 626123",
    "city": "Sivakasi",
    "state": "Tamil Nadu",
    "pincode": "626123",
    "phone": "9629286017",
    "email": "veermobiles14@gmail.com"
  },
  {
    "id": 259,
    "name": "B N C Solution (VIS00609)",
    "sc_name": "B N C Solution",
    "sc_code": "VIS00609",
    "address": "Shop No.8 Infront Of Nagar Nigam Circuit House Satna Madhya Pradesh, PIN: 485001",
    "city": "Satna",
    "state": "Madhya Pradesh",
    "pincode": "485001",
    "phone": "7869044100",
    "email": "peyussingh@gmail.com"
  },
  {
    "id": 260,
    "name": "Cell Care (VISASP4026)",
    "sc_name": "Cell Care",
    "sc_code": "VISASP4026",
    "address": "\"Device Care,First Floor, Shop No. 07, Dixit Pride, Dayanand Saraswati Ward, Dixit Pride, OLD Napior Town, Jabalpur, Jabalpur, Madhya Pradesh, 482001,MADHYA PRADESH,482002",
    "city": "Jabalpur",
    "state": "Madhya Pradesh",
    "pincode": "482001",
    "phone": "8770276782",
    "email": "nemaprakhar38@gmail.com"
  },
  {
    "id": 261,
    "name": "Shikha Enterprises (VIS01309)",
    "sc_name": "Shikha Enterprises",
    "sc_code": "VIS01309",
    "address": "A-3/29, First Floor, Sector 5 Rohini, Near Vishram Chowk, Delhi-110085",
    "city": "Rohini",
    "state": "Delhi",
    "pincode": "110085",
    "phone": "9310072681",
    "email": "shikhaenterprisesrohini@gmail.com"
  },
  {
    "id": 262,
    "name": "Siddhivinayak Services (VIS00866)",
    "sc_name": "Siddhivinayak Services",
    "sc_code": "VIS00866",
    "address": "Siddhi Vinayak Services Services Housing Co-operative Society Ltd ,Shop 44 Market Complex,. Ashok Nagar Gat No-3 Argora Ranchi Jharkhand Pin- 834002, Jharkhand, Ranchi",
    "city": "Ranchi",
    "state": "Jharkhand",
    "pincode": "834002",
    "phone": "8936042723",
    "email": "ranchi.iphone@gmail.com"
  },
  {
    "id": 263,
    "name": "Prashyam Infotech (VISASP2862)",
    "sc_name": "Prashyam Infotech",
    "sc_code": "VISASP2862",
    "address": "Mecheda Bust Stsans, 3 No, Mini Market, Kolaghat, Purb Medinipur, City - Purb Medinipur, State - West Bengal, Pincode - 721137",
    "city": "East Medinipur",
    "state": "West Bengal",
    "pincode": "721137",
    "phone": "9153228138",
    "email": "prashyaminfotech@gmail.com"
  },
  {
    "id": 264,
    "name": "Apsara Enterprises (VISASP2658)",
    "sc_name": "Apsara Enterprises",
    "sc_code": "VISASP2658",
    "address": "Apsara Hotel , Near Buxar Railway Station , Station Road , Buxar. Pin-802101 Ph-7870368100 , Bihar, Buxar",
    "city": "Buxar",
    "state": "Bihar",
    "pincode": "802101",
    "phone": "7870368100",
    "email": "apsarabxr@gmail.com"
  },
  {
    "id": 265,
    "name": "JLK Communication (VISASP3267)",
    "sc_name": "JLK Communication",
    "sc_code": "VISASP3267",
    "address": "Sainthia Mohan Bagan More Near Marwari Seva Somity Pin 731234 Birbhum West Bengal",
    "city": "Birbhum",
    "state": "West Bengal",
    "pincode": "731234",
    "phone": "7029993876",
    "email": "lavaservice.sainthia@gmail.com"
  },
  {
    "id": 266,
    "name": "Smart Solution (VIS01421)",
    "sc_name": "Smart Solution",
    "sc_code": "VIS01421",
    "address": "Central Bus Stand,Stall No. 16 Ground Floor, Berhampore , Murshidabad ,Pin Code \u00e2\u20ac\u201c 742101",
    "city": "Murshidabad",
    "state": "West Bengal",
    "pincode": "742101",
    "phone": "9475201116",
    "email": "prosunkumar.nath@gmail.com"
  },
  {
    "id": 267,
    "name": "XCELENCY (VISASP2703)",
    "sc_name": "XCELENCY",
    "sc_code": "VISASP2703",
    "address": "M1, Maruthi Electronic Plaza, 1st Floor, S J P Road Cross,(Opp To Dasappa Hospital Side Gate), Bangalore, Karnataka-560002",
    "city": "Bangalore",
    "state": "Karnataka",
    "pincode": "560002",
    "phone": "9036903183",
    "email": "xcelency@gmail.com"
  },
  {
    "id": 268,
    "name": "Godsons Enterprises (VIS01068)",
    "sc_name": "Godsons Enterprises",
    "sc_code": "VIS01068",
    "address": "G-12 And 12-A, 10/54 , U.G.F. , B.D. Chambersdesh Bandhu Gupta Road, Karol Baghlandmark- Near Karol Bagh Police Station, Opposite Vijay Sales Showroom, PIN: 110005",
    "city": "Karol Bagh",
    "state": "Delhi",
    "pincode": "110005",
    "phone": "9266147147",
    "email": "godsonsenterprises@gmail.com"
  },
  {
    "id": 269,
    "name": "Mobile Point (VIS00480)",
    "sc_name": "Mobile Point",
    "sc_code": "VIS00480",
    "address": "Lal Chowk Anantnag Near Bata Showroom 192101",
    "city": "Anantnag",
    "state": "Jammu And Kashmir",
    "pincode": "192101",
    "phone": "9906826065",
    "email": "sayeed.qazi@gmail.com"
  },
  {
    "id": 270,
    "name": "Sri Kalyani Enterprises (VIS01204)",
    "sc_name": "Sri Kalyani Enterprises",
    "sc_code": "VIS01204",
    "address": "DoorNo - 4-4-173,Shop No.3,KVR Plaza, Near Indira Gandhi Stastue, Nawabpet, Nellore-524002.Andhra Pradesh",
    "city": "Nellore",
    "state": "Andhra Pradesh",
    "pincode": "524002",
    "phone": "8099995052",
    "email": "srikalyanienterprisesnlr@gmail.com"
  },
  {
    "id": 271,
    "name": "Regal Mobile (VIS00662)",
    "sc_name": "Regal Mobile",
    "sc_code": "VIS00662",
    "address": "Shop No.D-5, Iind Floor Golanimarket Jalgaon, PIN: 425001",
    "city": "Jalgaon",
    "state": "Maharashtra",
    "pincode": "425001",
    "phone": "9860460505",
    "email": "mushtaqueregal@gmail.com"
  },
  {
    "id": 272,
    "name": "Care And Cure (VIS00278)",
    "sc_name": "Care And Cure",
    "sc_code": "VIS00278",
    "address": "Opposite Jwalaganj Bus Stand Near Akash Telecom, Peeranpur Road, Fatehpur-212601 , Uttar Pradesh, Fatehpur",
    "city": "Fatehpur",
    "state": "Uttar Pradesh",
    "pincode": "212601",
    "phone": "7905744648",
    "email": "s8756438@gmail.com"
  },
  {
    "id": 273,
    "name": "Madeena Mobile Phone Service (VIS01192)",
    "sc_name": "Madeena Mobile Phone Service",
    "sc_code": "VIS01192",
    "address": "1/813 Yerramukkapalli Circle Railway Station Road, Kadapa, PIN: 516004",
    "city": "Kadapa",
    "state": "Andhra Pradesh",
    "pincode": "516004",
    "phone": "9700876876",
    "email": "syed.rahiman1987@gmail.com"
  },
  {
    "id": 274,
    "name": "Multimedia Mobile Plaza (VIS00032)",
    "sc_name": "Multimedia Mobile Plaza",
    "sc_code": "VIS00032",
    "address": "Vill + Po-Buniadpur , Near New Bus Stand , Ps-Banshihari, PIN: 733121",
    "city": "Buniadpur",
    "state": "West Bengal",
    "pincode": "733121",
    "phone": "9733123940",
    "email": "rakibmmplaza@gmail.com"
  },
  {
    "id": 275,
    "name": "ARIHANT COMPUTER (VISASP3664)",
    "sc_name": "ARIHANT COMPUTER",
    "sc_code": "VISASP3664",
    "address": "Apurva Complex 1st Floor Shop No 3 Opp Sadguru Tirth Dham Complex Raiya Road Rajkot 360007",
    "city": "Rajkot",
    "state": "Gujarat",
    "pincode": "360007",
    "phone": "9327309997",
    "email": "arihant.computer2002@gmail.com"
  },
  {
    "id": 276,
    "name": "Om Computer (VISASP4068)",
    "sc_name": "Om Computer",
    "sc_code": "VISASP4068",
    "address": "Tajpur Road Near V-Mart Samastipur Bihar 848101",
    "city": "Samastipur",
    "state": "Bihar",
    "pincode": "848101",
    "phone": "7463810353",
    "email": "rkrahulom@gmail.com"
  },
  {
    "id": 277,
    "name": "Aarush Infotech Services (VISASP2744)",
    "sc_name": "Aarush Infotech Services",
    "sc_code": "VISASP2744",
    "address": "202B, Indraprastha Tower Wazirpur Ind Area , Delhi-110052",
    "city": "Wazirpur",
    "state": "Delhi",
    "pincode": "110052",
    "phone": "8810477757",
    "email": "aarushinfotechwazirpur@gmail.com"
  },
  {
    "id": 278,
    "name": "M/S - Raj Electronics (VISASP2856)",
    "sc_name": "M/S - Raj Electronics",
    "sc_code": "VISASP2856",
    "address": "City Bus Stand Shopp No 12 Afiya Tower L.I.C Office Road - Kalaburgagi 585105",
    "city": "Kalaburgagi",
    "state": "Karnataka",
    "pincode": "585105",
    "phone": "9342351981",
    "email": "kspgulbarga1@gmail.com"
  },
  {
    "id": 279,
    "name": "Riadham Mobiles (VIS00740)",
    "sc_name": "Riadham Mobiles",
    "sc_code": "VIS00740",
    "address": "61/11240, CK ARCADE, MAVOOR ROAD, BEHIND KANNANKANDY, Kozhikode Kerala-673004 , City:Calicut,",
    "city": "Calicut",
    "state": "Kerala",
    "pincode": "673004",
    "phone": "7012699336",
    "email": "kscridham@gmail.com"
  },
  {
    "id": 280,
    "name": "Royal Communication (VIS01332)",
    "sc_name": "Royal Communication",
    "sc_code": "VIS01332",
    "address": "D.No 11-1-5A 6, Shambhavi Fortune, Near Ksrtc Bus Stand, Moodanidamboor, Udupi,Karnataka. Pin Code -576101",
    "city": "Udupi",
    "state": "Karnataka",
    "pincode": "576101",
    "phone": "9967109717",
    "email": "rajeshmyht007@gmail.com"
  },
  {
    "id": 281,
    "name": "Aditya Service Centre (VIS01105)",
    "sc_name": "Aditya Service Centre",
    "sc_code": "VIS01105",
    "address": "Mukhia Ji Market Station Road Khagaria Bihar , 851204",
    "city": "Khagaria",
    "state": "Bihar",
    "pincode": "851204",
    "phone": "7352075420",
    "email": "adityaservicecentrekhagaria@gmail.com"
  },
  {
    "id": 282,
    "name": "RAJ ENTERPRISES (VISASP3725)",
    "sc_name": "RAJ ENTERPRISES",
    "sc_code": "VISASP3725",
    "address": "SHOP NO 31/32, BAWAL ROAD, SECTOR-1, MODEL TOWN, NEAR CHAWLA CHICKEN, REWARI, HARYANA, 123401.",
    "city": "Rewari",
    "state": "Haryana",
    "pincode": "123401",
    "phone": "7027311512",
    "email": "rajentservices4900@gmail.com"
  },
  {
    "id": 283,
    "name": "SAHA COMMUNICATION (VISASP3202)",
    "sc_name": "SAHA COMMUNICATION",
    "sc_code": "VISASP3202",
    "address": "WARD NO 14, FALAKATA ROAD, DHUPGURI, JALPAIGURI, WEST BENGAL, PIN: 735210",
    "city": "Jalpaiguri",
    "state": "West Bengal",
    "pincode": "735210",
    "phone": "8250790998",
    "email": "rjsaha217@gmail.com"
  },
  {
    "id": 284,
    "name": "R.K.Computer (VIS00257)",
    "sc_name": "R.K.Computer",
    "sc_code": "VIS00257",
    "address": "R.K.COMPUTER Railway Station Road, Near Meat Market Deoria Pin No. 274001 , Uttar Pradesh, Deoria",
    "city": "Deoria",
    "state": "Uttar Pradesh",
    "pincode": "274001",
    "phone": "8604411501",
    "email": "r.k.computer96@gmail.com"
  },
  {
    "id": 285,
    "name": "Ameria Enterprises (VIS00343)",
    "sc_name": "Ameria Enterprises",
    "sc_code": "VIS00343",
    "address": "Avadh Complex,In Front Of Daak Banglow,Near Allahabad Bank, Dausa, Rajasthan, 303303",
    "city": "Dausa",
    "state": "Rajasthan",
    "pincode": "303303",
    "phone": "9587514999",
    "email": "rakeshkhandelwal.83@gmail.com"
  },
  {
    "id": 286,
    "name": "Rakesh Mobile Repairing Centre (VIS02118)",
    "sc_name": "Rakesh Mobile Repairing Centre",
    "sc_code": "VIS02118",
    "address": "Ramji Pardhan Street,Hospital Road Mansa-151505",
    "city": "Mansa",
    "state": "Punjab",
    "pincode": "151505",
    "phone": "9876571551",
    "email": "rmrc.mansa@gmail.com"
  },
  {
    "id": 287,
    "name": "Silicon Computer Services (VISASP2501)",
    "sc_name": "Silicon Computer Services",
    "sc_code": "VISASP2501",
    "address": "Silicon Computer Services\u00c2\u00a0 Sharma Complex Chirwani Road Near Jio Digital Bhtta Bazar Purnea Pin-854301",
    "city": "Purnea",
    "state": "Bihar",
    "pincode": "854301",
    "phone": "7677507027",
    "email": "cco.purnea@gmail.com"
  },
  {
    "id": 288,
    "name": "Mobile Hospital (VIS00890)",
    "sc_name": "Mobile Hospital",
    "sc_code": "VIS00890",
    "address": "Near Ganesh Chitra Mandir Movie Hall , Barharwa, PIN: 816101",
    "city": "Barharwa",
    "state": "Jharkhand",
    "pincode": "816101",
    "phone": "9631392647",
    "email": "radiohospital7@gmail.com"
  },
  {
    "id": 289,
    "name": "Tirupati Telecom (VIS00397)",
    "sc_name": "Tirupati Telecom",
    "sc_code": "VIS00397",
    "address": "2Nd Floor, Above R G B, Station Road, Dholpur , ,Dholpur ,Rajasthan ,328001 ,Indi",
    "city": "Dholpur",
    "state": "Rajasthan",
    "pincode": "328001",
    "phone": "8432631123",
    "email": "ramnathtyagi1003@gmail.com"
  },
  {
    "id": 290,
    "name": "Shri Joga Baba Diamand Mobile (VISASP2687)",
    "sc_name": "Shri Joga Baba Diamand Mobile",
    "sc_code": "VISASP2687",
    "address": "Chordiya Market, Gandi Chouck Merta City Nagaur 341510",
    "city": "Merta City",
    "state": "Rajasthan",
    "pincode": "341510",
    "phone": "6377712717",
    "email": "ram186850@gmail.com"
  },
  {
    "id": 291,
    "name": "COVER HOUSE (VISASP3500)",
    "sc_name": "COVER HOUSE",
    "sc_code": "VISASP3500",
    "address": "Cover House, 1st Floor, Dalmiya Cmplx, Opp Gandhi Maidan, Daltonganj, Palamau JHARKHAND,822101, Jharkhand, Daltonganj",
    "city": "Daltonganj",
    "state": "Jharkhand",
    "pincode": "822101",
    "phone": "7004097523",
    "email": "ranjitchandradaltonganj@gmail.com"
  },
  {
    "id": 292,
    "name": "Bloom Computech (VISASP3068)",
    "sc_name": "Bloom Computech",
    "sc_code": "VISASP3068",
    "address": "Mahila Collage Road Binodpur, Power House , Katihar-854106 Ph-9153103660",
    "city": "Katihar",
    "state": "Bihar",
    "pincode": "854106",
    "phone": "9153103660",
    "email": "bloomkatihar@gmail.com"
  },
  {
    "id": 293,
    "name": "Jain Care Center (VIS00420)",
    "sc_name": "Jain Care Center",
    "sc_code": "VIS00420",
    "address": "Old Bus Stand, Sabji Mandi Road,Ghanthaghar,Tonk-304001",
    "city": "Tonk",
    "state": "Rajasthan",
    "pincode": "304001",
    "phone": "9829501013",
    "email": "ravi.jain565@gmail.com"
  },
  {
    "id": 294,
    "name": "Shyama International (VIS01122)",
    "sc_name": "Shyama International",
    "sc_code": "VIS01122",
    "address": "Karman Tola Waliya Complex Ara Bihar,803101",
    "city": "Ara",
    "state": "Bihar",
    "pincode": "803101",
    "phone": "6201052463",
    "email": "ara.ccoservice@gmail.com"
  },
  {
    "id": 295,
    "name": "R.R. Mobile (VIS00280)",
    "sc_name": "R.R. Mobile",
    "sc_code": "VIS00280",
    "address": "Near Allahbaad Up Grameen Bank Brhamndi Tola Bishwa Sitapur, PIN: 261201",
    "city": "Bishwa",
    "state": "Uttar Pradesh",
    "pincode": "261201",
    "phone": "7607419191",
    "email": "raviseth1441@gmail.com"
  },
  {
    "id": 296,
    "name": "Shri Som Communication (VIS00942)",
    "sc_name": "Shri Som Communication",
    "sc_code": "VIS00942",
    "address": "Near Main Gate Dr. Rajendra Prasad Medical Collage Tanda, Kangra (H.P.) 176001",
    "city": "Kangra",
    "state": "Himachal Pradesh",
    "pincode": "176001",
    "phone": "9418229162",
    "email": "bhabrarinku@gmail.com"
  },
  {
    "id": 297,
    "name": "Chipserve Solution (VIS01402)",
    "sc_name": "Chipserve Solution",
    "sc_code": "VIS01402",
    "address": "F.H Complex B.G Road New Balibat, Above Astha Laboratory, Johat Assam-785001",
    "city": "Jorhat",
    "state": "Assam",
    "pincode": "785001",
    "phone": "7002646002",
    "email": "rytu_chipserve@yahoo.co.in"
  },
  {
    "id": 298,
    "name": "Shri Sai Mobile Repairing (VISASP2481)",
    "sc_name": "Shri Sai Mobile Repairing",
    "sc_code": "VISASP2481",
    "address": "C/O Gopal Market Mussoorie Road ,Chamba, (Dist. Tehri-Garhwal)-249145",
    "city": "Chamba",
    "state": "Uttarakhand",
    "pincode": "249145",
    "phone": "9997873988",
    "email": "kothiyal88@gmail.com"
  },
  {
    "id": 299,
    "name": "Yaksh Enterprises (VIS00413)",
    "sc_name": "Yaksh Enterprises",
    "sc_code": "VIS00413",
    "address": "Shop No. 2 Loda Complex, Meera Nagri, Behind Vinayak Hotal,Chittorgarh, PIN: 312001",
    "city": "Chittorgarh",
    "state": "Rajasthan",
    "pincode": "312001",
    "phone": "9166779393",
    "email": "yakshenterprises23@gmail.com"
  },
  {
    "id": 300,
    "name": "Regal Computer Service (VIS01412)",
    "sc_name": "Regal Computer Service",
    "sc_code": "VIS01412",
    "address": "Office No 1248 South Kasba Behind Old Vithal Mandir Solapur 413007",
    "city": "Solapur",
    "state": "Maharashtra",
    "pincode": "413007",
    "phone": "9881155233",
    "email": "f1asp.solapur@gmail.com"
  },
  {
    "id": 301,
    "name": "NAGA MOBILES (VISASP3132)",
    "sc_name": "NAGA MOBILES",
    "sc_code": "VISASP3132",
    "address": "Surya Nagar, 80 Feet Road , Opposite Mallamma Temple, Anaanthapur -515001",
    "city": "Anantapur",
    "state": "Andhra Pradesh",
    "pincode": "515001",
    "phone": "6301053063",
    "email": "shankarnaga189@gmail.com"
  },
  {
    "id": 302,
    "name": "Celltronix (VIS01857)",
    "sc_name": "Celltronix",
    "sc_code": "VIS01857",
    "address": "No.218,1st Floor 2nd Street, Gandhipuram, Coimbatore 641012",
    "city": "Coimbatore",
    "state": "Tamil Nadu",
    "pincode": "641012",
    "phone": "9894404695",
    "email": "celltronixgsm12@gmail.com"
  },
  {
    "id": 303,
    "name": "Kumar Electronics (VIS01909)",
    "sc_name": "Kumar Electronics",
    "sc_code": "VIS01909",
    "address": "113B,Raja Complex. Opp. PVT Theater,Tirunelveli, Tamilnadu-627001",
    "city": "Tirunelveli",
    "state": "Tamil Nadu",
    "pincode": "627001",
    "phone": "9345939394",
    "email": "sakthi939393@gmail.com"
  },
  {
    "id": 304,
    "name": "Todays Mobile (VISASP2861)",
    "sc_name": "Todays Mobile",
    "sc_code": "VISASP2861",
    "address": "21/4, 2nd Floor, Balaji Complex, Narasingapuram Street, Mount Road, Chennai-600002",
    "city": "Chennai",
    "state": "Tamil Nadu",
    "pincode": "600002",
    "phone": "9003022990",
    "email": "todaysmobilerich@gmail.com"
  },
  {
    "id": 305,
    "name": "Sri Durga Communication (VISASP2749)",
    "sc_name": "Sri Durga Communication",
    "sc_code": "VISASP2749",
    "address": "Dwaraka Plaza, Shope No 1, Beside Flyover Bridge, Mayuri Centre,khammam 507001",
    "city": "Khammam",
    "state": "Telangana",
    "pincode": "507001",
    "phone": "9704412054",
    "email": "sraju260@gmail.com"
  },
  {
    "id": 306,
    "name": "Laxmi Telecare (VIS00707)",
    "sc_name": "Laxmi Telecare",
    "sc_code": "VIS00707",
    "address": "2Nd Floor Icici Bank,Santaji Ward. St. Road Bhandara 441904",
    "city": "Bhandara",
    "state": "Maharashtra",
    "pincode": "441904",
    "phone": "9503446545",
    "email": "sachin_laxmi@hotmail.com"
  },
  {
    "id": 307,
    "name": "Nilawar Mobile Shopee (VIS01770)",
    "sc_name": "Nilawar Mobile Shopee",
    "sc_code": "VIS01770",
    "address": "Jai Hind Chowk , Near Ram Mandir Yavatmal-445001",
    "city": "Yavatmal",
    "state": "Maharashtra",
    "pincode": "445001",
    "phone": "9326664166",
    "email": "nilawar.yavatmal@gmail.com"
  },
  {
    "id": 308,
    "name": "The Mobile ICU (VIS01739)",
    "sc_name": "The Mobile ICU",
    "sc_code": "VIS01739",
    "address": "11, Vinod State Bank Coloney, Near Police Ground, Camp, Amravati 444602 Maharastra",
    "city": "Amravati",
    "state": "Maharashtra",
    "pincode": "444602",
    "phone": "9225504433",
    "email": "sagar.wankhade@gmail.com"
  },
  {
    "id": 309,
    "name": "Aarti Communications (VIS00175)",
    "sc_name": "Aarti Communications",
    "sc_code": "VIS00175",
    "address": "Ground Floor, Behind Sheetla Mata Mandir Flyover Road Maqbara Faizabad,Ayodhya-224001",
    "city": "Ayodhya",
    "state": "Uttar Pradesh",
    "pincode": "224001",
    "phone": "8299290949",
    "email": "aarti.communications224001@gmail.com"
  },
  {
    "id": 310,
    "name": "Friends Mobile Care (VISASP4177)",
    "sc_name": "Friends Mobile Care",
    "sc_code": "VISASP4177",
    "address": "Dehradun Road Malviya Chowk Near Navin Eye Hospital Roorkee Uttarakhand - 247667",
    "city": "Roorkee",
    "state": "Uttarakhand",
    "pincode": "247667",
    "phone": "8439391039",
    "email": "sajidlava@gmail.com"
  },
  {
    "id": 311,
    "name": "Shiv Shakti Mobile Service (VIS00364)",
    "sc_name": "Shiv Shakti Mobile Service",
    "sc_code": "VIS00364",
    "address": "1St Floor, Shop No.-23, Old Talkies, Near Sbi Bank, Sirohi-307001, PIN: 313001",
    "city": "Sirohi",
    "state": "Rajasthan",
    "pincode": "313001",
    "phone": "9783875939",
    "email": "pariharsandeep001@gmail.com"
  },
  {
    "id": 312,
    "name": "SN Technologies (VIS02356)",
    "sc_name": "SN Technologies",
    "sc_code": "VIS02356",
    "address": "27, Western Street, Mini Building ,3rd Floor, Kolkata-700012",
    "city": "Kolkata",
    "state": "West Bengal",
    "pincode": "700012",
    "phone": "9647505122",
    "email": "sntechnologies2021@gmail.com"
  },
  {
    "id": 313,
    "name": "Realtech Computer And Services (VISASP2779)",
    "sc_name": "Realtech Computer And Services",
    "sc_code": "VISASP2779",
    "address": "S-56 Sanjay Complex Jayandraganj Laskar Gwalior 474001",
    "city": "Gwalior",
    "state": "Madhya Pradesh",
    "pincode": "474001",
    "phone": "9300048484",
    "email": "rtc.gwl@gmail.com"
  },
  {
    "id": 314,
    "name": "Mobile Services (VIS01046)",
    "sc_name": "Mobile Services",
    "sc_code": "VIS01046",
    "address": "418, Arihant Complex, Opposite Hari Nagar-1 Main Road Udhana Surat -394210Surat,Gujarat",
    "city": "Surat",
    "state": "Gujarat",
    "pincode": "394210",
    "phone": "9408333327",
    "email": "mobile.service.surat@gmail.com"
  },
  {
    "id": 315,
    "name": "Sanjeev Mobile Point (VIS00271)",
    "sc_name": "Sanjeev Mobile Point",
    "sc_code": "VIS00271",
    "address": "Old Police Chaucki Chauraha,Tamkuhi Road,Khushinagar-274406",
    "city": "Kushinagar",
    "state": "Uttar Pradesh",
    "pincode": "274406",
    "phone": "8853055925",
    "email": "ksanjeev544@gmail.com"
  },
  {
    "id": 316,
    "name": "Maa Gayatri Telecom (VIS00871)",
    "sc_name": "Maa Gayatri Telecom",
    "sc_code": "VIS00871",
    "address": "Plot No- Hf/7, City Center ,Sector-4 , B.S.City,Jharkhand Pin-827004, Jharkhand, Bokaro Steel City",
    "city": "Bokaro Steel City",
    "state": "Jharkhand",
    "pincode": "827004",
    "phone": "9128432006",
    "email": "maagayatritelecombksc@gmail.com"
  },
  {
    "id": 317,
    "name": "Mittal Telecom (VIS02235)",
    "sc_name": "Mittal Telecom",
    "sc_code": "VIS02235",
    "address": "Outside Mori Gate Opp Rajindera Machinery Store Ferozepur City 152002",
    "city": "Ferozepur",
    "state": "Punjab",
    "pincode": "152002",
    "phone": "9855855811",
    "email": "mittaltelecomfzr@gmail.com"
  },
  {
    "id": 318,
    "name": "Niharika Communication (VIS00692)",
    "sc_name": "Niharika Communication",
    "sc_code": "VIS00692",
    "address": "Near Laxmi Sabhahgrah Shankar Nagar Bypass Road ,Chandrapur. MAHARASHTRA-442401, PIN: 442402",
    "city": "Chandrapur",
    "state": "Maharashtra",
    "pincode": "442402",
    "phone": "7020446911",
    "email": "chandrapur.servicecenter@gmail.com"
  },
  {
    "id": 319,
    "name": "Santosh Mobile Repairing (VIS01620)",
    "sc_name": "Santosh Mobile Repairing",
    "sc_code": "VIS01620",
    "address": "swarnkar colony infront of dr neeraj sakti nigam Vidisha,MP pin 464001",
    "city": "Vidisha",
    "state": "Madhya Pradesh",
    "pincode": "464001",
    "phone": "9826528895",
    "email": "santosh.sarathe01@gmail.com"
  },
  {
    "id": 320,
    "name": "Shankari Debi Enterprise (VIS00016)",
    "sc_name": "Shankari Debi Enterprise",
    "sc_code": "VIS00016",
    "address": "Vill+Po-Debinagar ,P.S-Raiganj Near Debinagar Bagha Jatin Park More, U/D West Bengal - 733123",
    "city": "Raiganj",
    "state": "West Bengal",
    "pincode": "733123",
    "phone": "9434601681",
    "email": "santoshrose.sarkar@gmail.com"
  },
  {
    "id": 321,
    "name": "M/S SINGH TELECOM (VISASP3613)",
    "sc_name": "M/S SINGH TELECOM",
    "sc_code": "VISASP3613",
    "address": "Hasnu Market 1st Floor Near ICICI Bank G.T Road Sasaram 821115 Ph 7717777921, Bihar, Saran",
    "city": "Saran",
    "state": "Bihar",
    "pincode": "821115",
    "phone": "7717777921",
    "email": "singhkamaljeet34.sasaram@gmail.com"
  },
  {
    "id": 322,
    "name": "Advance Computer & Technology (VIS01330)",
    "sc_name": "Advance Computer & Technology",
    "sc_code": "VIS01330",
    "address": "115 Eva Complex Opp Gulista Ground Near C.S.M.C.R.I Waghavadi Road Bhavnagar 364001",
    "city": "Bhavnagar",
    "state": "Gujarat",
    "pincode": "364001",
    "phone": "9574183636",
    "email": "satyajitgohil951@gmail.com"
  },
  {
    "id": 323,
    "name": "M/s SN Mobile Center (VIS01266)",
    "sc_name": "M/s SN Mobile Center",
    "sc_code": "VIS01266",
    "address": "R K Complex Ward No-4 , Near Roy Auto Work Shop Barpeta Road, Dist- Barpeta (Assam) Pin- 781315",
    "city": "Barpeta",
    "state": "Assam",
    "pincode": "781315",
    "phone": "9707778109",
    "email": "munnachouhan@gmail.com"
  },
  {
    "id": 324,
    "name": "Agrahari Enterpriese (VIS00277)",
    "sc_name": "Agrahari Enterpriese",
    "sc_code": "VIS00277",
    "address": "Dharmashala Road, Robertsganj Sonbhadra-231216, Uttar Pradesh, Sonebhadara",
    "city": "Sonebhadara",
    "state": "Uttar Pradesh",
    "pincode": "231216",
    "phone": "9555254110",
    "email": "omsai533@gmail.com"
  },
  {
    "id": 325,
    "name": "Arya Enterprises (VISASP2520)",
    "sc_name": "Arya Enterprises",
    "sc_code": "VISASP2520",
    "address": "Lal Chauk Sonar Patti Maa Girja Complex(Nm Zone) Nawada Pin-805110 Ph-9576959327",
    "city": "Nawada",
    "state": "Bihar",
    "pincode": "805110",
    "phone": "9576959327",
    "email": "mithuarya0501@gmail.com"
  },
  {
    "id": 326,
    "name": "M M Mobile Solution (VIS01052)",
    "sc_name": "M M Mobile Solution",
    "sc_code": "VIS01052",
    "address": "Office No. 35, 2nd Floor, Sadguru Tirthdham Complex, Nr. Azad Chowk, Raiya Road, Rajkot - 360007",
    "city": "Rajkot",
    "state": "Gujarat",
    "pincode": "360007",
    "phone": "9228000077",
    "email": "saurabh.madhu@outlook.in"
  },
  {
    "id": 327,
    "name": "Golden Mobile (VISASP2674)",
    "sc_name": "Golden Mobile",
    "sc_code": "VISASP2674",
    "address": "M.G Road Near Nagar Parisad Menka Hall Lohardaga Pin 835302 Mob 9308739430 , Jharkhand, Lohardaga",
    "city": "Lohardaga",
    "state": "Jharkhand",
    "pincode": "835302",
    "phone": "9308739430",
    "email": "isafakansari1990@gmail.com"
  },
  {
    "id": 328,
    "name": "Shubham Commuation (VIS00416)",
    "sc_name": "Shubham Commuation",
    "sc_code": "VIS00416",
    "address": "Near Navjoyti Press Babu Mohala Kaser Gunj Ajmer Pin Code 305001",
    "city": "Ajmer",
    "state": "Rajasthan",
    "pincode": "305001",
    "phone": "9261543327",
    "email": "shubham1581992@gmail.com"
  },
  {
    "id": 329,
    "name": "Gander Electronics and Telecommunication (VIS00565)",
    "sc_name": "Gander Electronics and Telecommunication",
    "sc_code": "VIS00565",
    "address": "H.No. 114/2, Station Road, Near Hotel Sagar, Mandsaur, Madhya Pradesh-, PIN: 458001",
    "city": "Mandsaur",
    "state": "Madhya Pradesh",
    "pincode": "458001",
    "phone": "9907707759",
    "email": "shailugander@gmail.com"
  },
  {
    "id": 330,
    "name": "Varsha Mobile (VIS01087)",
    "sc_name": "Varsha Mobile",
    "sc_code": "VIS01087",
    "address": "Shop 7 Atul Mobile Ke Piche Vip Road Budhwari Bazar Korba, PIN: 495677",
    "city": "Korba",
    "state": "Chhattisgarh",
    "pincode": "495677",
    "phone": "7000356029",
    "email": "varshamoblieshop.korba@gmail.com"
  },
  {
    "id": 331,
    "name": "Sunaniya Electronics (VIS00548)",
    "sc_name": "Sunaniya Electronics",
    "sc_code": "VIS00548",
    "address": "Sunaniya Electronics In Front of Baheti colony ,Station Road, Harda, PIN: 461331",
    "city": "Harda",
    "state": "Madhya Pradesh",
    "pincode": "461331",
    "phone": "8966943254",
    "email": "sunaniyaharda@gmail.com"
  },
  {
    "id": 332,
    "name": "Kbn Care (VIS01199)",
    "sc_name": "Kbn Care",
    "sc_code": "VIS01199",
    "address": "7/62 Near Old Market Chinna Bazer,Tadipatri, PIN: 515411",
    "city": "Tadipatri",
    "state": "Andhra Pradesh",
    "pincode": "515411",
    "phone": "9293929031",
    "email": "shaksha_786@yahoo.co.in"
  },
  {
    "id": 333,
    "name": "Shakir Mobile Care (VIS00207)",
    "sc_name": "Shakir Mobile Care",
    "sc_code": "VIS00207",
    "address": "Shahpura Kothi,Near Micromax And Gionee Care,Nourangabad Rode .Lakhimpur-Kheri,Pin-262701, Uttar Pradesh, Lakhimpur Khiri",
    "city": "Lakhimpur Khiri",
    "state": "Uttar Pradesh",
    "pincode": "262701",
    "phone": "8887664853",
    "email": "shakirmobilecare@gmail.com"
  },
  {
    "id": 334,
    "name": "Friendz Communication (VIS02217)",
    "sc_name": "Friendz Communication",
    "sc_code": "VIS02217",
    "address": "First Floor,1 Shireen Ali Commercial Complex,Iqbal Market,Sopore Pin Code 193201",
    "city": "Sopore",
    "state": "Jammu And Kashmir",
    "pincode": "193201",
    "phone": "7006142221",
    "email": "friendz.tariq@gmail.com"
  },
  {
    "id": 335,
    "name": "King Dot Com (VISASP2489)",
    "sc_name": "King Dot Com",
    "sc_code": "VISASP2489",
    "address": "Chetak Complex Dahod Road Banswara 327001",
    "city": "Banswara",
    "state": "Rajasthan",
    "pincode": "327001",
    "phone": "7891101110",
    "email": "shikharjain108@gmail.com"
  },
  {
    "id": 336,
    "name": "Jangid Mobile & Electronics (VIS01281)",
    "sc_name": "Jangid Mobile & Electronics",
    "sc_code": "VIS01281",
    "address": "Shop No.11-12,1st Floor, Shri Radha Sarveshwar Mandir,Ajmer Road,Madanganj,Kishangarh-305801",
    "city": "Kishangarh",
    "state": "Rajasthan",
    "pincode": "305801",
    "phone": "9950011088",
    "email": "jangidmobiles@yahoo.com"
  },
  {
    "id": 337,
    "name": "Yeshu Care (VIS00856)",
    "sc_name": "Yeshu Care",
    "sc_code": "VIS00856",
    "address": "Yeshu Care New Bus Stand, Bijuliya Talab Road No.3 Ramgarh Cantt Jharkhand-829122 Ph-7209737383, Jharkhand, Ramgarh",
    "city": "Ramgarh",
    "state": "Jharkhand",
    "pincode": "829122",
    "phone": "9693551483",
    "email": "careyeshu@gmsil.com"
  },
  {
    "id": 338,
    "name": "Tulshi Service Centre (VIS01180)",
    "sc_name": "Tulshi Service Centre",
    "sc_code": "VIS01180",
    "address": "Pound Road Ward No 4 P.O, Dist. Dhubri, PIN: 783301",
    "city": "Dhubri",
    "state": "Assam",
    "pincode": "783301",
    "phone": "9859937474",
    "email": "tulshiservicecentre@gmail.com"
  },
  {
    "id": 339,
    "name": "City Care Mobile And Services (VISASP3076)",
    "sc_name": "City Care Mobile And Services",
    "sc_code": "VISASP3076",
    "address": "Main Road Dumwaliya Bagaha -2 Near In Front Of Maszid 845101 Ph-7004011043 , Bihar, Other",
    "city": "Other",
    "state": "Bihar",
    "pincode": "845101",
    "phone": "7004011043",
    "email": "citycarebagaha@gmail.com"
  },
  {
    "id": 340,
    "name": "Dream Land (VIS00092)",
    "sc_name": "Dream Land",
    "sc_code": "VIS00092",
    "address": "Soni Mandir More,Station Road,Mathabhanga,Coochbehar Wb:-736146",
    "city": "Coochbehar",
    "state": "West Bengal",
    "pincode": "736146",
    "phone": "9749075655",
    "email": "djshovon03@gmail.com"
  },
  {
    "id": 341,
    "name": "SUDHARWALA (VISASP2772)",
    "sc_name": "SUDHARWALA",
    "sc_code": "VISASP2772",
    "address": "1st Floor, Jain Battery, Near Navbharat Press, Rajbandha Maidan Road, Mohdapara, Raipur (C.G) 492001",
    "city": "Raipur",
    "state": "Chhattisgarh",
    "pincode": "492001",
    "phone": "8269209086",
    "email": "sudharwala@gmail.com"
  },
  {
    "id": 342,
    "name": "Unitech (VIS00468)",
    "sc_name": "Unitech",
    "sc_code": "VIS00468",
    "address": "2686 First Floor Opp Lal Path Lab Near Fauji Chowk Gt Road Bathinda, PIN: 151001",
    "city": "Bathinda",
    "state": "Punjab",
    "pincode": "151001",
    "phone": "9888008174",
    "email": "unitech47@yahoo.com"
  },
  {
    "id": 343,
    "name": "Singh Service Point (VIS00124)",
    "sc_name": "Singh Service Point",
    "sc_code": "VIS00124",
    "address": "Near Holi Chauraha Gangotri Jalpilibhit ( Up West ), PIN: 262001",
    "city": "Pilibhit",
    "state": "Uttar Pradesh",
    "pincode": "262001",
    "phone": "9528513282",
    "email": "singhservicepoint@gmail.com"
  },
  {
    "id": 344,
    "name": "Bharat Enterprises Services (VIS00194)",
    "sc_name": "Bharat Enterprises Services",
    "sc_code": "VIS00194",
    "address": "Hemaraj Market, Opp. City Kotwali Near Dukhharan Nath Mandir, Station Raod-U.P.-2710001, PIN: 271001",
    "city": "Gonda",
    "state": "Uttar Pradesh",
    "pincode": "271001",
    "phone": "9807794071",
    "email": "bharatenterprisesgonda@gmail.com"
  },
  {
    "id": 345,
    "name": "Shivaji Telecom (VIS00109)",
    "sc_name": "Shivaji Telecom",
    "sc_code": "VIS00109",
    "address": "Near - Pancil Fectory Padampur Road Manpur Kotdwara 276149, PIN: 246149",
    "city": "Kotdwar",
    "state": "Uttarakhand",
    "pincode": "246149",
    "phone": "9997232086",
    "email": "11gourav11@gmail.com"
  },
  {
    "id": 346,
    "name": "S K Mobile Service (VISASP2463)",
    "sc_name": "S K Mobile Service",
    "sc_code": "VISASP2463",
    "address": "K . C Rani Road, Gadag-582101",
    "city": "Gadag",
    "state": "Karnataka",
    "pincode": "582101",
    "phone": "7795665077",
    "email": "sanjeevkhode.sk@gmail.com"
  },
  {
    "id": 347,
    "name": "Rita Enterprse (VISASP4062)",
    "sc_name": "Rita Enterprse",
    "sc_code": "VISASP4062",
    "address": "64/A RAJGANJ MOHALLA,WORD NO-4,KERANIBANDH PAYPASS,BANKURA, PIN: 722101",
    "city": "Bankura",
    "state": "West Bengal",
    "pincode": "722101",
    "phone": "8388840421",
    "email": "ritaenterprise165@gmail.com"
  },
  {
    "id": 348,
    "name": "J.B Mobile (VISASP2883)",
    "sc_name": "J.B Mobile",
    "sc_code": "VISASP2883",
    "address": "NEW LOACTION ADDRESS \u00e2\u20ac\u201c 173, P.C. STREET , BISWAS PARA , 1st FLOOR , NEAR PUNJAB & SIND BANK , RANAGHAT , NADIA , PIN 741201",
    "city": "Ranaghat",
    "state": "West Bengal",
    "pincode": "741201",
    "phone": "7001909098",
    "email": "jbmobile.ranaghat@gmail.com"
  },
  {
    "id": 349,
    "name": "Global Infotech (VIS00282)",
    "sc_name": "Global Infotech",
    "sc_code": "VIS00282",
    "address": "HGB Road Battala Dasamighat Road Opposite Nabadiganata Club Agartala West Tripura,Pin-799001, PIN: 799120",
    "city": "Udaipur",
    "state": "Tripura",
    "pincode": "799120",
    "phone": "9862604846",
    "email": "globalinfotech217@gmail.com"
  },
  {
    "id": 350,
    "name": "Sri Vaishnavi Technologies (VISASP2614)",
    "sc_name": "Sri Vaishnavi Technologies",
    "sc_code": "VISASP2614",
    "address": "Shop No: 15, Mayuri Mall, Kishanpura, Naimnagar, Hanamkonda, Warangal, Telangana - 506001",
    "city": "Warangal",
    "state": "Telangana",
    "pincode": "506001",
    "phone": "9652208812",
    "email": "srivaishnavitechwgl@gmail.com"
  },
  {
    "id": 351,
    "name": "Radhika Telecom (VIS01267)",
    "sc_name": "Radhika Telecom",
    "sc_code": "VIS01267",
    "address": "Pratap Market Near Sai Guest House Cinema Road Golghar,Gorakhpur Uttar Pradesh 273001, Uttar Pradesh, Gorakhpur",
    "city": "Gorakhpur",
    "state": "Uttar Pradesh",
    "pincode": "273001",
    "phone": "9935721812",
    "email": "sudhir.nokia@gmail.com"
  },
  {
    "id": 352,
    "name": "Surya Communication (VIS00086)",
    "sc_name": "Surya Communication",
    "sc_code": "VIS00086",
    "address": "S C Sen Road , Old Police Line Purulia West Bengal -723101",
    "city": "Purulia",
    "state": "West Bengal",
    "pincode": "723101",
    "phone": "9851194444",
    "email": "somuprl@gmail.com"
  },
  {
    "id": 353,
    "name": "Mobile Campus (VIS00493)",
    "sc_name": "Mobile Campus",
    "sc_code": "VIS00493",
    "address": "Mobile Campus 2nd Military Lane In Front Of Tpsodl Seva Kendra Berhampur -760001 Office - 06802220131 PH -7008087058, PIN: 760002",
    "city": "Behrampur",
    "state": "Odisha",
    "pincode": "760002",
    "phone": "7008087058",
    "email": "lgmservicebam@gmail.com"
  },
  {
    "id": 354,
    "name": "Sk Telecom (VIS00658)",
    "sc_name": "Sk Telecom",
    "sc_code": "VIS00658",
    "address": "Shop No.4, Nirankar Apt.,Opp.Idbi Bank, Ambernath (E), PIN: 421501",
    "city": "Ambernath",
    "state": "Maharashtra",
    "pincode": "421501",
    "phone": "7745010890",
    "email": "sk.telecom.karbonn@gmail.com"
  },
  {
    "id": 355,
    "name": "Pooja Enterprises (VISASP3374)",
    "sc_name": "Pooja Enterprises",
    "sc_code": "VISASP3374",
    "address": "1St Floor Today Market Kachahari Chowk Begusarai Pin 851101 Ph 9709782694, Bihar, Begusarai",
    "city": "Begusarai",
    "state": "Bihar",
    "pincode": "851101",
    "phone": "8877369424",
    "email": "sunil.singh22013@gmail.com"
  },
  {
    "id": 356,
    "name": "M/S Balaji Electronics (VIS00254)",
    "sc_name": "M/S Balaji Electronics",
    "sc_code": "VIS00254",
    "address": "Near Agarsen Chawk Chawani Road Bahraich Up East-271801",
    "city": "Bahraich",
    "state": "Uttar Pradesh",
    "pincode": "271801",
    "phone": "8933921243",
    "email": "balaji.bahraich@gmail.com"
  },
  {
    "id": 357,
    "name": "Solanki Telecom (VIS00624)",
    "sc_name": "Solanki Telecom",
    "sc_code": "VIS00624",
    "address": "A-26 ,2Floor In Front Of Bank Of India New Sabji Mandi Harda-461331",
    "city": "Harda",
    "state": "Madhya Pradesh",
    "pincode": "461331",
    "phone": "7000479489",
    "email": "solankitelecom25@gmail.com"
  },
  {
    "id": 358,
    "name": "Om Comunication (VIS00414)",
    "sc_name": "Om Comunication",
    "sc_code": "VIS00414",
    "address": "Naya Bazar , Kothi Road, Nawalgarh, PIN: 333042",
    "city": "Nawalgarh",
    "state": "Rajasthan",
    "pincode": "333042",
    "phone": "9783856144",
    "email": "ntcsis.nawalgarh@gmail.com"
  },
  {
    "id": 359,
    "name": "Purvi Enterprises (VISASP2537)",
    "sc_name": "Purvi Enterprises",
    "sc_code": "VISASP2537",
    "address": "Sagarmal Chowk,Khagaria, Bihar-851204",
    "city": "Khagaria",
    "state": "Bihar",
    "pincode": "851204",
    "phone": "9241441094",
    "email": "purvienterpriseskgg@gmail.com"
  },
  {
    "id": 360,
    "name": "Navya Enterprises (VIS00997)",
    "sc_name": "Navya Enterprises",
    "sc_code": "VIS00997",
    "address": "Sco No.270 B-8 Sector 14 Panchkula Near Jio Office Haryana-134107",
    "city": "Panchkula",
    "state": "Haryana",
    "pincode": "134107",
    "phone": "9988353581",
    "email": "ssardar141@gmail.com"
  },
  {
    "id": 361,
    "name": "Saha Electronics (VIS01900)",
    "sc_name": "Saha Electronics",
    "sc_code": "VIS01900",
    "address": "3/A/24 Royland Circular Road, Serampore,Mahesh Hooghly-712202",
    "city": "Shrerampore",
    "state": "West Bengal",
    "pincode": "712202",
    "phone": "9883195278",
    "email": "swapans641@gmail.com"
  },
  {
    "id": 362,
    "name": "Zadi Technologies (VIS01721)",
    "sc_name": "Zadi Technologies",
    "sc_code": "VIS01721",
    "address": "Madina Shoping Complex Beehama Ganderbal Opposit Pnb Bank Pin: 191201",
    "city": "Ganderbal",
    "state": "Jammu And Kashmir",
    "pincode": "191201",
    "phone": "7006258952",
    "email": "syedferoz8803@gmail.com"
  },
  {
    "id": 363,
    "name": "Rishabh Telecom (VIS00401)",
    "sc_name": "Rishabh Telecom",
    "sc_code": "VIS00401",
    "address": "Shop No-37 First Floor, Inderprasth Complex Delhi Gate Udaipur Rajasthan-313001",
    "city": "Udaipur",
    "state": "Rajasthan",
    "pincode": "313001",
    "phone": "9352585986",
    "email": "rishabhtelecom@gmail.com"
  },
  {
    "id": 364,
    "name": "Sadashiv Telecom (VISASP2528)",
    "sc_name": "Sadashiv Telecom",
    "sc_code": "VISASP2528",
    "address": "Gori Complex Near Khemaka Petrol Pump Nai Sarak Churu 331001",
    "city": "Churu",
    "state": "Rajasthan",
    "pincode": "331001",
    "phone": "7023093003",
    "email": "rajputthansingh900@gmail.com"
  },
  {
    "id": 365,
    "name": "Moulana Mobile Point (VIS00782)",
    "sc_name": "Moulana Mobile Point",
    "sc_code": "VIS00782",
    "address": "Moulana Mobile Point Ubaidulrahiman Oppo Moulanahospital 9745353506,9539669601, PIN: 679322",
    "city": "Perinthalmanna",
    "state": "Kerala",
    "pincode": "679322",
    "phone": "9745353506",
    "email": "moulanamobilepoints@gmail.com"
  },
  {
    "id": 366,
    "name": "GSM Solution (VIS01265)",
    "sc_name": "GSM Solution",
    "sc_code": "VIS01265",
    "address": "N.T. Road, Nalbari ,781335 ( Harimandir Guest House Complex Nalbari Assam-781335 )",
    "city": "Nalbari",
    "state": "Assam",
    "pincode": "781335",
    "phone": "7002210892",
    "email": "gsmsolution.nalbari@gmail.com"
  },
  {
    "id": 367,
    "name": "Simra Enterprises (VIS01827)",
    "sc_name": "Simra Enterprises",
    "sc_code": "VIS01827",
    "address": "First Floor, Nagar Palika Market, Nawabganj, Bareilly- 262406",
    "city": "Bareilly",
    "state": "Uttar Pradesh",
    "pincode": "262406",
    "phone": "9457380786",
    "email": "simra.entnwj@gmail.com"
  },
  {
    "id": 368,
    "name": "New Communication (VIS00614)",
    "sc_name": "New Communication",
    "sc_code": "VIS00614",
    "address": "Plash Market Sachi Road Raisen Dist.- Raisen Mp - 464551",
    "city": "Raisen",
    "state": "Madhya Pradesh",
    "pincode": "464551",
    "phone": "8871374705",
    "email": "pra.spice@gmail.com"
  },
  {
    "id": 369,
    "name": "Luxmi Telecom (VIS00957)",
    "sc_name": "Luxmi Telecom",
    "sc_code": "VIS00957",
    "address": "Laxmi Telecom Shop No.164-Basement Mugal Canal Market,Karnal-132001",
    "city": "Karnal",
    "state": "Haryana",
    "pincode": "132001",
    "phone": "7988812661",
    "email": "vikasknl728@gmail.com"
  },
  {
    "id": 370,
    "name": "ANANTA INFO SERVICES (VISASP3099)",
    "sc_name": "ANANTA INFO SERVICES",
    "sc_code": "VISASP3099",
    "address": "1023, 10th Floor, Hemkunt Chamber, Building No - 89, Nehru Place, New Delhi - 110019",
    "city": "New Delhi",
    "state": "Delhi",
    "pincode": "110019",
    "phone": "9958723328",
    "email": "anantainfoservices@gmail.com"
  },
  {
    "id": 371,
    "name": "Shree Gayatri Mobile (VIS00539)",
    "sc_name": "Shree Gayatri Mobile",
    "sc_code": "VIS00539",
    "address": "Naya Bazar, Sawarkar Chowk Ganj Basoda Mp 464221",
    "city": "Ganj Basoda",
    "state": "Madhya Pradesh",
    "pincode": "464221",
    "phone": "9893406842",
    "email": "vnema30@gmail.com"
  },
  {
    "id": 372,
    "name": "Excel Computer (VIS00188)",
    "sc_name": "Excel Computer",
    "sc_code": "VIS00188",
    "address": "Nai Bazar Chowk Uttar Line Balrmapur ( Up East ), Uttar Pradesh, Balrampur, PIN: 271201",
    "city": "Balrampur",
    "state": "Uttar Pradesh",
    "pincode": "271201",
    "phone": "9838900511",
    "email": "vikashbhartiya009@gmail.com"
  },
  {
    "id": 373,
    "name": "Vivek Communication (VIS01930)",
    "sc_name": "Vivek Communication",
    "sc_code": "VIS01930",
    "address": "Vivek Communication, Indramall Chauraha ,near over bridh , Bhadohi, UP-221401",
    "city": "Bhadohi",
    "state": "Uttar Pradesh",
    "pincode": "221401",
    "phone": "9794985905",
    "email": "vivekkumar200222@gmail.com"
  },
  {
    "id": 374,
    "name": "Tech Solution (VIS00968)",
    "sc_name": "Tech Solution",
    "sc_code": "VIS00968",
    "address": "Shop No.123 1st Floor , Red Cross Market Near South Indian Fast Food , Railway Road, Hisar(125001) Haryana",
    "city": "Hisar",
    "state": "Haryana",
    "pincode": "125001",
    "phone": "9896826726",
    "email": "techsolution.hisar@gmail.com"
  },
  {
    "id": 375,
    "name": "Adinath Mobile And Electronics (VIS00395)",
    "sc_name": "Adinath Mobile And Electronics",
    "sc_code": "VIS00395",
    "address": "Shop No. 126 1St Floor Mangalam Complex ,Opp. Ambe Mata Temple College Road, Banswara, PIN: 327001",
    "city": "Banswara",
    "state": "Rajasthan",
    "pincode": "327001",
    "phone": "9024044004",
    "email": "adinathmobile.mobile@gmail.com"
  },
  {
    "id": 376,
    "name": "Om Sai Teleservices (VIS01104)",
    "sc_name": "Om Sai Teleservices",
    "sc_code": "VIS01104",
    "address": "Bodhman Talab ,Khaira Road,Jamui Bihar , 811307, Bihar, Jamui",
    "city": "Jamui",
    "state": "Bihar",
    "pincode": "811307",
    "phone": "9955599522",
    "email": "virendra.jamui@yahoo.in"
  },
  {
    "id": 377,
    "name": "Sejal Mobile (VIS02365)",
    "sc_name": "Sejal Mobile",
    "sc_code": "VIS02365",
    "address": "Nagar Palika Ke Samne, SBI Bank K Piche, Pokhran, Pin Code 345021",
    "city": "Pokaran",
    "state": "Rajasthan",
    "pincode": "345021",
    "phone": "8764172859",
    "email": "sejalmobpok@gmail.com"
  },
  {
    "id": 378,
    "name": "R M Serrvice Care (VIS00708)",
    "sc_name": "R M Serrvice Care",
    "sc_code": "VIS00708",
    "address": "Dambe Nala,in Front Of Dr.Babasaheb Ambedkar Udyan, Shirur, Maharashtra 412210",
    "city": "Shirpur",
    "state": "Maharashtra",
    "pincode": "412210",
    "phone": "7304733222",
    "email": "salvev288@gmail.com"
  },
  {
    "id": 379,
    "name": "MAA GAYATRI COMMUNICATION (VISASP3574)",
    "sc_name": "MAA GAYATRI COMMUNICATION",
    "sc_code": "VISASP3574",
    "address": "B3 SUPPER SHOPPING CENTER SANJAY GANDHI PURAM FAIZABAD ROAD LKO, PIN: 226016",
    "city": "Lucknow",
    "state": "Uttar Pradesh",
    "pincode": "226016",
    "phone": "9140593174",
    "email": "communicationmaagayatri@gmail.com"
  },
  {
    "id": 380,
    "name": "Shwetha Communuications (VIS00302)",
    "sc_name": "Shwetha Communuications",
    "sc_code": "VIS00302",
    "address": "Shop No:101,102 Vishwanath Complex,Shastri Road,Karimnagar, PIN: 505001",
    "city": "Karimnagar",
    "state": "Telangana",
    "pincode": "505001",
    "phone": "8686196777",
    "email": "swethavishnu.3@gmail.com"
  },
  {
    "id": 381,
    "name": "ANJANA ENTERPRISES (VISASP4037)",
    "sc_name": "ANJANA ENTERPRISES",
    "sc_code": "VISASP4037",
    "address": "Shop 307 ,Second Floor , Aparna Tower , Infornt Of Vikash Bajar ,Mathura, PIN: 281001",
    "city": "Mathura",
    "state": "Uttar Pradesh",
    "pincode": "281001",
    "phone": "8445774273",
    "email": "anjanaenterprises14@gmail.com"
  },
  {
    "id": 382,
    "name": "Ayansh Telecom (VISASP3472)",
    "sc_name": "Ayansh Telecom",
    "sc_code": "VISASP3472",
    "address": "Near-vayapar Mndal Raykatra Main Road Dumraon Buxar Pin-802119 Ph-9507020713, Bihar, Buxar",
    "city": "Buxar",
    "state": "Bihar",
    "pincode": "802119",
    "phone": "9507020713",
    "email": "yamunakumar768@gmail.com"
  },
  {
    "id": 383,
    "name": "Thakur Electronics (VIS01901)",
    "sc_name": "Thakur Electronics",
    "sc_code": "VIS01901",
    "address": "40/2,Thakur Electronics,Middle Bazar,Shimla,Himachal Pradesh-171001",
    "city": "Shimla",
    "state": "Himachal Pradesh",
    "pincode": "171001",
    "phone": "7018071560",
    "email": "dhimanyogesh1981@gmail.com"
  },
  {
    "id": 384,
    "name": "Zenith Emporium (VIS01685)",
    "sc_name": "Zenith Emporium",
    "sc_code": "VIS01685",
    "address": "13 ,radha vallabh market ,near icici bank khargone , MP- 451001",
    "city": "Khargaon",
    "state": "Madhya Pradesh",
    "pincode": "451001",
    "phone": "9826499352",
    "email": "yusuf.spice@gmail.com"
  },
  {
    "id": 385,
    "name": "Nobal Mobile Center (VISASP2465)",
    "sc_name": "Nobal Mobile Center",
    "sc_code": "VISASP2465",
    "address": "Ramkrishna Ganj Near Jain Mandir Khandwa , Mp-450001",
    "city": "Khandwa",
    "state": "Madhya Pradesh",
    "pincode": "450001",
    "phone": "9826778878",
    "email": "abbas_tiger786@yahoo.com"
  },
  {
    "id": 386,
    "name": "Anurag Trader (VISASP3730)",
    "sc_name": "Anurag Trader",
    "sc_code": "VISASP3730",
    "address": "H-1, INDIRA NAGAR, JHUNJHUNU, Jhunjhunu, Rajasthan, 333001",
    "city": "Jhunjhnu",
    "state": "Rajasthan",
    "pincode": "333001",
    "phone": "9828582828",
    "email": "atjhunjhunu@gmail.com"
  },
  {
    "id": 387,
    "name": "New R.K Communication (VISASP2447)",
    "sc_name": "New R.K Communication",
    "sc_code": "VISASP2447",
    "address": "Opp. Of Railway Station,Near At Cycle Stand Barh,Pin -803213 Ph-7004000060 , Bihar, Barh",
    "city": "Barh",
    "state": "Bihar",
    "pincode": "803213",
    "phone": "8804722313",
    "email": "2015rkcommunication@gmail.com"
  },
  {
    "id": 388,
    "name": "RANJAN MOBILE CARE (VIS02015)",
    "sc_name": "RANJAN MOBILE CARE",
    "sc_code": "VIS02015",
    "address": "RADHE SHYAM MARKET, NEAR OM MEDICAL STORE, BADA CHAURAHA, JHINJHAK, KANPUR DEHAT-209302",
    "city": "Jhinjhak",
    "state": "Uttar Pradesh",
    "pincode": "209302",
    "phone": "8173847602",
    "email": "amankushwahajjk47@gmail.com"
  },
  {
    "id": 389,
    "name": "Surabhi Electro Systems (VISASP2918)",
    "sc_name": "Surabhi Electro Systems",
    "sc_code": "VISASP2918",
    "address": "Office No. F - 30, 1st Floor, Silver Pearlss\u00c2\u00a0Building, (Opposite Riddhi Siddhi Hall), Near Indian Oil Petrol Pump, Above\u00c2\u00a0Bhairuvnath\u00c2\u00a0Pav Bhaji Center, Plot No. 1, CTS No. 15735/30/2, Garkheda, Chh. Sambhajinagar - 431005",
    "city": "Aurangabad",
    "state": "Maharashtra",
    "pincode": "431005",
    "phone": "9322924408",
    "email": "surabhielectrosystems@gmail.com"
  },
  {
    "id": 390,
    "name": "Chauhan Sales And Service (VIS02328)",
    "sc_name": "Chauhan Sales And Service",
    "sc_code": "VIS02328",
    "address": "Soun Complax ,Near Nager Palika , Pithoragarh-262501",
    "city": "Pithoragarh",
    "state": "Uttarakhand",
    "pincode": "262501",
    "phone": "9557015380",
    "email": "arjunchauhanpith@gmail.com"
  },
  {
    "id": 391,
    "name": "JBV Communication (VIS02271)",
    "sc_name": "JBV Communication",
    "sc_code": "VIS02271",
    "address": "F-396,F/F,Main Wazirabad Road,Khajoori Khas,North East Delhi, PIN: 110094",
    "city": "Bhajanpura",
    "state": "Delhi",
    "pincode": "110094",
    "phone": "7011768143",
    "email": "jbvcommunication@gmail.com"
  },
  {
    "id": 392,
    "name": "Perfect Services (VISASP3732)",
    "sc_name": "Perfect Services",
    "sc_code": "VISASP3732",
    "address": "SHOP NO 26 1st FLR SAMVED SHIKHAR COMPLEX RAJBANDHA MAIDAN INFRONT OF BJP KARYALAY RAIPUR, CHHATTISGARH - 492001",
    "city": "Raipur",
    "state": "Chhattisgarh",
    "pincode": "492001",
    "phone": "9584460552",
    "email": "perfectcomputer254@gmail.com"
  },
  {
    "id": 393,
    "name": "Nancy Communication (VIS02262)",
    "sc_name": "Nancy Communication",
    "sc_code": "VIS02262",
    "address": "Halwasiya Mall, Shop No. 21 First Floor Hansi Gate, Bhiwani -127021",
    "city": "Bhiwani",
    "state": "Haryana",
    "pincode": "127021",
    "phone": "7206137315",
    "email": "bharat123tanwar@gmail.com"
  },
  {
    "id": 394,
    "name": "M/S AB Associates (VISASP3731)",
    "sc_name": "M/S AB Associates",
    "sc_code": "VISASP3731",
    "address": "M/S AB ASSOCIATES,MATHASAHI, BHADRAK, NEAR SHIV TEMPLE, MATHASAHI, Bhadrak, Odisha, 756100",
    "city": "Bhadrak",
    "state": "Odisha",
    "pincode": "756100",
    "phone": "9778040450",
    "email": "abassociates.bdk02@gmail.com"
  },
  {
    "id": 395,
    "name": "The Mobile Doctor (VISASP2487)",
    "sc_name": "The Mobile Doctor",
    "sc_code": "VISASP2487",
    "address": "The Mobile Doctor, Main Bus Stand Hanumangarh Town Pin Code 335513 Hanumangarth",
    "city": "Hanumangarh",
    "state": "Rajasthan",
    "pincode": "335513",
    "phone": "9783835353",
    "email": "gurpreetsingh22843@gmail.com"
  },
  {
    "id": 396,
    "name": "Nitin Communication (VIS02246)",
    "sc_name": "Nitin Communication",
    "sc_code": "VIS02246",
    "address": "SHOP NO. 467-A/4, NEAR CITY HEART HOTAL AND BUS STAND, WEST COLONY, PANIPAT, PIN: 132103",
    "city": "Panipat",
    "state": "Haryana",
    "pincode": "132103",
    "phone": "9355560001",
    "email": "harshkush86@yahoo.com"
  },
  {
    "id": 397,
    "name": "Kgn Enterprises (VIS02339)",
    "sc_name": "Kgn Enterprises",
    "sc_code": "VIS02339",
    "address": "Shop No 48, Bagat Singh Complex, Near Government Hospitel Shahdol Madhya Pradesh, 484001",
    "city": "Shahdol",
    "state": "Madhya Pradesh",
    "pincode": "484001",
    "phone": "99182 7122",
    "email": "imrankhansdl@gmail.com"
  },
  {
    "id": 398,
    "name": "Yashika Enterprises (VISASP2467)",
    "sc_name": "Yashika Enterprises",
    "sc_code": "VISASP2467",
    "address": "Shop No. 12, Pandit Din Dayal Market, Near By Union Bank , Pratapgarh (Raj.) 312605",
    "city": "Partabgarh",
    "state": "Rajasthan",
    "pincode": "312605",
    "phone": "8003859962",
    "email": "kuldeepchouhan9393@gmail.com"
  },
  {
    "id": 399,
    "name": "My Mobile Care (VISASP2484)",
    "sc_name": "My Mobile Care",
    "sc_code": "VISASP2484",
    "address": "Umed Bhavan Canara Bank Building 2 Floor, Near Sukhwanin Chamber ,Stn Road ,Pimpri Pune 411018",
    "city": "Pune/Pimpri",
    "state": "Maharashtra",
    "pincode": "411018",
    "phone": "9890540020",
    "email": "mymobilecare2014@gmail.com"
  },
  {
    "id": 400,
    "name": "DHEERAJ MOBILE SHOP (VIS02020)",
    "sc_name": "DHEERAJ MOBILE SHOP",
    "sc_code": "VIS02020",
    "address": "NEAR RAILWAY CROSSING, KITHAWAR ROAD, AMETHI, Uttar Pradesh, Amethi, PIN: 227405",
    "city": "Amethi",
    "state": "Uttar Pradesh",
    "pincode": "227405",
    "phone": "9919411018",
    "email": "mohanssia11@gmail.com"
  },
  {
    "id": 401,
    "name": "Cell Heart (VIS02369)",
    "sc_name": "Cell Heart",
    "sc_code": "VIS02369",
    "address": "Cell Heart City Tower Junction Dimapur Nagaland Pin No 797112",
    "city": "Dimapur",
    "state": "Nagaland",
    "pincode": "797112",
    "phone": "9856871609",
    "email": "cellheart.99@gmail.com"
  },
  {
    "id": 402,
    "name": "Nizam Cell Point (VISASP2427)",
    "sc_name": "Nizam Cell Point",
    "sc_code": "VISASP2427",
    "address": "Stall No-3, Ground Floor, Netaji Complex, Bellary Road, Siruguppa 583121",
    "city": "Bellary",
    "state": "Karnataka",
    "pincode": "583121",
    "phone": "9611703785",
    "email": "siruguppa.care@gmail.com"
  },
  {
    "id": 403,
    "name": "Jay Ambe Mobile House (VIS00688)",
    "sc_name": "Jay Ambe Mobile House",
    "sc_code": "VIS00688",
    "address": "GUJARI AREA, BEHIND VIKAS KAPADA BAZAR, DESAIGANJ WADSA 441207",
    "city": "Wadsa",
    "state": "Maharashtra",
    "pincode": "441207",
    "phone": "9422364379",
    "email": "manapurenitesh@gmail.com"
  },
  {
    "id": 404,
    "name": "Shreyas Empire (VIS00899)",
    "sc_name": "Shreyas Empire",
    "sc_code": "VIS00899",
    "address": "VATIKA COMPLEX, NEAR BLOCK CHOWK,BIJULIYA, RAMGARH-829122, JHARKHAND",
    "city": "Ramgarh",
    "state": "Jharkhand",
    "pincode": "829122",
    "phone": "9835516642",
    "email": "service.shreyasempire@gmail.com"
  },
  {
    "id": 405,
    "name": "STRENGTH SERVICES PRIVATE LIMITED (VISASP2740)",
    "sc_name": "STRENGTH SERVICES PRIVATE LIMITED",
    "sc_code": "VISASP2740",
    "address": "WA 88 SHAKARPUR ABOVE ICICI BANK, Laxmi Nagar, Delhi-110092",
    "city": "Delhi",
    "state": "Delhi",
    "pincode": "110092",
    "phone": "9958401112",
    "email": "strengthservicesdelhi@gmail.com"
  },
  {
    "id": 406,
    "name": "Swaraj Electronics (VIS01473)",
    "sc_name": "Swaraj Electronics",
    "sc_code": "VIS01473",
    "address": "Shop No. 20, Kailash Complex Station Road, Near H. P Ghose Petrol Pumo, Samastipur, Bihar Pin-848101 Ph-8873359773 Mail-rajsrivastava82@gmail.com, Bihar, Samastipur",
    "city": "Samastipur",
    "state": "Bihar",
    "pincode": "848101",
    "phone": "8873359773",
    "email": "rajsrivastava82@gmail.com"
  },
  {
    "id": 407,
    "name": "Tarafdar Infosys (VISASP2426)",
    "sc_name": "Tarafdar Infosys",
    "sc_code": "VISASP2426",
    "address": "Room No 34 ,Friends Union Market, Gulmohar ,Balurghat , South Dinajpur -733101",
    "city": "Balurghat",
    "state": "West Bengal",
    "pincode": "733101",
    "phone": "9614194387",
    "email": "rajendradas900@gmail.com"
  },
  {
    "id": 408,
    "name": "Bhai Computer (VIS02230)",
    "sc_name": "Bhai Computer",
    "sc_code": "VIS02230",
    "address": "Shop No.Oa-8 Chhattisgarh Complex,Teliphone Exchange Road Bilaspur Chhattisgarh Pin Coad No.495001",
    "city": "Bilaspur",
    "state": "Chhattisgarh",
    "pincode": "495001",
    "phone": "9303998817",
    "email": "bhaicomputer@gmail.com"
  },
  {
    "id": 409,
    "name": "Square Enterprises (VISASP3758)",
    "sc_name": "Square Enterprises",
    "sc_code": "VISASP3758",
    "address": "Square Enterprises,NEAR TODERMAL PETROL PUMP, MADHAV CHOWK SHIVPURI Madhya Pradesh-473552",
    "city": "Shivpuri",
    "state": "Madhya Pradesh",
    "pincode": "473552",
    "phone": "9200509200",
    "email": "squareenterprises2015@gmail.com"
  },
  {
    "id": 410,
    "name": "M.S. Solution And Service (VISASP3729)",
    "sc_name": "M.S. Solution And Service",
    "sc_code": "VISASP3729",
    "address": "Marwaripatty, A.T Road, Near Chapter One Caf\u00c3\u00a9-Nagaon-782001",
    "city": "Nagaon",
    "state": "Assam",
    "pincode": "782001",
    "phone": "8638669742",
    "email": "m.s.solutionandservice@gmail.com"
  },
  {
    "id": 411,
    "name": "Telport (VISASP3812)",
    "sc_name": "Telport",
    "sc_code": "VISASP3812",
    "address": "C99, 5th Cross, West Thillai Nagar, Tiruchirappalli, Tamilnadu-620018",
    "city": "Tiruchirappalli",
    "state": "Tamil Nadu",
    "pincode": "620018",
    "phone": "9942254445",
    "email": "telport_nokiacare@yahoo.co.in"
  },
  {
    "id": 412,
    "name": "MegaHertz Technologies (VIS01569)",
    "sc_name": "MegaHertz Technologies",
    "sc_code": "VIS01569",
    "address": "1st Floor, Shop No 10, Pawan Bela Market, Court Road, OPP ITO, Saharanpur, Uttar Pradesh, India, Pin 247001",
    "city": "Saharanpur",
    "state": "Uttar Pradesh",
    "pincode": "247001",
    "phone": "7248870006",
    "email": "megahertzservice@yahoo.com"
  },
  {
    "id": 413,
    "name": "Sheikh Services (VIS02177)",
    "sc_name": "Sheikh Services",
    "sc_code": "VIS02177",
    "address": "Kp Road , Hista Higher Secondary Lane , Kp Road , Anantnag Pin Code 192101",
    "city": "Anantnag",
    "state": "Jammu And Kashmir",
    "pincode": "192101",
    "phone": "7006053591",
    "email": "sheikhjalees@gmail.com"
  },
  {
    "id": 414,
    "name": "Ultimate Technical Solutions (VISASP2483)",
    "sc_name": "Ultimate Technical Solutions",
    "sc_code": "VISASP2483",
    "address": "5 No, Uttar Ramkrishna Pally, Durgapur, Paschim Bardhaman, West Bengal, 713213",
    "city": "Durgapur",
    "state": "West Bengal",
    "pincode": "713213",
    "phone": "8250544403",
    "email": "utsdgp@outlook.com"
  },
  {
    "id": 415,
    "name": "SM Technologies (VISASP2440)",
    "sc_name": "SM Technologies",
    "sc_code": "VISASP2440",
    "address": "No.143, First Floor, Beside Indian Clinic, Gangamma Gudi Road, 1St Cross, M.V Extension, Hoskote - 562114",
    "city": "Hoskote",
    "state": "Karnataka",
    "pincode": "562114",
    "phone": "9738001155",
    "email": "smtechnologieshosakote@gmail.com"
  },
  {
    "id": 416,
    "name": "Doriya Communications (VIS01716)",
    "sc_name": "Doriya Communications",
    "sc_code": "VIS01716",
    "address": "Shop No B18,Bothra Complex,Modern Market,Bikaner - 334001",
    "city": "Bikaner",
    "state": "Rajasthan",
    "pincode": "334001",
    "phone": "8619639196",
    "email": "doriyacommunications@gmail.com"
  },
  {
    "id": 417,
    "name": "Service At One Call (VISASP3347)",
    "sc_name": "Service At One Call",
    "sc_code": "VISASP3347",
    "address": "Infront Of Nautanwa Tahsil Banailiya Mata Mandir Road Nautanwa Maharajganj , Pin Code-273164, Uttar Pradesh, Nautanwa",
    "city": "Nautanwa",
    "state": "Uttar Pradesh",
    "pincode": "273164",
    "phone": "9354236280",
    "email": "serviceatonecall@gmail.com"
  },
  {
    "id": 418,
    "name": "Technocare (VISASP3922)",
    "sc_name": "Technocare",
    "sc_code": "VISASP3922",
    "address": "172 Pitamber Nagar Ground Floor Unnao,Uttar Pradesh, , Uttar Pradesh, Unnao, PIN: 209801",
    "city": "Unnao",
    "state": "Uttar Pradesh",
    "pincode": "209801",
    "phone": "6307424784",
    "email": "vishnu.gupta452@gmail.com"
  },
  {
    "id": 419,
    "name": "Ambe Services (VISASP3749)",
    "sc_name": "Ambe Services",
    "sc_code": "VISASP3749",
    "address": "Plot 6 A, Bapu Nagar Senthi West, Infront Of Government Sawariya Hospital, Main Udaipur Road, Chittorgarh, Rajasthan, 312001",
    "city": "Chittorgarh",
    "state": "Rajasthan",
    "pincode": "312001",
    "phone": "9828140725",
    "email": "vishnu_mundra@rediffmail.com"
  },
  {
    "id": 420,
    "name": "Saachi Services (VIS02372)",
    "sc_name": "Saachi Services",
    "sc_code": "VIS02372",
    "address": "1287, 1St Floor Arihant Plaza, 25Th Main Road, Jayanagar 9Th Block Above Poorvika Mobiles ,560069",
    "city": "Bangalore",
    "state": "Karnataka",
    "pincode": "560069",
    "phone": "8884021435",
    "email": "saachiservices22@gmail.com"
  },
  {
    "id": 421,
    "name": "Aspire Solutions (VIS01766)",
    "sc_name": "Aspire Solutions",
    "sc_code": "VIS01766",
    "address": "Aspire Solutions Near Municipal Office Calicut Road, Manjeri Malappuram, Kerala. PIN 676121",
    "city": "Manjeri",
    "state": "Kerala",
    "pincode": "676121",
    "phone": "7012002134",
    "email": "aspiremanjeri@gmail.com"
  },
  {
    "id": 422,
    "name": "Om Enterprise (VIS01652)",
    "sc_name": "Om Enterprise",
    "sc_code": "VIS01652",
    "address": "Near Chachi Misti Bhandar Rahalane , Asansol , 713303",
    "city": "Asansol",
    "state": "West Bengal",
    "pincode": "713303",
    "phone": "9775313551",
    "email": "omenterprise.asansol@gmail.com"
  },
  {
    "id": 423,
    "name": "Sahar Communication (VISASP2943)",
    "sc_name": "Sahar Communication",
    "sc_code": "VISASP2943",
    "address": "Sahar Communication, Sindus, Near Axis Bank, Aart Road, Kannur 670001",
    "city": "Kannur",
    "state": "Kerala",
    "pincode": "670001",
    "phone": "8848013094",
    "email": "saharinfrastructure@gmail.com"
  },
  {
    "id": 424,
    "name": "Maruti Enterprises (VIS01911)",
    "sc_name": "Maruti Enterprises",
    "sc_code": "VIS01911",
    "address": "Sikandra Road, Akbarpur ,Kanpur Dehat Pin-209101 , Uttar Pradesh, Akbarpur",
    "city": "Akbarpur",
    "state": "Uttar Pradesh",
    "pincode": "209101",
    "phone": "8736030414",
    "email": "maruti.akbarpur@gmail.com"
  },
  {
    "id": 425,
    "name": "Chirawa Telecommunication (VIS01518)",
    "sc_name": "Chirawa Telecommunication",
    "sc_code": "VIS01518",
    "address": "Neelkanth complex,Opp.SBI Bank,Pilani Road,Chirawa (Jhunjhunu)Raj-333026",
    "city": "Chirawa",
    "state": "Rajasthan",
    "pincode": "333026",
    "phone": "9887299786",
    "email": "chirawatelecommunication@gmail.com"
  },
  {
    "id": 426,
    "name": "Gayatri Enterprises (VIS02125)",
    "sc_name": "Gayatri Enterprises",
    "sc_code": "VIS02125",
    "address": "4 A, Dutt Apartment, Sneh Vihar, New Swami Dayanand Saraswati Ward, Napier Town, Jabalpur, M.P-482001",
    "city": "Jabalpur",
    "state": "Madhya Pradesh",
    "pincode": "482001",
    "phone": "7000834492",
    "email": "rishabhjaiswal209@gmail.com"
  },
  {
    "id": 427,
    "name": "Maa Vashnavi Traders (VIS01912)",
    "sc_name": "Maa Vashnavi Traders",
    "sc_code": "VIS01912",
    "address": "Ram Katha Marg Shop No 3 Maya Bazar Mahoba 210427",
    "city": "Mahoba",
    "state": "Uttar Pradesh",
    "pincode": "210427",
    "phone": "7007502889",
    "email": "ashishshivhare9@gmail.com"
  },
  {
    "id": 428,
    "name": "Telemart Mobile (VIS02228)",
    "sc_name": "Telemart Mobile",
    "sc_code": "VIS02228",
    "address": "At-Rairang Pur (Golai W.N-6 Infront Of Bank Of India Main Branch) Dist-Mayurbhanj-757043",
    "city": "Rairangpur",
    "state": "Odisha",
    "pincode": "757043",
    "phone": "9439214487",
    "email": "tapaskumarsamal1985@gmail.com"
  },
  {
    "id": 429,
    "name": "Maa Durga Mobile & Electronic Service Centre (VIS01969)",
    "sc_name": "Maa Durga Mobile & Electronic Service Centre",
    "sc_code": "VIS01969",
    "address": "khatra koralir more(near girls high school),khatra ,khatra, bankura ,722140",
    "city": "Bankura",
    "state": "West Bengal",
    "pincode": "722140",
    "phone": "9332574448",
    "email": "chandranathbid@gmail.com"
  },
  {
    "id": 430,
    "name": "Rakshya Telecom (VISASP2480)",
    "sc_name": "Rakshya Telecom",
    "sc_code": "VISASP2480",
    "address": "Mahaveer Work Shop Ke Pichhe, Kachha Bus Stand City :- Sardarshahar Pin Code:- 331403",
    "city": "Sardar Sahar",
    "state": "Rajasthan",
    "pincode": "331403",
    "phone": "9664450072",
    "email": "rakshyatelecomsrdr@gmail.com"
  },
  {
    "id": 431,
    "name": "Mahavir It Sales & Services (VIS01504)",
    "sc_name": "Mahavir It Sales & Services",
    "sc_code": "VIS01504",
    "address": "Shop No.57, Old Cannaught Place Near Capri Trade Centre Chakrata Road Dehradun Uttrakhand -248001 , Uttarakhand, Dehradun",
    "city": "Dehradun",
    "state": "Uttarakhand",
    "pincode": "248001",
    "phone": "9808603635",
    "email": "dv_rawat@yahoo.co.in"
  },
  {
    "id": 432,
    "name": "Sri Amman Enterprises (VIS02218)",
    "sc_name": "Sri Amman Enterprises",
    "sc_code": "VIS02218",
    "address": "No,28/29 Rahamath Complex , Trichy Main Road, Villupuram, Tamilnadu,605602",
    "city": "Villupuram",
    "state": "Tamil Nadu",
    "pincode": "605602",
    "phone": "9790133162",
    "email": "sriamman162@gmail.com"
  },
  {
    "id": 433,
    "name": "Sri Ganesh Enterprises (VIS02215)",
    "sc_name": "Sri Ganesh Enterprises",
    "sc_code": "VIS02215",
    "address": "1St Floor Shop No-25 Gaya Munda Complex Main Road Khunti (Jharkhand) Pin-835210 Ph 9304772293 , Jharkhand, Khunti",
    "city": "Khunti",
    "state": "Jharkhand",
    "pincode": "835210",
    "phone": "9304772293",
    "email": "goutammandal222@gmail.com"
  },
  {
    "id": 434,
    "name": "Swetha Cell Point (VIS01564)",
    "sc_name": "Swetha Cell Point",
    "sc_code": "VIS01564",
    "address": "116B,SS Complex,BLDEA Road Bijapur, PIN: 586101",
    "city": "Bijapur",
    "state": "Karnataka",
    "pincode": "586101",
    "phone": "9686610006",
    "email": "se.bijapur@gmail.com"
  },
  {
    "id": 435,
    "name": "Innovative Techsoft (VIS01847)",
    "sc_name": "Innovative Techsoft",
    "sc_code": "VIS01847",
    "address": "Bxx-2813,3Rd Floor,Ranjit Tower,Near Hdfc Bank,Pakhowal Road,Ludhiana-141002",
    "city": "Ludhiana",
    "state": "Punjab",
    "pincode": "141002",
    "phone": "9781355224",
    "email": "dlinkcare.ludhiana@gmail.com"
  },
  {
    "id": 436,
    "name": "Chhabra Electronics (VIS01586)",
    "sc_name": "Chhabra Electronics",
    "sc_code": "VIS01586",
    "address": "Gurudwara Complex,School Road Ambikapur (C.G) Pin-497001",
    "city": "Ambikapur",
    "state": "Chhattisgarh",
    "pincode": "497001",
    "phone": "9826624461",
    "email": "chhabraservices@gmail.com"
  },
  {
    "id": 437,
    "name": "Mobile Service Point (VIS01754)",
    "sc_name": "Mobile Service Point",
    "sc_code": "VIS01754",
    "address": "Opp Rana Pratap School Melaghat Road Khatima U.S.Nagar 262308 Uttarakhand, Uttarakhand, Khatima",
    "city": "Khatima",
    "state": "Uttarakhand",
    "pincode": "262308",
    "phone": "9837947428",
    "email": "asc.khatima2008@gmail.com"
  },
  {
    "id": 438,
    "name": "The Best Service (VIS02127)",
    "sc_name": "The Best Service",
    "sc_code": "VIS02127",
    "address": "AK Building, Behind Radhika Uniform, The Best Service, Freeganj, Ujjain, Madhya Pradesh., PIN: 456010",
    "city": "Ujjain",
    "state": "Madhya Pradesh",
    "pincode": "456010",
    "phone": "9171974862",
    "email": "thebestserviceujjain@gmail.com"
  },
  {
    "id": 439,
    "name": "Technominds Mobile (VIS02254)",
    "sc_name": "Technominds Mobile",
    "sc_code": "VIS02254",
    "address": "Shop: 106 , Mobile Markit , Palika Bazzar ,Fatehabad (125050)",
    "city": "Fatehabad",
    "state": "Haryana",
    "pincode": "125050",
    "phone": "9996073731",
    "email": "technominds@hotmail.com"
  },
  {
    "id": 440,
    "name": "Mou Telecom (VIS01708)",
    "sc_name": "Mou Telecom",
    "sc_code": "VIS01708",
    "address": "Bandhgora Saroda Sagar Par , Bolpur , Birbhum - 731204",
    "city": "Bhirbhum",
    "state": "West Bengal",
    "pincode": "731204",
    "phone": "8759323232",
    "email": "kalikantakamat@gmail.com"
  },
  {
    "id": 441,
    "name": "Shivam Communiucation (VIS02285)",
    "sc_name": "Shivam Communiucation",
    "sc_code": "VIS02285",
    "address": "Shop No 305 Gireraj Complax Opp Pnb Bank Cinma Road Mahendergarh 123029",
    "city": "Mahendragarh",
    "state": "Haryana",
    "pincode": "123029",
    "phone": "9992221310",
    "email": "shivam.hemanshi@gmail.com"
  },
  {
    "id": 442,
    "name": "Ruhi Telecom (VIS01778)",
    "sc_name": "Ruhi Telecom",
    "sc_code": "VIS01778",
    "address": "Ruhi Telecom, Off No 103, 1st Floor , B-Wing , Jay Ambedham Co-Op HSG, Above Chandrika Jewellers, Near Hanuman Mandir Patel Chowk, Ghtkopar East Mumbai 400077",
    "city": "Ghatkopar",
    "state": "Maharashtra",
    "pincode": "400077",
    "phone": "9769530707",
    "email": "ruhitelecom07@yahoo.com"
  },
  {
    "id": 443,
    "name": "Mahesh Electronics (VIS02263)",
    "sc_name": "Mahesh Electronics",
    "sc_code": "VIS02263",
    "address": "Phul Bazar , Nr. Mandir Wali Gali, Rampura Phul Distic Bathinda Pin 151103",
    "city": "Rampura Phul",
    "state": "Punjab",
    "pincode": "151103",
    "phone": "9041708508",
    "email": "maheshelectronics45222@gmail.com"
  },
  {
    "id": 444,
    "name": "OM MOBILE REPAIRING CENTERE (VISASP4231)",
    "sc_name": "OM MOBILE REPAIRING CENTERE",
    "sc_code": "VISASP4231",
    "address": "Om Mobile Repairing Centere Anu Near Degree Co 177005",
    "city": "Hamirpur",
    "state": "Himachal Pradesh",
    "pincode": "177005",
    "phone": "7018225389",
    "email": "omchauhanhmr@gmail.com"
  },
  {
    "id": 445,
    "name": "Dipti Enterprises (VISASP2414)",
    "sc_name": "Dipti Enterprises",
    "sc_code": "VISASP2414",
    "address": "Civil Lines Ward No 21 Near Dr.rashmi Hospital Maharajganj 273303",
    "city": "Maharajganj",
    "state": "Uttar Pradesh",
    "pincode": "273303",
    "phone": "8090044600",
    "email": "manoj_verma44@yahoo.com"
  },
  {
    "id": 446,
    "name": "Azad Communication (VIS01889)",
    "sc_name": "Azad Communication",
    "sc_code": "VIS01889",
    "address": "S14/25 B4 Andharapull Near City Garden lown Varanasi 221001, Uttar Pradesh, Varanasi",
    "city": "Varanasi",
    "state": "Uttar Pradesh",
    "pincode": "221001",
    "phone": "9118005200",
    "email": "azadmrj0@gmail.com"
  },
  {
    "id": 447,
    "name": "Shyam Enterprises (VIS01524)",
    "sc_name": "Shyam Enterprises",
    "sc_code": "VIS01524",
    "address": "Surbhi Complex, Sagar Shoroom Ke Piche Near Taparia Bagichi, Station Road Sikar 332001",
    "city": "Sikar",
    "state": "Rajasthan",
    "pincode": "332001",
    "phone": "8107060080",
    "email": "shyamenterprises51@gmail.com"
  },
  {
    "id": 448,
    "name": "Yash Associates (VIS01916)",
    "sc_name": "Yash Associates",
    "sc_code": "VIS01916",
    "address": "Opp.Roop Garden Najfgarh Road, Bahadurhgarh ,Near Of Shiv Chok,124507",
    "city": "Bahadurgarh",
    "state": "Haryana",
    "pincode": "124507",
    "phone": "7982231191",
    "email": "nareshsaroha87@gmail.com"
  },
  {
    "id": 449,
    "name": "Cell Service (VIS01931)",
    "sc_name": "Cell Service",
    "sc_code": "VIS01931",
    "address": "Ff/1, Shivalik, Opp. Bank Of Baroda, Near Ahmedabad Central Mall, Panchavati, Ambawadi, Ahmedabad -380006",
    "city": "Ahmedabad",
    "state": "Gujarat",
    "pincode": "380006",
    "phone": "9879883338",
    "email": "cell.ahmedabad240208@gmail.com"
  },
  {
    "id": 450,
    "name": "Gita Mobiles Service Point (VIS02358)",
    "sc_name": "Gita Mobiles Service Point",
    "sc_code": "VIS02358",
    "address": "B.S. Road, Natun Bazar Chowpathi ,Near Sagar Hotel, Cooch Behar-736101",
    "city": "Coochbehar",
    "state": "West Bengal",
    "pincode": "736101",
    "phone": "7866974812",
    "email": "gitamobilesarvice.cob@gmail.com"
  },
  {
    "id": 451,
    "name": "Unique Mobiles (VIS02324)",
    "sc_name": "Unique Mobiles",
    "sc_code": "VIS02324",
    "address": "15-306,First Floor, Bsrr Complex, Indira Bhavan Road,Nellore-524001",
    "city": "Nellore",
    "state": "Andhra Pradesh",
    "pincode": "524001",
    "phone": "9700625001",
    "email": "uniquemobilesnellore@gmail.com"
  },
  {
    "id": 452,
    "name": "Maxx Mobile Com (VIS01573)",
    "sc_name": "Maxx Mobile Com",
    "sc_code": "VIS01573",
    "address": "4-5 Bherugat Pani Darwaja Road Pali Pin-306401",
    "city": "Pali",
    "state": "Rajasthan",
    "pincode": "306401",
    "phone": "9672222768",
    "email": "sharma21670@gmail.com"
  },
  {
    "id": 453,
    "name": "Sri Sai Services (VIS02197)",
    "sc_name": "Sri Sai Services",
    "sc_code": "VIS02197",
    "address": "Gandhi Chowk ,Near Honda Showroom Rajdhanwar Jharkhand Pin-825412 Mob:-9110996144 , Jharkhand, Rajdhanwar",
    "city": "Rajdhanwar",
    "state": "Jharkhand",
    "pincode": "825412",
    "phone": "9110996144",
    "email": "pawan.ravani20@gmail.com"
  },
  {
    "id": 454,
    "name": "It Point (VIS02042)",
    "sc_name": "It Point",
    "sc_code": "VIS02042",
    "address": "1St Floor,Khan Building,S.C.Sen Road.Purulia ,Pin-723101,West Bengal",
    "city": "Purulia",
    "state": "West Bengal",
    "pincode": "723101",
    "phone": "9775471860",
    "email": "itpoint_purulia@rediffmail.com"
  },
  {
    "id": 455,
    "name": "MY Services (VIS01831)",
    "sc_name": "MY Services",
    "sc_code": "VIS01831",
    "address": "7, KAMLA NAGAR GULAB BAGH ROAD , NEAR SINDHI DHARMSHALA Opp. Hotel ACE Udaipur (Rajasthan) -313001",
    "city": "Udaipur",
    "state": "Rajasthan",
    "pincode": "313001",
    "phone": "9782989722",
    "email": "myservices@microbs.net"
  },
  {
    "id": 456,
    "name": "M/S Suchi Enterprises (VIS01987)",
    "sc_name": "M/S Suchi Enterprises",
    "sc_code": "VIS01987",
    "address": "Shop No. 231 Dariyapur Road Khairabad Sultanpur-228001",
    "city": "Kadipur",
    "state": "Uttar Pradesh",
    "pincode": "228001",
    "phone": "9795632798",
    "email": "durgeshy386@gmail.com"
  },
  {
    "id": 457,
    "name": "C.K. Traders (VIS01561)",
    "sc_name": "C.K. Traders",
    "sc_code": "VIS01561",
    "address": "F-7 First Floor Amar Plza Complex Opp.Daulat Bagh Ajmer -305001(Raj.)",
    "city": "Ajmer",
    "state": "Rajasthan",
    "pincode": "305001",
    "phone": "9351052341",
    "email": "cktraders104@gmail.com"
  },
  {
    "id": 458,
    "name": "Ravi Telecom (VIS01932)",
    "sc_name": "Ravi Telecom",
    "sc_code": "VIS01932",
    "address": "1St Floor, Shop Bearing No.11, E.M.-248,, Phagwara Gate, Jalandhar, Punjab, 144004",
    "city": "Jalandhar",
    "state": "Punjab",
    "pincode": "144004",
    "phone": "9815763913",
    "email": "ravitelecom@yahoo.in"
  },
  {
    "id": 459,
    "name": "M M Enterprises (VIS02316)",
    "sc_name": "M M Enterprises",
    "sc_code": "VIS02316",
    "address": "Olandganj, Near J P Hotel, Jaunpur 222002",
    "city": "Jaunpur",
    "state": "Uttar Pradesh",
    "pincode": "222002",
    "phone": "7379912345",
    "email": "mmenterprisesjnp18@gmail.com"
  },
  {
    "id": 460,
    "name": "T.S. Enterprises (VIS01551)",
    "sc_name": "T.S. Enterprises",
    "sc_code": "VIS01551",
    "address": "Malik Mau , Chhota Ghosiyana ,Raebareli -229001, Uttar Pradesh, Raebareli",
    "city": "Raebareli",
    "state": "Uttar Pradesh",
    "pincode": "229001",
    "phone": "9305131874",
    "email": "shashankkumar4051@gmail.com"
  },
  {
    "id": 461,
    "name": "Guru Kripa Associates (VIS01675)",
    "sc_name": "Guru Kripa Associates",
    "sc_code": "VIS01675",
    "address": "Shop N 102 Huda Market Sector 3 ,Faridbad, Pin Code 121004",
    "city": "Faridabad",
    "state": "Haryana",
    "pincode": "121004",
    "phone": "7836800605",
    "email": "rs530599@gmail.com"
  },
  {
    "id": 462,
    "name": "Shanvi Communication (VIS01952)",
    "sc_name": "Shanvi Communication",
    "sc_code": "VIS01952",
    "address": "New Market Cinema Road,Yadav Chowk,Hajipur 844101",
    "city": "Hajipur",
    "state": "Bihar",
    "pincode": "844101",
    "phone": "9097799115",
    "email": "rupeshkumars991@gmail.com"
  },
  {
    "id": 463,
    "name": "S.S Infotech (VIS01804)",
    "sc_name": "S.S Infotech",
    "sc_code": "VIS01804",
    "address": "Shop No 220 Kaveri Complex,P L Sharma Road , Meerut-250002",
    "city": "Meerut",
    "state": "Uttar Pradesh",
    "pincode": "250002",
    "phone": "9997479018",
    "email": "ssinfotechmrt@gmail.com"
  },
  {
    "id": 464,
    "name": "Newxperto (VIS01236)",
    "sc_name": "Newxperto",
    "sc_code": "VIS01236",
    "address": "G-13,Krishna Complex,Agra Road,Kalyan Naka,Bhiwandi,Thane,Maharashtra-421302",
    "city": "Bhiwandi",
    "state": "Maharashtra",
    "pincode": "421302",
    "phone": "7498379888",
    "email": "newxperto.bhiwandi@gmail.com"
  },
  {
    "id": 465,
    "name": "Harsh Mobile Point (VIS01623)",
    "sc_name": "Harsh Mobile Point",
    "sc_code": "VIS01623",
    "address": "Near Chawala Agency Sewa Kunj Road Raigarh C.G. 496001",
    "city": "Raigarh",
    "state": "Chhattisgarh",
    "pincode": "496001",
    "phone": "8435088889",
    "email": "harshmobilepoint2@gmail.com"
  },
  {
    "id": 466,
    "name": "Manju Enterprises (VIS01681)",
    "sc_name": "Manju Enterprises",
    "sc_code": "VIS01681",
    "address": "Manju Enterprises Near Of Ps Collage Chauk ,Madhepura Pin-852113 (Bihar) , Bihar, Madhepura",
    "city": "Madhepura",
    "state": "Bihar",
    "pincode": "852113",
    "phone": "8539846385",
    "email": "manjuenterprises9988@gmail.com"
  },
  {
    "id": 467,
    "name": "Lucky Mobile Gallery (VIS02256)",
    "sc_name": "Lucky Mobile Gallery",
    "sc_code": "VIS02256",
    "address": "Siwani Chok Tosham Jabru Market Pin Code 127040",
    "city": "Tosham",
    "state": "Haryana",
    "pincode": "127040",
    "phone": "9728717779",
    "email": "luckymobilegallary@gmail.com"
  },
  {
    "id": 468,
    "name": "Ambe Agencies (VIS01666)",
    "sc_name": "Ambe Agencies",
    "sc_code": "VIS01666",
    "address": "NEW BUS STAND, OSIAN DISTT. JODHPUR, RAJASTHAN, PIN NO. - 342303",
    "city": "Osian",
    "state": "Rajasthan",
    "pincode": "342303",
    "phone": "7568068513",
    "email": "ambeagencies61@gmail.com"
  },
  {
    "id": 469,
    "name": "Rajendra Treding Company (VIS01566)",
    "sc_name": "Rajendra Treding Company",
    "sc_code": "VIS01566",
    "address": "Sidhu Hospital Road Near Gyan Mandir School Nohar-335523",
    "city": "Nohar",
    "state": "Rajasthan",
    "pincode": "335523",
    "phone": "9950662040",
    "email": "santoshkumarjoshinohar@gmail.com"
  },
  {
    "id": 470,
    "name": "Bablu Mobile Centre (VIS02237)",
    "sc_name": "Bablu Mobile Centre",
    "sc_code": "VIS02237",
    "address": "Mahagama Main Chowk Nearly-Mosam Bahar Mall Jharkhand Pin-814154 Ph-9771373559 , Jharkhand, Godda",
    "city": "Godda",
    "state": "Jharkhand",
    "pincode": "814154",
    "phone": "9771373559",
    "email": "sarojkumarmahtobmc@gmail.com"
  },
  {
    "id": 471,
    "name": "Kasturi Cellular Service (VIS01926)",
    "sc_name": "Kasturi Cellular Service",
    "sc_code": "VIS01926",
    "address": "No.781/1B, Lakshmi Complex, Imperial Road, (Opp.K.V.Tex), Cuddalore, PIN: 607001",
    "city": "Cuddalore",
    "state": "Tamil Nadu",
    "pincode": "607001",
    "phone": "9500956740",
    "email": "kasturi.tn31@gmail.com"
  },
  {
    "id": 472,
    "name": "Ravi Electronics (VIS02366)",
    "sc_name": "Ravi Electronics",
    "sc_code": "VIS02366",
    "address": "Rana Complax Near Hospital Road Rohru Distt Shimla Hp 171207",
    "city": "Rohru",
    "state": "Himachal Pradesh",
    "pincode": "171207",
    "phone": "9418895188",
    "email": "ravielectronics2000@gmail.com"
  },
  {
    "id": 473,
    "name": "S.S. Communication (VIS01683)",
    "sc_name": "S.S. Communication",
    "sc_code": "VIS01683",
    "address": "Jai Narayan Mishra Building, Aishbagh Road, Near Hanuman Mandir, Naka Hindola, Lucknow, 226004",
    "city": "Lucknow",
    "state": "Uttar Pradesh",
    "pincode": "226004",
    "phone": "7007507007",
    "email": "sscommunication015@gmail.com"
  },
  {
    "id": 474,
    "name": "Suman Telecom (VIS01794)",
    "sc_name": "Suman Telecom",
    "sc_code": "VIS01794",
    "address": "Tin Bazar Beside Fish Market,Opposite-Jol Ghor,Suri Sainthia Road,Suri Birbhum Wesr Bengal-731101",
    "city": "Suri",
    "state": "West Bengal",
    "pincode": "731101",
    "phone": "9832139966",
    "email": "shantumaji1063@gmail.com"
  },
  {
    "id": 475,
    "name": "Aashi Enterprises (VIS01845)",
    "sc_name": "Aashi Enterprises",
    "sc_code": "VIS01845",
    "address": "Baldauganj Kashai Road Karwi Chitrakoot Pin 210205 Uttar Pradesh, Uttar Pradesh, Karwi",
    "city": "Karwi",
    "state": "Uttar Pradesh",
    "pincode": "210205",
    "phone": "9648475574",
    "email": "sharadgupta5345@gmail.com"
  },
  {
    "id": 476,
    "name": "Shri Sai Mobile World (VIS01873)",
    "sc_name": "Shri Sai Mobile World",
    "sc_code": "VIS01873",
    "address": "Chhajjapur, In Front Of Shivam Nursing Home, Tanda ,Ambedkar Nagar ,Tanda ,Uttar Pradesh ,Pin-224190 , Uttar Pradesh, Tanda",
    "city": "Tanda",
    "state": "Uttar Pradesh",
    "pincode": "224190",
    "phone": "9415759905",
    "email": "shrawangupta00583@gmail.com"
  },
  {
    "id": 477,
    "name": "Mehreen Mobile Solution (VIS02164)",
    "sc_name": "Mehreen Mobile Solution",
    "sc_code": "VIS02164",
    "address": "Laxmi Talkies Market Datia, Madhya Pradesh, 475661",
    "city": "Datia",
    "state": "Madhya Pradesh",
    "pincode": "475661",
    "phone": "6264666839",
    "email": "sohibshaikh1234@gmail.com"
  },
  {
    "id": 478,
    "name": "Metro Complex (VIS02081)",
    "sc_name": "Metro Complex",
    "sc_code": "VIS02081",
    "address": "Biswanath Pur,Ganjer Bazar,Ramganga Road,Patharpratima ,South 24 Parganas,743349",
    "city": "South 24 Parganas",
    "state": "West Bengal",
    "pincode": "743349",
    "phone": "8697447644",
    "email": "subrataat@gmail.com"
  },
  {
    "id": 479,
    "name": "R P Technology (VIS02242)",
    "sc_name": "R P Technology",
    "sc_code": "VIS02242",
    "address": "Shop No 49, 1St Floor, Bhosale Shinde Arcade, Deccan, J. M. Road, Pune 411004.",
    "city": "Pune",
    "state": "Maharashtra",
    "pincode": "411004",
    "phone": "8149988841",
    "email": "rptech0109@gmail.com"
  },
  {
    "id": 480,
    "name": "Rana Service (VIS01654)",
    "sc_name": "Rana Service",
    "sc_code": "VIS01654",
    "address": "Vill-Deulpota . Po-Barbasudevpur. Ps-Sutahata. Dist-Purba Medini Pur. Pin-721645",
    "city": "Haldia",
    "state": "West Bengal",
    "pincode": "721645",
    "phone": "9932498647",
    "email": "surajitmobile@gmail.com"
  },
  {
    "id": 481,
    "name": "Verma Enterprises (VIS02258)",
    "sc_name": "Verma Enterprises",
    "sc_code": "VIS02258",
    "address": "Rs Phogat Market,Ist Floor,Rohtak Chouk,Charkhi,Dadri,Pin Code 127306",
    "city": "Charkhi Dadri",
    "state": "Haryana",
    "pincode": "127306",
    "phone": "9992958300",
    "email": "surenderverma9999@gmail.com"
  },
  {
    "id": 482,
    "name": "Shriram Enterprises (VISASP2420)",
    "sc_name": "Shriram Enterprises",
    "sc_code": "VISASP2420",
    "address": "First Floor Shop No-28 Subhash Market In Front Of Bus Stand Firozabad -283203",
    "city": "Firozabad",
    "state": "Uttar Pradesh",
    "pincode": "283203",
    "phone": "7417034775",
    "email": "shrirament.fzd@gmail.com"
  },
  {
    "id": 483,
    "name": "Smartfix Technologies (VIS01791)",
    "sc_name": "Smartfix Technologies",
    "sc_code": "VIS01791",
    "address": "Sho No 3, Frist Floor, Chandrareddy Building, Opp Chowdeshwari Temple. Martheahalli Bangalore - 560037",
    "city": "Bangalore",
    "state": "Karnataka",
    "pincode": "560037",
    "phone": "9986488363",
    "email": "smaartfixtech@gmail.com"
  },
  {
    "id": 484,
    "name": "Akshar Communication (VIS02036)",
    "sc_name": "Akshar Communication",
    "sc_code": "VIS02036",
    "address": "203-204,2Nd Floor, Rajkamal Arcade, Opp Bank Of Maharastra,Gidc,Ankleshwar-393002",
    "city": "Ankleshwar",
    "state": "Gujarat",
    "pincode": "393002",
    "phone": "9157387177",
    "email": "akshar.miank@gmail.com"
  },
  {
    "id": 485,
    "name": "Ginia Care (VISASP4157)",
    "sc_name": "Ginia Care",
    "sc_code": "VISASP4157",
    "address": "KF/8 City Center Near Maruti Showroom Opp.Style Baazar M Baazar Sector-4 Bokaro Steel City Jharkhand 827004",
    "city": "Bokaro",
    "state": "Jharkhand",
    "pincode": "827004",
    "phone": "7545900300",
    "email": "ginia.bokaro@gmail.com"
  },
  {
    "id": 486,
    "name": "Pareek Commnucation (VIS01552)",
    "sc_name": "Pareek Commnucation",
    "sc_code": "VIS01552",
    "address": "Back Aanad Hotel,Bus Stand , Rawla Mandi, Dist -Sri Ganganagar ,Pin 335707 (Raj)",
    "city": "Rawala",
    "state": "Rajasthan",
    "pincode": "335707",
    "phone": "9530206080",
    "email": "vinodpareek029@gmail.com"
  },
  {
    "id": 487,
    "name": "Kamboj Communication (VIS02346)",
    "sc_name": "Kamboj Communication",
    "sc_code": "VIS02346",
    "address": "Main Bazar ,Near Streat No:-4 , Malout , City Malout, Dist. Muktsar Sahib, Panjab Pin 152107",
    "city": "Malout",
    "state": "Punjab",
    "pincode": "152107",
    "phone": "9872791961",
    "email": "vinodkamboj2k9@gmail.com"
  },
  {
    "id": 488,
    "name": "Billaiya Mobile (VISASP2410)",
    "sc_name": "Billaiya Mobile",
    "sc_code": "VISASP2410",
    "address": "Mahal Road, Chhatarpur, Mp-471001,Ph-7000233988",
    "city": "Chhatarpur",
    "state": "Madhya Pradesh",
    "pincode": "471001",
    "phone": "7000233988",
    "email": "billaiya143@gmail.com"
  },
  {
    "id": 489,
    "name": "Jai Ambe Telecom (VIS01871)",
    "sc_name": "Jai Ambe Telecom",
    "sc_code": "VIS01871",
    "address": "G02 & G03,shivam Plaza,lanka Gate Road,Bundi - 323001",
    "city": "Bundi",
    "state": "Rajasthan",
    "pincode": "323001",
    "phone": "7014398395",
    "email": "jaiambetelecombundi@gmail.com"
  },
  {
    "id": 490,
    "name": "Ananya Enterprises (VIS01965)",
    "sc_name": "Ananya Enterprises",
    "sc_code": "VIS01965",
    "address": "Ramtal Road Near Kohinoor Tent House Jalalabad, Shahjahanpur Pincode 242221",
    "city": "Jalalabad",
    "state": "Uttar Pradesh",
    "pincode": "242221",
    "phone": "9236586407",
    "email": "yogendra6407@gmail.com"
  },
  {
    "id": 491,
    "name": "Aayush Mobile - Mumbai (VISASP3988)",
    "sc_name": "Aayush Mobile - Mumbai",
    "sc_code": "VISASP3988",
    "address": "2A,1ST FLOOR,PLOT 167/262,A,NAVYUG NIWAS DR.DADASAHEB BHADKAMKAR MARG,MINERWA CINEMA,GRANT ROAD MUMBAI-400007",
    "city": "Mumbai",
    "state": "Maharashtra",
    "pincode": "400007",
    "phone": "9325980674",
    "email": "aayushmobilelamington@gmail.com"
  },
  {
    "id": 492,
    "name": "Orion Communication (VISASP3056)",
    "sc_name": "Orion Communication",
    "sc_code": "VISASP3056",
    "address": "Khalap Building, 1st Floor, Shop No.F-5, Above Canara Bank, Opp. Main Municipal Market, Mapusa Goa-403507",
    "city": "Goa",
    "state": "Maharashtra",
    "pincode": "403507",
    "phone": "9822060739",
    "email": "orion.mapusa@gmail.com"
  },
  {
    "id": 493,
    "name": "Aadya Enterprises (VISASP2476)",
    "sc_name": "Aadya Enterprises",
    "sc_code": "VISASP2476",
    "address": "Gandhi Path, Ashok Cinema Road, Saharsa, Bihar 852201,Ph-9472023914",
    "city": "Saharsa",
    "state": "Bihar",
    "pincode": "852201",
    "phone": "7903204613",
    "email": "aadyaenterprises2806@gmail.com"
  },
  {
    "id": 494,
    "name": "A S Communication (VIS01553)",
    "sc_name": "A S Communication",
    "sc_code": "VIS01553",
    "address": "Shop No - 8 & 9, 1st Floor, Janki Complex, Netaji Fule Market, Sitabuldi, Nagpur - 440012(Maharashtra)",
    "city": "Nagpur",
    "state": "Maharashtra",
    "pincode": "440012",
    "phone": "7972372076",
    "email": "asc281642@gmail.com"
  },
  {
    "id": 495,
    "name": "Sai Mobiles (VIS01933)",
    "sc_name": "Sai Mobiles",
    "sc_code": "VIS01933",
    "address": "Shop No.2, First Floor,Hardy Complex,Opp.Chermas,M.G.Road ,Near Paradise,Secunderabad-500003",
    "city": "Secunderabad",
    "state": "Telangana",
    "pincode": "500003",
    "phone": "9246842353",
    "email": "saimobiles.secunderabad@gmail.com"
  },
  {
    "id": 496,
    "name": "Techmate Enterprises (VIS02145)",
    "sc_name": "Techmate Enterprises",
    "sc_code": "VIS02145",
    "address": "Mezzanine Floor, Plot No 147,Zone-1, MP Nagar, Above Central Bank Of India - 462011",
    "city": "Bhopal",
    "state": "Madhya Pradesh",
    "pincode": "462011",
    "phone": "9977008888",
    "email": "techmatebpl@gmail.com"
  },
  {
    "id": 497,
    "name": "Shipra Communication (VIS01361)",
    "sc_name": "Shipra Communication",
    "sc_code": "VIS01361",
    "address": "Shop No 14 Kissan Bazar Circular Road Near Hotel Utsav Railway Ganj Hardoi 241001",
    "city": "Hardoi",
    "state": "Uttar Pradesh",
    "pincode": "241001",
    "phone": "7985821558",
    "email": "sweet.gaurav16@gmail.com"
  },
  {
    "id": 498,
    "name": "UNIQUE MOBILE (VISASP3738)",
    "sc_name": "UNIQUE MOBILE",
    "sc_code": "VISASP3738",
    "address": "Upper No.1, Sagar Complex, Dr Nalinkant Gandhi Marg, Bombay Pavbhaji Nyay Mandir, HIMATNAGAR, Sabarkantha-383001",
    "city": "Himatnagar",
    "state": "Gujarat",
    "pincode": "383001",
    "phone": "9904210600",
    "email": "uniqueinfo1060@gmail.com"
  },
  {
    "id": 499,
    "name": "Amit Communication (VISASP2793)",
    "sc_name": "Amit Communication",
    "sc_code": "VISASP2793",
    "address": "1st floor agrwal market near by surya ges agency bhind (MP) - 477001",
    "city": "Bhind",
    "state": "Madhya Pradesh",
    "pincode": "477001",
    "phone": "6268190600",
    "email": "amitcommunicationbhind@gmail.com"
  },
  {
    "id": 500,
    "name": "Bhatta Communication (VISASP3759)",
    "sc_name": "Bhatta Communication",
    "sc_code": "VISASP3759",
    "address": "Jail Road, Ward No-8, Near Assam Oil Petrol Pump-787001",
    "city": "North Lakhimpur",
    "state": "Assam",
    "pincode": "787001",
    "phone": "9613280287",
    "email": "bhattanlp.com@gmail.com"
  },
  {
    "id": 501,
    "name": "B.M.Gadget Services Pvt.Ltd (VISASP3786)",
    "sc_name": "B.M.Gadget Services Pvt.Ltd",
    "sc_code": "VISASP3786",
    "address": "Ground Floor, Meenal Arcade,Next To Samudra Hotel, Nal Stop,Off Karve Road , Pune, Maharashtra-411004",
    "city": "Pune",
    "state": "Maharashtra",
    "pincode": "411004",
    "phone": "8888833685",
    "email": "shamolgaikwad@gmail.com"
  },
  {
    "id": 502,
    "name": "KANJI MOBILE SHOP (VIS01694)",
    "sc_name": "KANJI MOBILE SHOP",
    "sc_code": "VIS01694",
    "address": "KANJI MOBILE SHOP, NEAR KRISHNA PLAZA, DABLA ROAD, KOTPUTLI, JAIPUR, RAJASTHAN (303108)",
    "city": "Kotputli",
    "state": "Rajasthan",
    "pincode": "303108",
    "phone": "9929936688",
    "email": "nkyadav5010@gmail.com"
  },
  {
    "id": 503,
    "name": "Sri Sai Solution (VISASP3857)",
    "sc_name": "Sri Sai Solution",
    "sc_code": "VISASP3857",
    "address": "RIGHT SIDE LIFE STYLE FURNITUR, 12, Madhura Nagar Colony,WOMENS COLLEGE ROAD, Official Colony, Srikakulam, Srikakulam,Andhra Pradesh, 532001",
    "city": "Srikakulam",
    "state": "Andhra Pradesh",
    "pincode": "532001",
    "phone": "9133893636",
    "email": "srisaisolution.visasp3857@gmail.com"
  },
  {
    "id": 504,
    "name": "AARA TECHNOLOGIES (VISASP3771)",
    "sc_name": "AARA TECHNOLOGIES",
    "sc_code": "VISASP3771",
    "address": "Ground Floor, 339/3,4, Arun Complex, Brough Road, Erode, Tamil Nadu, 638001",
    "city": "Erode",
    "state": "Tamil Nadu",
    "pincode": "638001",
    "phone": "9345568222",
    "email": "aaratecherode@gmail.com"
  },
  {
    "id": 505,
    "name": "S Mart Traders (VISASP3885)",
    "sc_name": "S Mart Traders",
    "sc_code": "VISASP3885",
    "address": "Opp -Congress Office ,Near Sahara , Buxidih Road 815301",
    "city": "Giridih",
    "state": "Jharkhand",
    "pincode": "815301",
    "phone": "9525225924",
    "email": "smarttraders.bksc@gmail.com"
  },
  {
    "id": 506,
    "name": "New Rachna Electronics (VISASP3795)",
    "sc_name": "New Rachna Electronics",
    "sc_code": "VISASP3795",
    "address": "Near Bada Pul, A. B. Road, Guna-473001",
    "city": "Guna",
    "state": "Madhya Pradesh",
    "pincode": "473001",
    "phone": "9893333789",
    "email": "globalelectronics.guna@gmail.com"
  },
  {
    "id": 507,
    "name": "SMILEY COMMUNICATION (VISASP4221)",
    "sc_name": "SMILEY COMMUNICATION",
    "sc_code": "VISASP4221",
    "address": "No.322 First Floor Gandhi Road Kanchipuram 631501",
    "city": "Kancheepuram",
    "state": "Tamil Nadu",
    "pincode": "631501",
    "phone": "9884472956",
    "email": "smileycommunication2017@gmail.com"
  },
  {
    "id": 508,
    "name": "SRI SAI VENKATESWARA TECHNOLOGIES (VISASP4190)",
    "sc_name": "SRI SAI VENKATESWARA TECHNOLOGIES",
    "sc_code": "VISASP4190",
    "address": "Opp.r.t.c Busstand ,gu[tassquare Complex ,1stfloor,shop No--5,b-block,60feet Road ,ongole 523002",
    "city": "Ongole",
    "state": "Andhra Pradesh",
    "pincode": "523002",
    "phone": "9948445454",
    "email": "saichandu5454@gmail.com"
  },
  {
    "id": 509,
    "name": "FRIEND (VISASP3808)",
    "sc_name": "FRIEND",
    "sc_code": "VISASP3808",
    "address": "383, WARD NO -5, LINK ROAD, Basantapur More, Arambag, Hooghly, West Bengal, 712601",
    "city": "Burdwan",
    "state": "West Bengal",
    "pincode": "712601",
    "phone": "9932460380",
    "email": "friend.burdwan007@gmail.com"
  },
  {
    "id": 510,
    "name": "Shine Solutions (VISASP3845)",
    "sc_name": "Shine Solutions",
    "sc_code": "VISASP3845",
    "address": "1st Floor, No 373/338, T.I Cycles Road, Ambathur, Chennai, Tamil Nadu-600053",
    "city": "Chennai",
    "state": "Tamil Nadu",
    "pincode": "600053",
    "phone": "9884411900",
    "email": "shine.ambathur@gmail.com"
  },
  {
    "id": 511,
    "name": "Dhaneshwari Communication (VISASP2485)",
    "sc_name": "Dhaneshwari Communication",
    "sc_code": "VISASP2485",
    "address": "Shop No 1, Khedapati Marg, Opp. Sehta Hospital Patidar Square, Dhar, Madhya Pradesh-454001",
    "city": "Dhar",
    "state": "Madhya Pradesh",
    "pincode": "454001",
    "phone": "8827408888",
    "email": "pankajrampal04@gmail.com"
  },
  {
    "id": 512,
    "name": "Sri Shiv Communication (VIS02272)",
    "sc_name": "Sri Shiv Communication",
    "sc_code": "VIS02272",
    "address": "In Front Of Circuit House, Pakri, Ara, Bhojpur, Bihar, 802301, India Ph-8271489111",
    "city": "Ara",
    "state": "Bihar",
    "pincode": "802301",
    "phone": "8271489111",
    "email": "srishivcommunication@gmail.com"
  },
  {
    "id": 513,
    "name": "Jaiswal Mobile and Repairing (VIS02090)",
    "sc_name": "Jaiswal Mobile and Repairing",
    "sc_code": "VIS02090",
    "address": "Ambedkar Chouk, Waidhan, Singrauli, M.P 486886",
    "city": "Singrauli",
    "state": "Madhya Pradesh",
    "pincode": "486886",
    "phone": "9009254194",
    "email": "pjanjaiswal@gmail.com"
  },
  {
    "id": 514,
    "name": "Silicon Solutions (VISASP3844)",
    "sc_name": "Silicon Solutions",
    "sc_code": "VISASP3844",
    "address": "NO.6 & 7, AKSHAYA COMPLEX,16TH MAIN ROAD, BTM 2ND STAGE, BENGALURU-560076",
    "city": "Bangalore",
    "state": "Karnataka",
    "pincode": "560076",
    "phone": "9972530579",
    "email": "siliconsolutions.visasp3844@gmail.com"
  },
  {
    "id": 515,
    "name": "SEJAL MARKETING (VIS00391)",
    "sc_name": "SEJAL MARKETING",
    "sc_code": "VIS00391",
    "address": "City Center Complex Near Vishwakarma Mandir Kuchaman City - 341508",
    "city": "Kuchaman City",
    "state": "Rajasthan",
    "pincode": "341508",
    "phone": "9001808228",
    "email": "pradeepkumawat298@gmail.com"
  },
  {
    "id": 516,
    "name": "SERVICE POINT NEW A K MOBILE (VISASP3752)",
    "sc_name": "SERVICE POINT NEW A K MOBILE",
    "sc_code": "VISASP3752",
    "address": "SERVICE POINT NEW A K MOBILE,LALAN COMPLEX BABUNIYA MORE SIWAN, Bihar-841226",
    "city": "Siwan",
    "state": "Bihar",
    "pincode": "841226",
    "phone": "9955490970",
    "email": "servicepointswn@gmail.com"
  },
  {
    "id": 517,
    "name": "Jaydeep Mobile (VISASP3741)",
    "sc_name": "Jaydeep Mobile",
    "sc_code": "VISASP3741",
    "address": "Ff/101 To 104, Sadguru Complex, Karanpara Garbi Chowk,Behind Std Stand, Rajkot-360001",
    "city": "Rajkot",
    "state": "Gujarat",
    "pincode": "360001",
    "phone": "7878832727",
    "email": "jaydeepmobilerajkot@gmail.com"
  },
  {
    "id": 518,
    "name": "Telecom India (VISASP3839)",
    "sc_name": "Telecom India",
    "sc_code": "VISASP3839",
    "address": "No.13, Mangaluru Essel Centre, Basement, Opp. Ibrose Omplex, MG Road, Kodialbail, Mangaluru-575003",
    "city": "Mangalore",
    "state": "Karnataka",
    "pincode": "575003",
    "phone": "9035288989",
    "email": "telecomindia.mangalore86@gmail.com"
  },
  {
    "id": 519,
    "name": "MOBITECH (VIS02053)",
    "sc_name": "MOBITECH",
    "sc_code": "VIS02053",
    "address": "OPP SONY SHOWROOM, POLYTECHNIC ROAD, OLD PAHAD GOAN, PORT BLAIR-744103",
    "city": "Port Blair",
    "state": "Andaman And Nicobar",
    "pincode": "744103",
    "phone": "9933261856",
    "email": "mobitechandaman@gmail.com"
  },
  {
    "id": 520,
    "name": "Fix Expert (VISASP3949)",
    "sc_name": "Fix Expert",
    "sc_code": "VISASP3949",
    "address": "4743/ D Ganesh Temple Road, N.R Mohalla, Mysore - 570007",
    "city": "Mysore",
    "state": "Karnataka",
    "pincode": "570007",
    "phone": "8095067034",
    "email": "fixxperts18@gmail.com"
  },
  {
    "id": 521,
    "name": "Jain Telecom (VISASP3768)",
    "sc_name": "Jain Telecom",
    "sc_code": "VISASP3768",
    "address": "Shop.No4/5 Sashwat Majestic Datta Chowk South Kasaba Solapur-413007",
    "city": "Solapur",
    "state": "Maharashtra",
    "pincode": "413007",
    "phone": "9822060079",
    "email": "jaintele2019@gmail.com"
  },
  {
    "id": 522,
    "name": "N R Marketing (VISASP3788)",
    "sc_name": "N R Marketing",
    "sc_code": "VISASP3788",
    "address": "#35,36 1St Floor Muslim Hostel Complex,Opp Ddpi Office Ambedkar Circle P J Extension-577002",
    "city": "Davangere",
    "state": "Karnataka",
    "pincode": "577002",
    "phone": "9741809555",
    "email": "nrmarketingdvg@gmail.com"
  },
  {
    "id": 523,
    "name": "I-Care (VIS01481)",
    "sc_name": "I-Care",
    "sc_code": "VIS01481",
    "address": "Old Ginani Near Pugal Dera Front Of Pooja Mava Bhandar Bikaner 334001",
    "city": "Bikaner",
    "state": "Rajasthan",
    "pincode": "334001",
    "phone": "7230044744",
    "email": "icareindia2014@gmail.com"
  },
  {
    "id": 524,
    "name": "RD Enterprises (VISASP3871)",
    "sc_name": "RD Enterprises",
    "sc_code": "VISASP3871",
    "address": "1st Floor, Municipality Holding No 648 (32), Plot No. 891/1632, Near Station Chhak, Balasore, Odisha-756001",
    "city": "Balasore",
    "state": "Odisha",
    "pincode": "756001",
    "phone": "7328885557",
    "email": "balasorerealme@gmail.com"
  },
  {
    "id": 525,
    "name": "Expert Enterprises (VIS02135)",
    "sc_name": "Expert Enterprises",
    "sc_code": "VIS02135",
    "address": "3, Ganesh Nagar Mohan Nagar, Choraya Near Indian Oil Petrol Pump Ratlam - 457001",
    "city": "Ratlam",
    "state": "Madhya Pradesh",
    "pincode": "457001",
    "phone": "7000640759",
    "email": "expertenterprises623@gmail.com"
  },
  {
    "id": 526,
    "name": "B L Enterprises (VISASP3756)",
    "sc_name": "B L Enterprises",
    "sc_code": "VISASP3756",
    "address": "5C-A Ambika Tower, Near Sangam Palace, Nawab Yusuf Road, Allahabad-211002",
    "city": "Allahabad",
    "state": "Uttar Pradesh",
    "pincode": "211002",
    "phone": "9198164395",
    "email": "manoj.ru.lal@gmail.com"
  },
  {
    "id": 527,
    "name": "Maa Vaishnawi Enterprises (VISASP3462)",
    "sc_name": "Maa Vaishnawi Enterprises",
    "sc_code": "VISASP3462",
    "address": "Pratapgang Road Simrahi Bazar Word-04 Nh-27 Supaul Pin-852111 Ph-9162788161, Bihar, Supaul",
    "city": "Supaul",
    "state": "Bihar",
    "pincode": "852111",
    "phone": "7250252225",
    "email": "ramvilashkumar9122@gmail.com"
  },
  {
    "id": 528,
    "name": "Rescue Mobiles (VISASP3770)",
    "sc_name": "Rescue Mobiles",
    "sc_code": "VISASP3770",
    "address": "No 565,-A 1st Floor Kamaraj Salai, Near Rajiv Gandhi Statue(opp SBI In Touch), Pakkamudayanpet, Pondicherry -605013",
    "city": "Pondicherry",
    "state": "Pondicherry",
    "pincode": "605013",
    "phone": "9786710102",
    "email": "rescuemobilespondy@gmail.com"
  },
  {
    "id": 529,
    "name": "B.B.Enterprise (VISASP3860)",
    "sc_name": "B.B.Enterprise",
    "sc_code": "VISASP3860",
    "address": "Dherua Midnapur Iti Road, Rangamati, Paschim Midnapur, West Bengal - 721102",
    "city": "West Medinipur",
    "state": "West Bengal",
    "pincode": "721102",
    "phone": "7719376543",
    "email": "bbenterprise7006@gmail.com"
  },
  {
    "id": 530,
    "name": "MOBILE ZONE (VISASP4217)",
    "sc_name": "MOBILE ZONE",
    "sc_code": "VISASP4217",
    "address": "Mobile Zone, Kamala Place, Near Kalawati Place SBI ATM, Biharsharif , Nalanda-803101,BIHAR,803101",
    "city": "Bihar Sharif",
    "state": "Bihar",
    "pincode": "803101",
    "phone": "8757170002",
    "email": "ratnesh.ranjan2@gmail.com"
  },
  {
    "id": 531,
    "name": "MOBILE DARBAR (VIS02002)",
    "sc_name": "MOBILE DARBAR",
    "sc_code": "VIS02002",
    "address": "Shop No- KF 1A, Krd Point, Near Old Nagarpalika, Bigga Bas, Dungargarh, Bikaner, Rajasthan, 331803",
    "city": "Dungar Garh",
    "state": "Rajasthan",
    "pincode": "331803",
    "phone": "9649163516",
    "email": "ravimorwani2@gmail.com"
  },
  {
    "id": 532,
    "name": "KVR MOBILES (VISASP4180)",
    "sc_name": "KVR MOBILES",
    "sc_code": "VISASP4180",
    "address": "Shop No : 2&3, Mvs Complex, Telangana State, Opp. New Busstand, Beside Dhanush Gas Agencies, Bheem Nagar, Gadwal, Telangana 509125",
    "city": "Gadwal",
    "state": "Telangana",
    "pincode": "509125",
    "phone": "9885976144",
    "email": "kvrmobiles99@gmail.com"
  },
  {
    "id": 533,
    "name": "Pratap Communication (VIS01547)",
    "sc_name": "Pratap Communication",
    "sc_code": "VIS01547",
    "address": "Pratap Communication Opp St Tressa School, Bettiah-845438, Bihar, Bettiah",
    "city": "Bettiah",
    "state": "Bihar",
    "pincode": "845438",
    "phone": "9931073291",
    "email": "pratapcommunication2010@gmail.com"
  },
  {
    "id": 534,
    "name": "M.R SERVICES (VISASP3750)",
    "sc_name": "M.R SERVICES",
    "sc_code": "VISASP3750",
    "address": "G-14 Asian, Complex Opp. City Bus Stand, Post Office Road, Super Market Kalaburagi-Karnataka-585101",
    "city": "Gulbarga",
    "state": "Karnataka",
    "pincode": "585101",
    "phone": "9513334777",
    "email": "razak.hk777@gmail.com"
  },
  {
    "id": 535,
    "name": "USHA COMMUNICATION (VISASP4029)",
    "sc_name": "USHA COMMUNICATION",
    "sc_code": "VISASP4029",
    "address": "FIRST FLOORBACK PORTION, SCF NO. 71,PHASE 2, SECTOR-54, MOHALI, SAS NAGAR, PUNJAB-160055",
    "city": "Mohali",
    "state": "Punjab",
    "pincode": "160055",
    "phone": "9988264499",
    "email": "chauhan00364@gmail.com"
  },
  {
    "id": 536,
    "name": "Rohit Trading Co. (VISASP3816)",
    "sc_name": "Rohit Trading Co.",
    "sc_code": "VISASP3816",
    "address": "Rohit Trading Co. 5252 Anaj Mandi, Opposite Water Tank, Ambala Cantt 133001",
    "city": "Ambala",
    "state": "Haryana",
    "pincode": "133001",
    "phone": "9541595415",
    "email": "rjain_1985@yahoo.com"
  },
  {
    "id": 537,
    "name": "MOBILE SOLUTION (VISASP4192)",
    "sc_name": "MOBILE SOLUTION",
    "sc_code": "VISASP4192",
    "address": "BUDDHA MARKET BESIDE MOHANA BUS STAND, PS BERHAMPORE, DIST MURSHIDABAD, PIN 742101",
    "city": "Murshidabad",
    "state": "West Bengal",
    "pincode": "742101",
    "phone": "7001202910",
    "email": "samimarif2@gmail.com"
  },
  {
    "id": 538,
    "name": "MOON STAR (VISASP4264)",
    "sc_name": "MOON STAR",
    "sc_code": "VISASP4264",
    "address": "HUSSAIN CHOWK THANA ROAD NEAR RAYMOND SHOWROOM SUPAUL-852131",
    "city": "Supaul",
    "state": "Bihar",
    "pincode": "852131",
    "phone": "9122492786",
    "email": "moonstar.mobi@gmail.com"
  },
  {
    "id": 539,
    "name": "Technovision (VISASP3753)",
    "sc_name": "Technovision",
    "sc_code": "VISASP3753",
    "address": "Eastern Publication Building Circular Road Dimapur,Nagaland-797112",
    "city": "Dimapur",
    "state": "Nagaland",
    "pincode": "797112",
    "phone": "7005707442",
    "email": "technovision.dimapur@gmail.com"
  },
  {
    "id": 540,
    "name": "Repair Factory (VISASP3747)",
    "sc_name": "Repair Factory",
    "sc_code": "VISASP3747",
    "address": "SHOP No. 21, GROUND FLOOR, INTERNATIONAL MARKET, NEAR PANITANKI MORE, SILIGURI, WEST BENGAL.-734001",
    "city": "Siliguri",
    "state": "West Bengal",
    "pincode": "734001",
    "phone": "7001579702",
    "email": "repairfactory24x7@gmail.com"
  },
  {
    "id": 541,
    "name": "Maa Kali Enterprises NX (VISASP3874)",
    "sc_name": "Maa Kali Enterprises NX",
    "sc_code": "VISASP3874",
    "address": "Shop No.1, GF, Acharya Tulsi Marg, Dombivli East,Kalyan-421201",
    "city": "Kalyan",
    "state": "Maharashtra",
    "pincode": "421201",
    "phone": "9833660333",
    "email": "maakalienterprisesnx50@gmail.com"
  },
  {
    "id": 542,
    "name": "Srkt Enterprises (VISASP3877)",
    "sc_name": "Srkt Enterprises",
    "sc_code": "VISASP3877",
    "address": "D/NO:46-11-21,OPP CCC CHANNEL,MADDURI VARI STREET,DANAVAIPETA,RAJAHMUNDRY-533103",
    "city": "Rajahmundry",
    "state": "Andhra Pradesh",
    "pincode": "533103",
    "phone": "8465881313",
    "email": "srktenterprises@gmail.com"
  },
  {
    "id": 543,
    "name": "Anannaya Infotel (VISASP3832)",
    "sc_name": "Anannaya Infotel",
    "sc_code": "VISASP3832",
    "address": "17, Girish Avenue, Opposite United Bank Of India, Near Girish Bhawan, Kolkata, Westbengal-700003",
    "city": "Kolkata",
    "state": "West Bengal",
    "pincode": "700003",
    "phone": "8910639132",
    "email": "sanjayjaiswalkol54@gmail.com"
  },
  {
    "id": 544,
    "name": "Anannya Infotech (VISASP3833)",
    "sc_name": "Anannya Infotech",
    "sc_code": "VISASP3833",
    "address": "36/2, Diamond Harbour Road,Behala,Barabagan, Near Ajanta Cinema\u00c2\u00a0,Kolkata , Westbengal-700060",
    "city": "Kolkata",
    "state": "West Bengal",
    "pincode": "700060",
    "phone": "8910639132",
    "email": "ashokejaiswal1981@gmail.com"
  },
  {
    "id": 545,
    "name": "Unique Sales & Service (VISASP4198)",
    "sc_name": "Unique Sales & Service",
    "sc_code": "VISASP4198",
    "address": "Unique Sales & Services , Tilak Road , PH Market , Beside Sanmitra Bank 444001",
    "city": "Akola",
    "state": "Maharashtra",
    "pincode": "444001",
    "phone": "9049764048",
    "email": "uniquesalesandservices4@gmail.com"
  },
  {
    "id": 546,
    "name": "S S R Services (VISASP3763)",
    "sc_name": "S S R Services",
    "sc_code": "VISASP3763",
    "address": "Sami Complex,1St Floor,Near Chamber Of Commerce, Jawaharlal Road-842001",
    "city": "Muzaffarpur",
    "state": "Bihar",
    "pincode": "842001",
    "phone": "7903701201",
    "email": "ssrservices.122@gmail.com"
  },
  {
    "id": 547,
    "name": "THRISSUR MOBILE CARE (VISASP2867)",
    "sc_name": "THRISSUR MOBILE CARE",
    "sc_code": "VISASP2867",
    "address": "TC-XIX/122/7. 1ST FLOOR ACHUS CENTER, POOTHOLE ROAD, NEAR GST OFFICE THRISSUR 680004",
    "city": "Thrissur",
    "state": "Kerala",
    "pincode": "680004",
    "phone": "9526211114",
    "email": "shansgroup@gmail.com"
  },
  {
    "id": 548,
    "name": "Dindigul Mobiles (VISASP3811)",
    "sc_name": "Dindigul Mobiles",
    "sc_code": "VISASP3811",
    "address": "5,6Csi Sopiha School Complex,Gh Salai Rood Dindigul-624001",
    "city": "Dindigul",
    "state": "Tamil Nadu",
    "pincode": "624001",
    "phone": "8344440000",
    "email": "dindigulmobilesservice@gmail.com"
  },
  {
    "id": 549,
    "name": "Harsh Mobile Gallery (VISASP2853)",
    "sc_name": "Harsh Mobile Gallery",
    "sc_code": "VISASP2853",
    "address": "Nau Kua Road Near Transformer Shamli 247776",
    "city": "Shamli",
    "state": "Uttar Pradesh",
    "pincode": "247776",
    "phone": "7817000342",
    "email": "harhmobile7500@gmail.com"
  },
  {
    "id": 550,
    "name": "SHREE MAHALAXMI MOBILE (VIS02001)",
    "sc_name": "SHREE MAHALAXMI MOBILE",
    "sc_code": "VIS02001",
    "address": "BEHIND RATHI PETROL PUMP, NOKHA BIKANER 334803",
    "city": "Nokha",
    "state": "Rajasthan",
    "pincode": "334803",
    "phone": "9529641838",
    "email": "shrawanr242@gmail.com"
  },
  {
    "id": 551,
    "name": "Sri Mobiles (VISASP3784)",
    "sc_name": "Sri Mobiles",
    "sc_code": "VISASP3784",
    "address": "\"F209, 2nd Floor, Rajnigandha Complex, Beside HDFC Bank, Metro Pillar No 1563, Chaitanyapuri, Hyderabad, Telangana, PIN: 500060",
    "city": "Hyderabad",
    "state": "Telangana",
    "pincode": "500060",
    "phone": "9951902799",
    "email": "srimobiles.dsnr@gmail.com"
  },
  {
    "id": 552,
    "name": "Nandani Enterprises (VIS02393)",
    "sc_name": "Nandani Enterprises",
    "sc_code": "VIS02393",
    "address": "Nandani enterpises shop no 4 frist floor city mall bhiwani , HR 127021",
    "city": "Bhiwani",
    "state": "Haryana",
    "pincode": "127021",
    "phone": "9812222347",
    "email": "nandanienterprisesbwn@gmail.com"
  },
  {
    "id": 553,
    "name": "Vankudre And Company (VISASP3869)",
    "sc_name": "Vankudre And Company",
    "sc_code": "VISASP3869",
    "address": "Vankudre And Company,333, E Ward , Prabhakar Plaza, Station Road, B Wing , Gala No.8,9,10 , Kolhapur-416002",
    "city": "Kolhapur",
    "state": "Maharashtra",
    "pincode": "416002",
    "phone": "9923269769",
    "email": "pushpak.com@gmail.com"
  },
  {
    "id": 554,
    "name": "Kalra Mobile (VISASP3854)",
    "sc_name": "Kalra Mobile",
    "sc_code": "VISASP3854",
    "address": "SHOP NO 8, MCB No. Z-3-00758, Shakti Complex, Mall Road, Near Gol Digi, Bathinda-151001",
    "city": "Bathinda",
    "state": "Punjab",
    "pincode": "151001",
    "phone": "8568820004",
    "email": "kalramobilecafe@gmail.com"
  },
  {
    "id": 555,
    "name": "Priya Infotech (VIS02249)",
    "sc_name": "Priya Infotech",
    "sc_code": "VIS02249",
    "address": "Shop No.14, International Market , Third Floor, Sevoke Road , Near Panitanki More, Siliguri-734001",
    "city": "Siliguri",
    "state": "West Bengal",
    "pincode": "734001",
    "phone": "8918836198",
    "email": "priyainfotech30@gmail.com"
  },
  {
    "id": 556,
    "name": "ALFA MOBILE SOLUTIONS (VIS00288)",
    "sc_name": "ALFA MOBILE SOLUTIONS",
    "sc_code": "VIS00288",
    "address": "Shop.No. G-14, Graund Floor, Nirmala Mahal, Old,Laxmi Theatre,JPN Road,,Warangal,\u00c2\u00a0Telangana,pincode- 506002\u00c2\u00b7\u00c2\u00a0Ph.9397888886,8328448199",
    "city": "Warangal",
    "state": "Telangana",
    "pincode": "506002",
    "phone": "9397888886",
    "email": "alfamobileservice@gmail.com"
  },
  {
    "id": 557,
    "name": "SHRI HARI TELECOM (VISASP2558)",
    "sc_name": "SHRI HARI TELECOM",
    "sc_code": "VISASP2558",
    "address": "Near By PC Care , HDFC Bank Ke Baju Me Parkota Wade Sagar Pin. 470002",
    "city": "Sagar",
    "state": "Madhya Pradesh",
    "pincode": "470002",
    "phone": "7415994072",
    "email": "shriharitelecom.sgr@gmail.com"
  },
  {
    "id": 558,
    "name": "Teleconnect (VISASP3866)",
    "sc_name": "Teleconnect",
    "sc_code": "VISASP3866",
    "address": "47, Janpath, Ashok Nagar, Bhubaneswar-751009",
    "city": "Bhubaneshwar",
    "state": "Odisha",
    "pincode": "751009",
    "phone": "7978509259",
    "email": "teleconnect_bbsr@yahoo.com"
  },
  {
    "id": 559,
    "name": "Global Solution (VIS02318)",
    "sc_name": "Global Solution",
    "sc_code": "VIS02318",
    "address": "Memari College More, Memari, Purba Bardhaman, Pin -713146",
    "city": "Memari",
    "state": "West Bengal",
    "pincode": "713146",
    "phone": "8013014409",
    "email": "globalsolutionmemari@gmail.com"
  },
  {
    "id": 560,
    "name": "Manvi Communication (VISASP4200)",
    "sc_name": "Manvi Communication",
    "sc_code": "VISASP4200",
    "address": "Shop No 179/180 1St Floor 100 Feet Road Opp Central Bank Of India Ballabgarh Pin Code 121004",
    "city": "Ballabhgarh",
    "state": "Haryana",
    "pincode": "121004",
    "phone": "9310908045",
    "email": "manvi.communication485@gmail.com"
  },
  {
    "id": 561,
    "name": "FORTUNE SERVICE (VISASP2899)",
    "sc_name": "FORTUNE SERVICE",
    "sc_code": "VISASP2899",
    "address": "5/3472 O, 1st FLOOR, MERRYLAND SQUARE, Near BABY MEMORIAL HOSPITAL, THIRUTHIYAD ROAD, CALICUT - 673004",
    "city": "Calicut",
    "state": "Kerala",
    "pincode": "673004",
    "phone": "6282108925",
    "email": "sreejithkmelur@gmail.com"
  },
  {
    "id": 562,
    "name": "Raghavendra Enterprises (VISASP3861)",
    "sc_name": "Raghavendra Enterprises",
    "sc_code": "VISASP3861",
    "address": "G6 GROUND FLOOR KEDAR PLAZA OPP SRI LAXMI MALL SRI SHAKTHI ROAD HUBLI-580020, PIN: 580021",
    "city": "Hubli",
    "state": "Karnataka",
    "pincode": "580021",
    "phone": "9036687414",
    "email": "ssingalagi@gmail.com"
  },
  {
    "id": 563,
    "name": "Appa Sons Mobile Gallery (VISASP3822)",
    "sc_name": "Appa Sons Mobile Gallery",
    "sc_code": "VISASP3822",
    "address": "2Nd Floor, Rabby Tower, Opp. Railway Station Road, Kannur-670001",
    "city": "Kannur",
    "state": "Kerala",
    "pincode": "670001",
    "phone": "9846007698",
    "email": "appasonskannur@gmail.com"
  },
  {
    "id": 564,
    "name": "Acme Technologies (VISASP3840)",
    "sc_name": "Acme Technologies",
    "sc_code": "VISASP3840",
    "address": "1st Floor, Metro Complex, Opp. Govt. Ayurveda Hospital, H.P.O. Road, Sulthanpet, Palakkad-678001",
    "city": "Palakkad",
    "state": "Kerala",
    "pincode": "678001",
    "phone": "8089799288",
    "email": "acme.palakkad@gmail.com"
  },
  {
    "id": 565,
    "name": "Uniek Services (VISASP2567)",
    "sc_name": "Uniek Services",
    "sc_code": "VISASP2567",
    "address": "Shilpi Plaza First Floor (A) Block F/A 4/3 Front Of Pili Kothi Gate Above Bata Showroom Rewa 486001",
    "city": "Rewa",
    "state": "Madhya Pradesh",
    "pincode": "486001",
    "phone": "9284041125",
    "email": "uniekservicerewa@gmail.com"
  },
  {
    "id": 566,
    "name": "H.S.ENTERPRISES (VISASP3754)",
    "sc_name": "H.S.ENTERPRISES",
    "sc_code": "VISASP3754",
    "address": "106B,Sunrise Plaza,Upstair Bakewell Bakery,Cooper Road,Amritsar-143001",
    "city": "Amritsar",
    "state": "Punjab",
    "pincode": "143001",
    "phone": "9872824804",
    "email": "hsenterprises510@gmail.com"
  },
  {
    "id": 567,
    "name": "A To Z Mobile Service Center (VISASP3146)",
    "sc_name": "A To Z Mobile Service Center",
    "sc_code": "VISASP3146",
    "address": "KARKULI, CONTAI , EAST MEDNAPUR , WEST BANGAL - 721401",
    "city": "Midnapore",
    "state": "West Bengal",
    "pincode": "721401",
    "phone": "8145992760",
    "email": "sumancontai189@gmail.com"
  },
  {
    "id": 568,
    "name": "R S Communication (VISASP3780)",
    "sc_name": "R S Communication",
    "sc_code": "VISASP3780",
    "address": "Near New Bus Stand ( Near Sbi Atm )\u00c2\u00a0 Kangra Hp 176001",
    "city": "Kangra",
    "state": "Himachal Pradesh",
    "pincode": "176001",
    "phone": "9459258620",
    "email": "rskangra176001@gmail.com"
  },
  {
    "id": 569,
    "name": "Sunrising Enterprises (VISASP3801)",
    "sc_name": "Sunrising Enterprises",
    "sc_code": "VISASP3801",
    "address": "105,New Khokhani Bhavan,Vasai Station Road, Vasai-401201",
    "city": "Vasai",
    "state": "Maharashtra",
    "pincode": "401201",
    "phone": "7021676339",
    "email": "sunrising.enterprises@gmail.com"
  },
  {
    "id": 570,
    "name": "MobiFix (VISASP3743)",
    "sc_name": "MobiFix",
    "sc_code": "VISASP3743",
    "address": "88A,Star Studio Building,East Of Tower,Nagercoil-629001",
    "city": "Nagercoil",
    "state": "Tamil Nadu",
    "pincode": "629001",
    "phone": "8122042240",
    "email": "mobifixasc@gmail.com"
  },
  {
    "id": 571,
    "name": "VIJAY COMMUNICATION (VIS01321)",
    "sc_name": "VIJAY COMMUNICATION",
    "sc_code": "VIS01321",
    "address": "BEHIND OFF ANDHRA BANK GALI NO.2 NEW KOHINOOR CINEMA MASURIYA JODHPUR-342001",
    "city": "Jodhpur",
    "state": "Rajasthan",
    "pincode": "342001",
    "phone": "7568705605",
    "email": "vijay.communications2014@gmail.com"
  },
  {
    "id": 572,
    "name": "M/s Shri Prakash Telecom (VISASP3791)",
    "sc_name": "M/s Shri Prakash Telecom",
    "sc_code": "VISASP3791",
    "address": "104, Ashok Nagar, Etawah, UP-206001",
    "city": "Etawah",
    "state": "Uttar Pradesh",
    "pincode": "206001",
    "phone": "8881088800",
    "email": "balaji.gpschaudhry@gmail.com"
  },
  {
    "id": 573,
    "name": "Cell Point (VISASP3821)",
    "sc_name": "Cell Point",
    "sc_code": "VISASP3821",
    "address": "Shop No 4, Raghu Mansion, Opp Sankar Vilas, 4/1, Brodipet, Guntur-522002",
    "city": "Guntur",
    "state": "Andhra Pradesh",
    "pincode": "522002",
    "phone": "9885118753",
    "email": "cellpoint.guntur@gmail.com"
  },
  {
    "id": 574,
    "name": "EXCELLENT SERVICES (VISASP3870)",
    "sc_name": "EXCELLENT SERVICES",
    "sc_code": "VISASP3870",
    "address": "Sy No 86/2K, Sanklap H Appartment, Karanje Peth 1, Karanje Turf Satara, Satara, Maharashtra 415001",
    "city": "Satara",
    "state": "Maharashtra",
    "pincode": "415001",
    "phone": "9764887732",
    "email": "excellentservicelava44@gmail.com"
  },
  {
    "id": 575,
    "name": "VIMAL ELECTRONIC",
    "sc_name": "VIMAL ELECTRONIC",
    "sc_code": "",
    "address": "MR VIMAL ELECTRONIC Front Of Agrawal Typing, Bluechip Building Near Gangaur Sweets Palace Road,Raigarh 496001,",
    "city": "Raigarh",
    "state": "Chhattisgarh",
    "pincode": "496001",
    "phone": "9977886005",
    "email": ""
  },
  {
    "id": 576,
    "name": "S R Quick Solutions",
    "sc_name": "S R Quick Solutions",
    "sc_code": "",
    "address": "121, L Block , First Floor , Behind Hanuman Mandir, Ramlila Ground Road,  Sri Ganganagar-335001",
    "city": "Sriganganagar",
    "state": "Rajasthan",
    "pincode": "335001",
    "phone": "8059900099",
    "email": ""
  },
  {
    "id": 577,
    "name": "Saini Computer Care",
    "sc_name": "Saini Computer Care",
    "sc_code": "",
    "address": "1st floor, 1, opp parshu ram chowk, RAILWAY ROAD,KURUKSHETRA, Kurukshetra, Haryana, 136118",
    "city": "Kurukshetra",
    "state": "Haryana",
    "pincode": "136118",
    "phone": "8222820668",
    "email": ""
  },
  {
    "id": 578,
    "name": "Shivam Mobile Service Centre",
    "sc_name": "Shivam Mobile Service Centre",
    "sc_code": "",
    "address": "4/8, municipal market complex, tarakeswar, Hooghly, West Bengal-712410",
    "city": "Tarakeswar",
    "state": "West Bengal",
    "pincode": "712410",
    "phone": "7430942442",
    "email": ""
  },
  {
    "id": 579,
    "name": "Mobi Care",
    "sc_name": "Mobi Care",
    "sc_code": "",
    "address": "55/18, Jeni complex, near aravind eye, hospital, junction, Tirunelveli, Tamil Nadu 627001",
    "city": "Tirunelveli",
    "state": "Tamil Nadu",
    "pincode": "627001",
    "phone": "9629164455",
    "email": ""
  },
  {
    "id": 580,
    "name": "The Mobile World",
    "sc_name": "The Mobile World",
    "sc_code": "",
    "address": "Behind SBI Bank, Jalori Gate Jodhpur,Rajasthan, PIN: 342003",
    "city": "Jodhpur",
    "state": "Rajasthan",
    "pincode": "342003",
    "phone": "9799957876",
    "email": ""
  },
  {
    "id": 581,
    "name": "Meher Telecom",
    "sc_name": "Meher Telecom",
    "sc_code": "",
    "address": "BHATLI CHOWK JAYASING COMPLEX(NEAR KISHORI NURSHING HOME), PIN: 768028",
    "city": "Bargarh",
    "state": "Odisha",
    "pincode": "768028",
    "phone": "8093366626",
    "email": ""
  },
  {
    "id": 582,
    "name": "Shri Mahalasa Communication",
    "sc_name": "Shri Mahalasa Communication",
    "sc_code": "",
    "address": "First Floor,Ward No 21Property No23-1-13-26,Shop No 4 And 5,M G Naik Comlex,Devikere Road,Sirsi,Uttara Kannada,Karnataka,581402",
    "city": "Sirsi",
    "state": "Karnataka",
    "pincode": "581402",
    "phone": "8746035151",
    "email": ""
  },
  {
    "id": 583,
    "name": "Singh Telecom",
    "sc_name": "Singh Telecom",
    "sc_code": "",
    "address": "Kapil Complex Near ICICI Bank in front of Bahadur petrol pump G.T Road Sasaram-821115",
    "city": "Sasaram",
    "state": "Bihar",
    "pincode": "821115",
    "phone": "9709746742",
    "email": ""
  },
  {
    "id": 584,
    "name": "MoBilic",
    "sc_name": "MoBilic",
    "sc_code": "",
    "address": "No.7, SLN Building, 2st Floor, Ayyappa Temple Road, Jalahalli Cross, Bengaluru-560057",
    "city": "Bangalore",
    "state": "Karnataka",
    "pincode": "560057",
    "phone": "8660500917",
    "email": ""
  },
  {
    "id": 585,
    "name": "PVR Communication",
    "sc_name": "PVR Communication",
    "sc_code": "",
    "address": "PVR Communocation, Shop No. 3, Ram ji Complex, Near Metro Pillar No.-836, Bahaduragrh, HR 124507",
    "city": "Bahadurgarh",
    "state": "Haryana",
    "pincode": "124507",
    "phone": "9873508499",
    "email": ""
  },
  {
    "id": 586,
    "name": "SMARTPHONE.COM",
    "sc_name": "SMARTPHONE.COM",
    "sc_code": "",
    "address": "SMARTPHONE.COM.BADASANKHA,GRAND ROAD KUMBHARPADA . INFRONT OF SWSTIC MANDAP . PURI PIN- 752002",
    "city": "Puri",
    "state": "Odisha",
    "pincode": "752002",
    "phone": "7853884635",
    "email": ""
  },
  {
    "id": 587,
    "name": "Strength Services Pvt. Ltd",
    "sc_name": "Strength Services Pvt. Ltd",
    "sc_code": "",
    "address": "Wa 88 Shakarpur Above Icici Bank, PIN: 110092",
    "city": "Laxminagar",
    "state": "Delhi",
    "pincode": "110092",
    "phone": "9650712340",
    "email": ""
  },
  {
    "id": 588,
    "name": "Aayush Infotech",
    "sc_name": "Aayush Infotech",
    "sc_code": "",
    "address": "Ward No-8, Near Sumit Bazar, Main Road, Khariar Road, Dist.Nuapada, Odisha -766104",
    "city": "Nuapada",
    "state": "Odisha",
    "pincode": "766104",
    "phone": "9348044366",
    "email": ""
  },
  {
    "id": 589,
    "name": "Elite Communication",
    "sc_name": "Elite Communication",
    "sc_code": "",
    "address": "No-48, Raman & Raman Shopping Complex, Near Pidaari Kulam, Kumbakonam, Tamil Nadu -.612001",
    "city": "Kadapa",
    "state": "Andhra Pradesh",
    "pincode": "612001",
    "phone": "8056969279",
    "email": ""
  },
  {
    "id": 590,
    "name": "Gupta Enterprises",
    "sc_name": "Gupta Enterprises",
    "sc_code": "",
    "address": "1st Floor, Gopal Complex, Holy Church, Rewa Road, Near IIFL Gold Loan, Navrang Park Colony, Satna, Madhya\u00a0Pradesh-485001",
    "city": "Satna",
    "state": "Madhya Pradesh",
    "pincode": "485001",
    "phone": "7000108146",
    "email": ""
  },
  {
    "id": 591,
    "name": "LN Mobiles",
    "sc_name": "LN Mobiles",
    "sc_code": "",
    "address": "1st Floor, Ganpat Plaza, Chhoti Bajariya, Near Railway Station, Morena, Madhya Pradesh-476001",
    "city": "Morena",
    "state": "Madhya Pradesh",
    "pincode": "476001",
    "phone": "6264563739",
    "email": ""
  },
  {
    "id": 592,
    "name": "M.S Electronics & Services",
    "sc_name": "M.S Electronics & Services",
    "sc_code": "",
    "address": "1st Floor, Mobile Solution, Near My Phone store, Mathur Colony, Guna, Madhya Pradesh-473001",
    "city": "Guna",
    "state": "Madhya Pradesh",
    "pincode": "473001",
    "phone": "9826333789",
    "email": ""
  },
  {
    "id": 593,
    "name": "Om Shanti Care Center",
    "sc_name": "Om Shanti Care Center",
    "sc_code": "",
    "address": "Pakiza Market, Beside National Motors, Hariganj, Khandwa, Madhya Pradesh-450001",
    "city": "Khandwa",
    "state": "Madhya Pradesh",
    "pincode": "450001",
    "phone": "9977058203",
    "email": ""
  },
  {
    "id": 594,
    "name": "Oneplanet",
    "sc_name": "Oneplanet",
    "sc_code": "",
    "address": "66B, GG Towers, Kumaran Road, Tirupur, Tamil Nadu-641601",
    "city": "Kurnool",
    "state": "Andhra Pradesh",
    "pincode": "641601",
    "phone": "9788598598",
    "email": ""
  },
  {
    "id": 595,
    "name": "Pareek Communication",
    "sc_name": "Pareek Communication",
    "sc_code": "",
    "address": "Ridhi Sidhi Complex, Behind Jai Complex, 3rd Floor, Alwar, Rajasthan-301001",
    "city": "Alwar",
    "state": "Rajasthan",
    "pincode": "301001",
    "phone": "7014885261",
    "email": ""
  },
  {
    "id": 596,
    "name": "Prajakta Electronics",
    "sc_name": "Prajakta Electronics",
    "sc_code": "",
    "address": "Shop No. 7&8, 2nd Floor, Shubhray Tower, Opp. Shalimar Talkies, Datta Chowk, Near Kelkar Hospital, Solapur, Maharashtra-413001",
    "city": "Solapur",
    "state": "Maharashtra",
    "pincode": "413001",
    "phone": "7741846310",
    "email": ""
  },
  {
    "id": 597,
    "name": "Ramraj Telecom",
    "sc_name": "Ramraj Telecom",
    "sc_code": "",
    "address": "Near Canara Bank, New Bus Stand Sehore, Madhya Pradesh-466001",
    "city": "Sehore",
    "state": "Madhya Pradesh",
    "pincode": "466001",
    "phone": "7000886588",
    "email": ""
  },
  {
    "id": 598,
    "name": "Smile Solutions",
    "sc_name": "Smile Solutions",
    "sc_code": "",
    "address": "Shop No. 373/338, 1st Floor, T.I. Cycles Road, Ambattur, Chennai, Tamil Nadu-600053",
    "city": "Anantapur",
    "state": "Andhra Pradesh",
    "pincode": "600053",
    "phone": "9884411900",
    "email": ""
  },
  {
    "id": 599,
    "name": "Sri Care",
    "sc_name": "Sri Care",
    "sc_code": "",
    "address": "18/1,M.K.Complex, 2nd Nachiappa Street, Erode, Tamil Nadu- 638001",
    "city": "Erode",
    "state": "Andhra Pradesh",
    "pincode": "638001",
    "phone": "9976434488",
    "email": ""
  },
  {
    "id": 600,
    "name": "Tech DPI",
    "sc_name": "Tech DPI",
    "sc_code": "",
    "address": "No 41/1, 1st Floor, Thanga Mayil Jewellery, Opp. Bagalur Road, Hosur, Tamil Nadu-635109",
    "city": "Hosur",
    "state": "Tamil Nadu",
    "pincode": "635109",
    "phone": "9566756714",
    "email": ""
  },
  {
    "id": 601,
    "name": "Teleworld",
    "sc_name": "Teleworld",
    "sc_code": "",
    "address": "1st Floor, 78 B Block, Thapar Colony, Yamuna Nagar, Haryana-135001",
    "city": "Yamunanagar",
    "state": "Haryana",
    "pincode": "135001",
    "phone": "8816839786",
    "email": ""
  },
  {
    "id": 602,
    "name": "VMS - lamington",
    "sc_name": "VMS - lamington",
    "sc_code": "",
    "address": "Office No.2/A, Plot-167/262, 1st Floor, Navyug Nivas, Above Canara Bank, Lamington Road, Opp. Minerva Cinema, Grant Road East, Mumbai, Maharashtra-400007",
    "city": "Mumbai",
    "state": "Maharashtra",
    "pincode": "400007",
    "phone": "7021328927",
    "email": ""
  },
  {
    "id": 603,
    "name": "We Care",
    "sc_name": "We Care",
    "sc_code": "",
    "address": "Shop 112 & 113, Light House Complex, Onmalur Mainroad, 4-Roads, Salem, Tamil Nadu-636009",
    "city": "Salem",
    "state": "Tamil Nadu",
    "pincode": "636009",
    "phone": "9123514823",
    "email": ""
  },
  {
    "id": 604,
    "name": "Xtreme Care",
    "sc_name": "Xtreme Care",
    "sc_code": "",
    "address": "46C, 1st Floor, 8th Street, Tatabad, Coimbatore, Tamil Nadu-641012",
    "city": "Coimbatore",
    "state": "Tamil Nadu",
    "pincode": "641012",
    "phone": "8608273355",
    "email": ""
  },
  {
    "id": 605,
    "name": "Modern Communications",
    "sc_name": "Modern Communications",
    "sc_code": "",
    "address": "Modern Communications Shop No. 4-2-197/E, Pattiwar Complex,Margadarshi Building,Cinema Road,Adilabad-504001Telangana",
    "city": "Other",
    "state": "Telangana",
    "pincode": "504001",
    "phone": "9971563941",
    "email": ""
  },
  {
    "id": 606,
    "name": "Omkar Services",
    "sc_name": "Omkar Services",
    "sc_code": "",
    "address": "Plot no,-140 , 1st Floor , Kakrola Housing Complex , Dwarka , South -West Delhi, PIN: 110078",
    "city": "Dwarika More",
    "state": "Delhi",
    "pincode": "110078",
    "phone": "7838326175",
    "email": ""
  },
  {
    "id": 607,
    "name": "Fone4u",
    "sc_name": "Fone4u",
    "sc_code": "",
    "address": "UCU011, Urvashi Commercial Centre Under B.A.H.D, City Centre, Durgapur - 713216, Dist.- Paschim Burdwan, West Bengal., PIN: 713201",
    "city": "Durgapore",
    "state": "West Bengal",
    "pincode": "713201",
    "phone": "",
    "email": ""
  }
];
